<template>
  <!-- 案件詳細 -->
  <div id="CpapRequestDetailEdit" v-if="data && data.patient">
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">案件情報</span>
        <table>
          <!-- QA415 申込み状況、受付番号の表示位置変更 start-->
          <!-- 案件詳細の場合 -->
          <template v-if="isShowProject">
            <tr>
              <th>申込み状況</th>
              <td>
                <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
                  {{getCpapProgres(data.status)}}
                </span>
              </td>
            </tr>
            <tr v-if="innerUser">
              <th>状態</th>
              <td>
                <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
                  {{getCpapStatus(data.status)}}
                </span>
              </td>
            </tr>
            <tr>
              <th>受付番号</th>
              <td>{{data.receiptNumber}}</td>
            </tr>
          </template>
          <!-- QA415 申込み状況、受付番号の表示位置変更 end-->
          <tr><th>申込日時</th><td colspan="2">{{data.applicationDate}} {{data.applicationTime}}　{{data.applicationUserName}}</td></tr>
          <tr v-if="!isShowProject"><th>受付番号</th><td colspan="2">{{data.receiptNumber}}</td></tr>
          <!-- QA415 担当情報追加　案件詳細のみ表示 -->
          <tr v-if="innerUser && isShowProject">
            <th>担当情報</th>
            <td style="width:80%;">
                <span style="display:inline-block;width:26%;">{{ data.salesOfficeName }}　{{ data.salesStaffName }}</span>
            </td>
          </tr>
          <!-- 見積情報リスト -->
          <tr v-if="data.estimateDetailCode.length==0"><th>見積情報</th></tr>
            <template v-for="(items,detailIndex) in data.estimateDetailCode">
            <tr :key="detailIndex" v-if="innerUser"><th style="width:15%;"><span v-if="detailIndex==0">見積情報</span></th>
              <td style="width:80%;">
                <span style="display:inline-block;width:20%;">{{items.estimateCode}}</span>
                <span style="display:inline-block;width:5%;padding-left:1%;">{{items.quotationDetailsNumber}}</span>
                <span style="display:inline-block;width:15%;padding-left:1%;">{{items.itemCode}}</span>
                <span style="display:inline-block;width:35%;padding-left:1%;">{{items.itemName}}</span>
                <span v-if="items.deliveryPrice" style="display:inline-block;width:15%;padding-left:1%;text-align:right;">￥{{items.deliveryPrice.toLocaleString()}}</span>
                <span v-else style="display:inline-block;width:15%;padding-left:1%;text-align:right;">￥0</span>
              </td>
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && isResume && data.beforeItems && data.beforeItems.length > 0">
        <span style="font-size:20px;">転院前使用品目</span>
        <table>
          <tr>
            <th style="width:20%;">品目コード</th>
            <th style="width:30%;">品目名</th>
            <!-- <th style="width:25%;">見積詳細番号</th> -->
          </tr>
          <template v-for="(beforeItem,beforeItemIndex) in data.beforeItems">
            <tr :key="beforeItemIndex">
              <td>
                <span v-if="beforeItem.itemCode">{{beforeItem.itemCode}}</span>
                <span v-else style="color:red;">指示書未選択</span>
              </td>
              <td>{{beforeItem.itemName}}</td>
              <!-- <td>
                <span v-if="beforeItem.quotationDetailsNumber">{{beforeItem.quotationDetailsNumber}}</span>
                <span v-else style="color:red;">見積未選択</span>
              </td> -->
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && !isUser && directionsItemList && directionsItemList.length > 0" v-bind:key="renderKey">
      <!-- <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && directionsItemList && directionsItemList.length > 0" v-bind:key="renderKey"> -->
          <span style="font-size:20px;">品目情報</span>
          <div v-if="isResume" class="notice">
            ●転院前後で同じシリアルを使用する場合、見積選択後に「継続使用」となります。機器選択は不要です。<br>
            ●転院前後で異なるシリアルを使用する場合、見積選択後に機器選択を行ってください。「選択済」となります。<br>
            &nbsp;&nbsp;転院前に使用していたシリアルは転院先の仮持出に入りますので、転院先にて機器回収を行ってください。</div>
          <div style="text-align:left;">
            <b-button style="margin-left:10px; width:150px; height:27px;" @click="bulkQuotationModalActive=true">一括選択</b-button>
          </div>
        <table>
          <tr>
            <th style="width:30%;">品目</th>
            <!-- <th style="width:30%;">品目名</th> -->
            <th style="width:20%;">見積選択</th>
            <th v-if="data.depositUseFlag" style="width:30%;">預託オーダーID</th>
            <th v-if="isTemp || isResume" style="width:30%;">仮持出ID</th>
            <th v-if="!((data.depositUseFlag)||(isTemp || isResume))" style="width:6%;text-align:center;">出荷指示</th>
            <th v-else-if="(data.depositUseFlag)||(isTemp || isResume)" style="width:6%;text-align:center;">レンタル<br>処理指示</th>
            <th style="width:6%;text-align:center;">回収指示</th>
          </tr>
          <template v-for="(directionsItem,directionsItemIndex) in directionsItemList">
            <tr :key="directionsItemIndex" :class="{'emphasis': directionsItem.shippingInstructionsFlg && isEscrow}">
              <td>
                <span v-if="directionsItem.itemCode">{{directionsItem.itemCode}}</span>
                <span v-else style="color:red;">指示書未選択</span>
                ：{{directionsItem.name}}
              </td>
              <td>
                <span v-if="directionsItem.estimateCode">見積選択済</span>
                <span v-else style="color:red;">見積未選択</span>
                <b-button v-if="directionsItem.estimateCode" class="clearBtn" icon-left="eraser" @click="deleteQuotation(directionsItem.itemCode, directionsItem.name, directionsItemIndex)"></b-button>
                <span v-else style="display: inline-block; width:35px;"></span>
              </td>
              <td v-if="data.depositUseFlag"> <!-- QA301 文言、幅の修正 -->
                <span v-if="!isSerialChanged(directionsItem.itemCode, directionsItem.serial) && directionsItem.quotationDetailsNumber" style="display: inline-block; width:120px;">変更なし</span>
                <span v-else-if="isSerialChanged(directionsItem.itemCode, directionsItem.serial) && directionsItem.depositUseOrderId" style="display: inline-block; width:120px;">選択済</span>
                <span v-else style="color:red;display: inline-block; width:120px;">選択前</span>
                <b-button v-if="directionsItem.quotationDetailsNumber" style="margin-left:5px; width:100px; height:27px;" v-on:click="orderSelectModalOn(directionsItem.depositUseOrderId, directionsItem.itemCode)">選択</b-button>
                <b-button v-if="isSerialChanged(directionsItem.itemCode, directionsItem.serial) && directionsItem.depositUseOrderId" class="clearBtn" icon-left="eraser" @click="deleteDepositUseOrderInfo(directionsItem.depositUseOrderId, directionsItem.itemCode)"></b-button>
                <span v-else style="display: inline-block; width:33px;"></span>
              </td>
              <td v-if="isTemp || isResume">
                <span v-if="directionsItem.quotationDetailsNumber">
                  <span v-if="!isSerialChanged(directionsItem.itemCode, directionsItem.serial)" style="display: inline-block; width:120px;">変更なし</span>
                  <span v-else-if="isSerialChanged(directionsItem.itemCode, directionsItem.serial) && directionsItem.tempDeviceId" style="display: inline-block; width:120px;">選択済</span>
                  <span v-else-if="!directionsItem.tempDeviceId && resumeExchangeCheck(directionsItem.itemCode)" style="display: inline-block; width:120px;">継続使用</span>
                  <span v-else style="display: inline-block; width:120px; color:red;">選択前</span>
                  <b-button style="margin-left:5px; width:100px; height:27px;" v-on:click="tempDeviceModalOn(directionsItem.itemCode, directionsItem.serial)">選択</b-button>
                  <b-button v-if="directionsItem.tempDeviceId" class="clearBtn" icon-left="eraser" @click="deleteTempDeviceInfo(directionsItem.itemCode, directionsItemIndex)"></b-button>
                  <span v-else style="display: inline-block; width:33px;"></span>
                </span>
              </td>
              <td>
                <span style="display:inline-block; text-align:center; width:100%;"><b-checkbox v-model="directionsItem.shippingInstructionsFlg" :disabled="estimateDisabled(directionsItem.itemCode, directionsItem.estimateCode, 'shipping')"></b-checkbox></span>
              </td>
              <td>
                <span style="display:inline-block; text-align:center; width:100%;"><b-checkbox v-model="directionsItem.collectionInstructionsFlg" :disabled="estimateDisabled(directionsItem.itemCode, directionsItem.estimateCode, 'collection')"></b-checkbox></span>

              </td>
            </tr>
          </template>
        </table>
        <div v-if="isEscrow && serialExchangeFlag" style="font-size:20px; color:red;">シリアルが交換されている機器がありますので、見積もり削除の上、<br>レンタル処理指示および回収指示両方をチェックしてください。</div>
        <!-- QA69 20231227 -->
        <span  v-if="!data.depositUseFlag && !isTemp" style="color:red; font-size:14px;">※川越にCPAP本体を発送依頼する場合は、標準の回路は同梱されているため、回路を別途見積連携する必要はありません。<br>（HTなど標準の回路でないものは見積選択が必要です。）</span>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">医療機関情報</span>
        <table>
          <tr><th>指示日<span class="require"/></th><td id="editMark"></td><td><input type="date" v-model="data.instructionDate" class="hospitalInfo" :name="'指示日'" validate="required|date" style="width:150px;"/></td></tr>
          <!-- 預託機使用の場合 -->
          <!-- <template v-if="data.depositUseFlag"> -->
          <!-- 外部ユーザーでは非表示20240329 -->
          <template v-if="data.depositUseFlag && innerUser && isCirculation">
            <tr>
              <th>契約終了日</th>
              <td id="editMark"></td>
              <td>{{ (data.depositContractEndDate).replace(/-/g, "/") }}</td>
            </tr>
            <tr>
            <!-- <tr v-if="innerUser"> -->
              <th>当月請求<span class="require"/></th>
              <td id="editMark"></td>
              <td>
                <select id="billingCurrentMonth" class="hospitalInfo" name="当月請求" validate="required" v-model="data.depositBillingCurrentMonth">
                  <option v-for="billed in this.billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.label }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>契約取消理由<span class="require"/></th>
              <td id="editMark"></td>
              <td>
                <select v-model="data.depositCancelReasonCode" class="hospitalInfo" name="契約取消理由" validate="required">
                  <option v-for="cancelCode in this.cancelCodeMaster" :value="cancelCode.value" :key="cancelCode.value">{{ cancelCode.label }}</option>
                </select>
              </td>
            </tr>
          </template>
          <!-- QA415 組織ID追加 start-->
          <tr v-if="innerUser">
            <th>組織ID</th>
            <td></td>
            <td>{{data.belongsId}}</td>
          </tr>
          <!-- QA415 組織ID追加 end-->
          <tr><th>{{ data.isDealer? "申請元医療機関名" : "医療機関名" }}</th><td id="editMark"></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.medicalInstitutionName}}</td></tr>
          <tr><th>医師名<span class="require"/></th><td id="editMark"><span v-if="changedCheck('doctorName')" class="change"></span></td><td><input type="text" class="hospitalInfo" name="医師名" validate="required" v-model="data.doctorName" maxlength="256" /></td></tr>
          <tr><th>事務担当者名</th><td id="editMark"><span v-if="changedCheck('clerkName')" class="change"></span></td><td><input type="text" v-model="data.clerkName" maxlength="256" /></td></tr>
          <tr v-if="innerUser && comment"><th>コメント</th><td></td><td>{{data.note}}</td></tr>
          <template v-if="data.isDealer">
            <tr><th>医療機関メールアドレス</th><td id="editMark"><span v-if="changedCheck('mailNotification')" class="change"></span></td><td><b-checkbox class="cstmCheckBox" v-model="data.mailNotification">申込み内容を医療機関にメールで通知する。</b-checkbox></td></tr>
            <tr v-if="data.mailNotification"><th></th><td></td><td><input type="text" v-model="data.hospitalMail" maxlength="256" placeholder="例）example@example.com" class="hospitalInfo" name="医療機関メールアドレス" validate="mail|required"></td></tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">患者情報</span>
        <table>
          <tr><th>患者コード<span class="require"/></th>
          <td id="editMark"><span v-if="changedCheck('patientCode')" class="change"></span></td>
            <td>
              <input type="text" style="width:600px;" v-model="data.patientCode" disabled />
              <b-button v-if="innerUser&&data.patientCodeStatus==cpapPatientRegisterStatus.registRequest" style="margin-left:10px; width:150px; height:27px;" @click="patientModalActive=true">患者選択</b-button>
            </td>
          </tr>
          <tr><th>診察券ID（患者ID）<span class="require" /></th><td id="editMark"><span v-if="changedCheck('patientRegistrationCard')" class="change"></span></td><td><input type="text" v-model="data.patient.patientRegistrationCard" maxlength="50" class="patientInfo" :name="'診察券ID（患者ID）'" validate="required" /></td></tr>
          <tr><th>患者名<span class="require" /></th><td id="editMark"><span v-if="changedCheck('patientName')" class="change"></span></td><td><input type="text" style="margin-right: 5px; width: 435px !important;" placeholder="姓" v-model="data.patient.patientFamilyName" class="patientInfo" :name="'患者名(姓)'" validate="required" maxlength="49" :disabled="patientDataDisabled"/><input type="text" style="width: 435px !important;" placeholder="名" v-model="data.patient.patientFirstName" class="patientInfo" :name="'患者名(名)'" validate="required" maxlength="49" :disabled="patientDataDisabled"/></td></tr>
          <tr><th>患者名（カナ）<span class="require" /></th><td id="editMark"><span v-if="changedCheck('patientNameKana')" class="change"></span></td><td><input type="text" style="margin-right: 5px; width: 435px !important;" placeholder="セイ" v-model="data.patient.patientFamilyNameKana" class="patientInfo" :name="'患者名カナ(セイ)'" validate="kana|required" maxlength="49" :disabled="patientDataDisabled"/><input type="text" style="width: 435px !important;" placeholder="メイ" v-model="data.patient.patientFirstNameKana" class="patientInfo" :name="'患者名カナ(メイ)'" validate="kana|required" maxlength="49" :disabled="patientDataDisabled"/></td></tr>
          <tr><th>性別<span class="require" /></th><td id="editMark"><span v-if="changedCheck('gender')" class="change"></span></td><td>
            <div class="block">
              <b-radio size="is-small" v-model="data.patient.gender" native-value="-">-</b-radio>
              <b-radio size="is-small" v-model="data.patient.gender" native-value="男">男</b-radio>
              <b-radio size="is-small" v-model="data.patient.gender" native-value="女">女</b-radio>
            </div></td>
          </tr>
          <tr><th>生年月日<span class="require"/></th><td id="editMark"><span v-if="changedCheck('birthday')" class="change"></span></td><td><input type="date" v-model="data.patient.birthday" :input="inputBirthday(data.patient.birthday)" class="patientInfo" :name="'患者の生年月日'" validate="required|date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;"/><span v-if="data.patient.birthday" style="margin-left:10px;">{{data.patient.japaneseCalendar}}</span></td></tr>
          <tr><th>年齢</th><td id="editMark"></td><td><input type="text" disabled v-model="data.patient.age"/></td></tr>
          <tr>
            <th>郵便番号<span class="require"/></th>
            <td id="editMark"><span v-if="changedCheck('patientPostcode')" class="change"></span></td>
            <td>
              <input
                id="patientZip"
                v-model="data.patient.zip"
                type="text"
                maxlength="7"
                style="width: 270px;"
                class="patientInfo"
                :class="{'border-red': invalidPatientPostcode}"
                :name="'患者の郵便番号'"
                validate="required|numeric|zip"
                :placeholder="postcodePlaceholder"
                :disabled="patientDataDisabled"
                @blur="onZipBlur(data.patient.zip, 'digitErrorPostcode')"
              />
              <b-button v-if="!patientDataDisabled" style="margin-left:10px; width:150px; height:27px;" v-on:click="patientAddressSearch(data.patient.zip)">自動入力</b-button>
              <!--  移行データ バリデーションなし 20240117 -->
              <div v-if= "data.existingFlag" v-show="invalidPatientPostcode" class="text-red"></div>
              <div v-else-if= "!data.existingFlag">
                <div v-show="invalidPatientPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                <div v-show="digitErrorPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
              </div>
            </td>
          </tr>
          <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td id="editMark"><span v-if="changedCheck('patientAddress')" class="change"></span></td><td><input type="text" v-model="data.patient.address" maxlength="256" class="patientInfo" :name="'患者の住所（都道府県、市町村区）'" validate="required" :disabled="patientDataDisabled"/></td></tr>
          <tr><th>住所（それ以降の住所）<span class="require"/></th><td id="editMark"><span v-if="changedCheck('patientHouseNumber')" class="change"></span></td><td><input type="text" v-model="data.patient.address1" maxlength="256" class="patientInfo" :name="'患者の住所（それ以降の住所）'" validate="required" :disabled="patientDataDisabled" ref="patientAddress1"/></td></tr>
          <tr><th>住所（建物名、部屋番号）</th><td id="editMark"><span v-if="changedCheck('patientBuilding')" class="change"></span></td><td><input type="text" v-model="data.patient.address2" maxlength="256" :disabled="patientDataDisabled"/></td></tr>
          <tr>
            <th>連絡先（携帯電話）</th>
            <td id="editMark"><span v-if="changedCheck('patientMobilePhone')" class="change"></span></td>
            <td>
              <input
                type="text"
                v-model="data.patient.mobilePhone"
                maxlength="11"
                id="mobilePhone"
                class="patientInfo"
                :class="{'border-red': invalidPatientMobilePhone}"
                name="連絡先（携帯電話）"
                validate="numeric"
                :placeholder="phonePlaceholder"
                :disabled="patientDataDisabled"
              />
              <!--  移行データ バリデーションなし 20240117 -->
              <div v-if= "data.existingFlag" v-show="invalidPatientMobilePhone" class="text-red"></div>
              <div v-else-if= "!data.existingFlag" v-show="invalidPatientMobilePhone" class="text-red">{{ invalidNumberMessage }}</div>
            </td>
          </tr>
          <tr>
            <th>連絡（自宅・その他）</th>
            <td id="editMark"><span v-if="changedCheck('patientPhoneNumber')" class="change"></span></td>
            <td>
              <input
                type="text"
                v-model="data.patient.phoneNumber"
                maxlength="11"
                id="phoneNumber"
                class="patientInfo"
                :class="{'border-red': invalidPatientPhoneNumber}"
                name="連絡（自宅・その他）"
                validate="numeric"
                :placeholder="phonePlaceholder"
                :disabled="patientDataDisabled"
              />
              <!--  移行データ バリデーションなし 20240117 -->
              <div v-if= "data.existingFlag" v-show="invalidPatientPhoneNumber" class="text-red"></div>
              <div v-else-if= "!data.existingFlag" v-show="invalidPatientPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
            </td>
          </tr>
          <tr v-if="(data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationDepositMachine || data.kind == cpapKindMap.applicationTempRemoval) && !isChangeValue"><th>フォローアップコール<span class="require"/></th><td id="editMark"><span v-if="changedCheck('followUpCall')" class="change"></span></td>
            <td>
              <div>
                <b-radio class="td_radio" name="followUpCall" v-model="data.patient.followUpCall" :native-value="true">する</b-radio>
                <b-radio class="td_radio" name="followUpCall" v-model="data.patient.followUpCall" :native-value="false">しない</b-radio>
              </div>
            </td>
          </tr>
          <tr><th>病名</th>
          <td id="editMark"><span v-if="changedCheck('disease')" class="change"></span></td>
            <td>
              <input type="text" v-model="data.patient.disease" maxlength="256"/>
            </td>
          </tr>
          <tr><th>感染症</th><td id="editMark"><span v-if="changedCheck('infection')" class="change"></span></td><td>
            <select v-model="data.patient.infection">
              <option value=""/>
              <option value="0">無し</option>
              <option value="1">MRSA</option>
              <option value="2">HCV</option>
              <option value="3">HBV</option>
              <option value="4">Wa</option>
              <option value="5">その他</option>
            </select>
          </td></tr>
          <tr><th>感染症名</th><td id="editMark"><span v-if="changedCheck('infectionText')" class="change"></span></td><td><input type="text" v-model="data.patient.infectionName" maxlength="256" class="patientInfo" name="感染症名" :validate="`${data.patient.infectionFlag ? 'required' : ''}`"/></td></tr>
          <tr><th>地域医療連携施設名</th><td id="editMark"><span v-if="changedCheck('communityMedicineName')" class="change"></span></td><td><input type="text" v-model="data.patient.hospitalName" maxlength="256" /></td></tr>
          <tr><th>地域医療連携施設　医師名</th><td id="editMark"><span v-if="changedCheck('communityMedicineDoctorName')" class="change"></span></td><td><input type="text" v-model="data.patient.doctorName" maxlength="105"/></td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">装置情報</span>
        <table>
          <template v-if="(isTemp || isResume)">
            <!-- 仮持出 -->
            <tr><th>機種<span class="require"/></th>
            <td id="editMark"><span v-if="changedCheck('reportFormatType')" class="change"></span></td>
              <td>
                <input disabled style="width:80%;" type="text" :value="getMachineName()" data-vv-as="機種" class="modelInfo" name="機種" validate="required"/>
              </td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
              <td id="editMark"><span v-if="changedCheck('serial')" class="change"></span></td>
              <td>
                <input disabled style="width:80%;" type="text" maxlength="18" v-model="data.serial" data-vv-as="CPAP機器シリアル" class="modelInfo" name="シリアル" validate="required"/>
                <b-button style="margin-left:10px; width:150px; height:27px;" v-on:click="tempDeviceChange(0, true)">選択</b-button>
              </td>
            </tr>
          </template>
          <template v-else>
            <!-- 仮持出以外 -->
            <tr><th>機種<span class="require"/></th>
            <td id="editMark"><span v-if="changedCheck('reportFormatType')" class="change"></span></td>
              <td>
                <select id="model" class="modelInfo" name="機種" validate="required" @change="changeModel" v-model="data.reportFormatType">
                  <option v-for="model in modelList" :value="model.reportFormatType" :key="model.reportFormatType">{{ model.itemName }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;">シリアル<span v-if="isRequiredSerial() || isEscrow" class="require"/></th>
              <td id="editMark"><span v-if="changedCheck('serial')" class="change"></span></td>
              <td>
                <span v-if="isRequiredSerial()">
                  <input type="text" data-vv-as="CPAP機器シリアル" maxlength="18" :disabled="data.status==cpapRequestStatus.request || data.status==cpapRequestStatus.Approving" v-model="data.serial" class="modelInfo" name="シリアル" validate="required"/>
                </span>
                <span v-else>
                  <input type="text" data-vv-as="CPAP機器シリアル" maxlength="18" disabled v-model="data.serial" name="シリアル"/>
                  <!-- :disabled="isChangeValue" -->
                </span>
              </td>
            </tr>
          </template>
          <!--
          <template>
            <tr>
              <th>使用機器</th><td><b-checkbox class="cstmCheckBox" v-model="data.depositUseFlag">預託機を使用する（要預託契約）</b-checkbox></td>
            </tr>
          </template>
          -->
          <!-- 設定変更対応欄不要　20230822 -->
          <!-- 処方変更の場合 --> 
          <!-- <template v-if="isChangeValue || data.kind == cpapKindMap.applicationChange">
            <tr>
              <th>設定変更対応<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('hardwareArea','settingChanger')" class="change"></span></td>
              <td>
                <div class="block">
                  <b-radio v-model="data.settingChanger" :native-value=0>医療機関にて対応済</b-radio>
                  <b-radio v-model="data.settingChanger" :native-value=1>Philipsへ対応依頼</b-radio>
                </div>
              </td>
            </tr>
          </template> -->
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <div style="display: flex;align-items: center;"><span style="flex: 1;text-align: right;"><span v-if="changedCheck('reportFormatType')" class="change"></span></span><span style="font-size:20px;">設定情報</span><span style="flex: 1;"></span></div>
        <table id="prescriptionTable">
          <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===0})">
            <!-- テキスト項目 -->
            <tr v-if="content.type==='char' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="changedPrescriptionCheck(content.displayOrder,content.displayName)" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form2char_'+index)&&!content.disabled}"
                :message="`${errors.has('form2char_'+index)&&!content.disabled ? errors.first('form2char_'+index) : ''}`">
                  <input
                    style="width:500px;"
                    type="text"
                    :name="'form2char_'+index"
                    :data-vv-as="content.displayName"
                    v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`"
                    v-model="content.value"
                    @input="changeSelect(content.displayName,content.value,content.itemName)"
                    :disabled="content.disabled"/>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- セレクトボックス -->
            <tr v-if="content.type=== 'sel' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="changedPrescriptionCheck(content.displayOrder,content.displayName)" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form2sel_'+index)&&!content.disabled}"
                :message="`${errors.has('form2sel_'+index)&&!content.disabled ? errors.first('form2sel_'+index) : ''}`">
                  <select 
                  style="width:500px;"
                  :name="'form2sel_'+index"
                  :data-vv-as="content.displayName"
                  v-model="content.value"
                  v-validate="`${content.required ? 'required':''}`"
                  @change="changeSelect(content.displayName,content.value,content.itemName)"
                  :disabled="content.disabled">
                    <option
                    v-for="tmpValue in content.displayValue"
                    :value="tmpValue.key"
                    :key="tmpValue.key"
                    >{{ tmpValue.value }}</option></select>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- カレンダー -->
            <tr v-if="content.type=== 'calender' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="changedPrescriptionCheck(content.displayOrder,content.displayName)" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form2calender_'+index)}"
                :message="errors.first('form2calender_'+index)">
                  <input style="width:500px;" type="date" :name="'form2calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- ラジオボタン -->
            <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="changedPrescriptionCheck(content.displayOrder,content.displayName)" class="change"></span></td>
              <td>
                <div>
                  <b-radio
                  v-for="tmpValue in content.displayValue"
                  v-model="content.value"
                  :value="tmpValue.value"
                  :key="tmpValue.key"
                  :name="'form2radio_'+index+'_'"
                  :native-value="tmpValue.key"
                  style="text-align:left; margin-Right:10px;"
                  >{{tmpValue.value}}</b-radio>
                </div>
                <!-- :disabled="content.isDisabled=='true'" -->
              </td>
            </tr>
            <tr v-if="content.annotation" :key="index+'α'">
              <td style="white-space:pre-wrap;color:red;" colspan="3">{{content.annotation}}</td>
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">加温加湿器</span>
        <div v-if="data.useMoist" style="font-size:20px; color:red;">※ヒーターチューブ付加温加湿を選択する際は、呼吸回路タイプを15Hに変更してください。<br>（加湿モードでヒーターチューブ付加温加湿を選択できる機器の場合も呼吸回路タイプの変更が必要です。）</div>
        <table>
          <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===1})">
            <!-- テキスト項目 -->
            <tr v-if="content.type==='char' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="moistPrescriptionCheck(content.displayName)" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3char_'+index)}"
                :message="errors.first('form3char_'+index)">
                  <input style="width:500px;" type="text" :name="'form3char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                  <!-- <span v-if="errors.has('char_'+index)" style="color:red;">{{errors.first('char_'+index)}}</span> -->
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- セレクトボックス -->
            <tr v-if="content.type=== 'sel' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="moistPrescriptionCheck(content.displayName)" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3sel_'+index)}"
                :message="errors.first('form3sel_'+index)">
                  <select
                  style="width:500px;"
                  :name="'form3sel_'+index"
                  :data-vv-as="content.displayName"
                  v-model="content.value"
                  v-validate="`${content.required ? 'required':''}`"
                  @change="changeSelect(content.displayName,content.value,content.itemName)"
                  :disabled="content.disabled">
                    <option
                    v-for="tmpValue in content.displayValue"
                    :value="tmpValue.key"
                    :key="tmpValue.key"
                    >{{ tmpValue.value }}</option></select>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- カレンダー -->
            <!-- QA421_加湿器、モデムの設置日の項目を削除する -->
            <!-- <tr v-if="content.type=== 'calender' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moistArea') || singleChangedCheck('moistArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3calender_'+index)}"
                :message="errors.first('form3calender_'+index)">
                  <input style="width:500px;" type="date" :name="'form3calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                </b-field>
              </td>
              <td> -->
                <!-- 説明コメント用 -->
              <!-- </td>
            </tr> -->
            <!-- ラジオボタン -->
            <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="moistPrescriptionCheck(content.displayName)" class="change"></span></td>
              <td>
                <div>
                  <b-radio
                  v-for="tmpValue in content.displayValue"
                  v-model="content.value"
                  :value="tmpValue.value"
                  :key="tmpValue.key"
                  :name="'form3radio1_'+index"
                  :native-value="tmpValue.key"
                  style="text-align:left; margin-Right:10px;"
                  @click.native="inputRadioValue(tmpValue.key,'useMoist')"
                  >{{tmpValue.value}}</b-radio>
                </div>
                <!-- :disabled="content.isDisabled=='true'" -->
              </td>
            </tr>
          </template>
          <tr v-if="data.useMoist">
            <th style="white-space:pre-wrap;">品目コード</th>
            <td id="editMark"><span v-if="moduleMoistCheck('moistArea','moistItemCode')" class="change"></span></td>
            <td>
              <input style="width:500px;" type="text" disabled data-vv-as="加湿器品目コード" maxlength="20" v-model="data.moistItemCode"/>
            </td>
          </tr>
          <tr v-if="data.useMoist">
            <th v-if="isEscrow" style="white-space:pre-wrap;">シリアル<span class="require"/></th>
            <th v-else style="white-space:pre-wrap;">シリアル</th>
            <td id="editMark"><span v-if="moduleMoistCheck('moistArea','moistSerial')" class="change"></span></td>
            <td v-if="isEscrow" >
              <input style="width:500px;" type="text" :disabled="data.status==cpapRequestStatus.request || data.status==cpapRequestStatus.Approving" data-vv-as="加湿器シリアル" maxlength="20" v-model="data.moistSerial" class="moistInfo" name="加湿器シリアル" validate="required"/>
            </td>
            <td v-else>
              <input style="width:500px;" type="text" disabled data-vv-as="加湿器シリアル" maxlength="20" v-model="data.moistSerial"/>
            </td>
          </tr>
          <!-- 仮持出の場合 機器、付属品のシリアル入力/選択する -->
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">通信モジュール</span>
        <div v-if="(simultaneousExchangeCheck() && !saveSimultaneousExchangeCheck()) || simultaneousExchangeCheck2()" style="font-size:20px; color:red;">※本体交換の為、モデムも交換します 交換用のデータを入力して下さい</div>
        <table>
          <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===2})">
            <!-- テキスト項目 -->
            <tr v-if="content.type==='char' && data.useModule && !isHideItem(content.displayName)  && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="modulePrescriptionCheck(content.displayName)" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3_2char_'+index)}"
                :message="errors.first('form3_2char_'+index)">
                  <input style="width:500px;" type="text" :name="'form3_2char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- セレクトボックス -->
            <tr v-if="content.type=== 'sel' && data.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="modulePrescriptionCheck(content.displayName)" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3_2sel_'+index)}"
                :message="errors.first('form3_2sel_'+index)">
                  <select style="width:500px;" :name="'form3_2sel_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`">
                    <option
                    v-for="tmpValue in content.displayValue"
                    :value="tmpValue.key"
                    :key="tmpValue.key"
                    >{{ tmpValue.value }}</option></select>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- カレンダー -->
            <!-- QA421_加湿器、モデムの設置日の項目を削除する -->
            <!-- <tr v-if="content.type=== 'calender' && data.useModule && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || singleChangedCheck('moduleArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType') || modulchangedCheck('moduleArea'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3_2calender_'+index)}"
                :message="errors.first('form3_2calender_'+index)">
                  <input style="width:500px;" type="date" :name="'form3_2calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                </b-field>
              </td>
              <td> -->
                <!-- 説明コメント用 -->
              <!-- </td>
            </tr> -->
            <!-- ラジオボタン -->
            <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="modulePrescriptionCheck(content.displayName)" class="change"></span></td>
            
              <td>
                <div>
                  <b-radio
                  v-for="tmpValue in content.displayValue"
                  v-model="content.value"
                  :value="tmpValue.value"
                  :key="tmpValue.key"
                  :name="'form3_2radio2_'+index"
                  :native-value="tmpValue.key"
                  :disabled="data.reportFormatType==6"
                  style="text-align:left; margin-Right:10px;"
                  @click.native="inputRadioValue(tmpValue.key,'useModule')"
                  >{{tmpValue.value}}</b-radio>
                </div>
                <!-- :disabled="content.isDisabled=='true'" -->
              </td>
            </tr>
          </template>
          <!-- 内部ユーザーのみ表示する20230913 -->
          <template v-if="innerUser || isEscrow">
            <!-- 預託処方変更の場合 -->
            <template v-if="isEscrow && data.useModule">
              <tr v-if="isCirculation">
                <th style="white-space:pre-wrap;">機種<span class="require"/></th>
                <td id="editMark"><span v-if="moduleMoistCheck('moduleArea','moduleItemCode')" class="change"></span></td>
                <td v-if="moduleList">
                  <b-field :type="{'is-danger':errors.has('moduleItemCode')}" :message="errors.first('moduleItemCode')">
                    <select style="width:500px;" name="moduleItemCode" data-vv-as="通信モジュール機種" v-validate="'required'" v-model="data.moduleItemCode" @change="getDirectionsItemList">
                      <option v-for="val in moduleList" :value="val.itemCode" :key="val.itemCode">{{ val.itemName }}</option>
                    </select>
                  </b-field>
                </td>
                <td v-else>
                  <input style="width:500px;" type="text" disabled data-vv-as="通信モジュール品目コード" maxlength="20" v-model="data.moduleItemCode"/>
                </td>
              </tr>
              <tr>
                <th style="white-space:pre-wrap;">シリアル<span v-if="this.data.reportFormatType != 3" class="require"/></th>
                <td id="editMark"><span v-if="moduleMoistCheck('moduleArea','moduleSerial')" class="change"></span></td>
                <td>
                  <input v-if="this.data.reportFormatType != 3" :disabled="data.status==cpapRequestStatus.request || data.status==cpapRequestStatus.Approving" style="width:500px;" type="text" data-vv-as="通信モジュールシリアル" maxlength="20" v-model="data.moduleSerial" class="moduleInfo" name="通信モジュールシリアル" validate="required"/>
                  <input v-else style="width:500px;" type="text" disabled data-vv-as="通信モジュールシリアル" maxlength="20" v-model="data.moduleSerial" name="シリアル"/>
                </td>
              </tr>
              <!-- 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
              <tr>
                <th style="white-space:pre-wrap;">院内在庫選択</th>
                <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('hardwareArea','serial')" class="change"></span></td>
                <td>
                  <select style="width:500px;" id="model" name="モジュール" validate="required" @change="selectionStock($event, data.moduleItemCode, 'module')" v-model="data.moduleItemCode">
                    <option></option>
                    <option v-for="(model,index) in escrowStockList" :value="model.itemCode" :key="index">{{ model.itemName }} : {{ model.serial }}</option>
                  </select>
                </td>
              </tr> -->
            </template>
            <!-- 預託処方変更以外 -->
            <template v-else>
              <tr v-if="data.useModule && (data.moduleItemCode || moduleList) && isCirculation">
                <th style="white-space:pre-wrap;">機種<span class="require"/></th>
                <td id="editMark"><span v-if="moduleMoistCheck('moduleArea','moduleItemCode')" class="change"></span></td>
                <td v-if="moduleList">
                  <b-field :type="{'is-danger':errors.has('moduleItemCode')}" :message="errors.first('moduleItemCode')">
                    <select style="width:500px;" name="moduleItemCode" data-vv-as="通信モジュール機種" v-validate="'required'" v-model="data.moduleItemCode" @change="getDirectionsItemList">
                      <option v-for="val in moduleList" :value="val.itemCode" :key="val.itemCode">{{ val.itemName }}</option>
                    </select>
                  </b-field>
                </td>
                <td v-else>
                  <input style="width:500px;" type="text" disabled data-vv-as="通信モジュール品目コード" maxlength="20" v-model="data.moduleItemCode"/>
                </td>
              </tr>
              <tr v-if="data.useModule">
                <th style="white-space:pre-wrap;">シリアル</th>
                <td id="editMark"><span v-if="moduleMoistCheck('moduleArea','moduleSerial')" class="change"></span></td>
                <td>
                  <input style="width:500px;" type="text" disabled data-vv-as="通信モジュールシリアル" maxlength="20" v-model="data.moduleSerial"/>
                </td>
              </tr>
            </template>
          </template>
          <!-- 仮持出の場合 機器、付属品のシリアル入力/選択する -->
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">マスク</span>
        <table>
          <tr>
            <th style="white-space:pre-wrap;width:250px;">マスク：種類<span class="require"/></th>
            <td id="editMark"><span v-if="changedCheck('maskType')" class="change"></span></td>
            <td>
              <b-field :type="{'is-danger':errors.has('form4.form4_3char_maskType')}" :message="errors.first('form4.form4_3char_maskType')">
                <input disabled style="width:500px;" type="text" name="form4_3char_maskType" data-vv-as="マスク種類" v-validate="`'required'`" v-model="data.maskType"/>
                <b-button type="is-primary" style="margin-left:10px; width:150px; height:27px;" v-on:click="getMaskMaster()">マスク選択</b-button>
              </b-field>
            </td>
            <td>
            </td>
          </tr>
          <tr>
            <th style="white-space:pre-wrap;width:250px;">マスク：クッションサイズ<span class="require"/></th>
            <td id="editMark"><span v-if="changedCheck('cushionSize')" class="change"></span></td>
            <td>
              <b-field :type="{'is-danger':errors.has('form4.form4_3char_cushionSize')}" :message="errors.first('form4.form4_3char_cushionSize')">
                <input disabled style="width:500px;" type="text" name="form4_3char_cushionSize" data-vv-as="クッションサイズ" v-validate="`'required'`" v-model="data.cushionSize"/>
              </b-field>
            </td>
            <td></td>
          </tr>
          <tr>
            <th style="white-space:pre-wrap;width:250px;">マスク：フレームサイズ<span class="require"/></th>
            <td id="editMark"><span v-if="changedCheck('frameSize')" class="change"></span></td>
            <td>
              <b-field :type="{'is-danger':errors.has('form4.form4_3char_frameSize')}" :message="errors.first('form4.form4_3char_frameSize')">
                <input disabled style="width:500px;" type="text" name="form4_3char_frameSize" data-vv-as="フレームサイズ" v-validate="`'required'`" v-model="data.frameSize"/>
              </b-field>
            </td>
            <td></td>
          </tr>
          <tr>
            <th style="white-space:pre-wrap;width:250px;">マスク：固定方法<span class="require"/></th>
            <td id="editMark"><span v-if="changedCheck('fixingMethod')" class="change"></span></td>
            <td>
              <b-field :type="{'is-danger':errors.has('form4.form4_3char_fixingMethod')}" :message="errors.first('form4.form4_3char_fixingMethod')">
                <input disabled style="width:500px;" type="text" name="form4_3char_fixingMethod" data-vv-as="固定方法" v-validate="`'required'`" v-model="data.fixingMethod"/>
              </b-field>
            </td>
            <td></td>
          </tr>
          <tr>
            <th style="white-space:pre-wrap;">ロット番号</th>
            <td id="editMark"><span v-if="changedCheck('lot')" class="change"></span></td>
            <td>
              <input style="width:500px;" type="text" data-vv-as="ロット番号" maxlength="20" v-model="data.lot"/>
            </td>
          </tr>
          <tr v-if="data.maskType=='その他'">
            <th style="white-space:pre-wrap;width:250px;">備考</th>
            <td id="editMark"></td>
            <td>オーダー情報の備考欄を参照してください。</td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="!data.depositUseFlag&&!data.notDirections&&!isResume&&!isChangeValue">
        <span style="font-size:20px;">納品先情報</span>
        <br><span v-if="data.kind == cpapKindMap.applicationChange && innerUser">(直送オーダー/持出オーダーが発生する場合、ご確認ください。)</span>
        <table>
          <tr><th>機器納品先<span class="require"/></th><td>
            <div class="block">
              <b-radio class="td_radio" name="target"  v-model="data.delivaryTarget" native-value="home" @input="changeDelivaryTarget(data.delivaryTarget)">患者宅</b-radio>
              <b-radio class="td_radio" name="target"  v-model="data.delivaryTarget" native-value="hospital" @input="changeDelivaryTarget(data.delivaryTarget)">医療機関</b-radio>
            </div></td>
          </tr>
          <tr><th></th>
            <td style="vertical-align: middle;"><b-checkbox class="cstmCheckBox" value="true" v-model="data.deliveryOther" @input="changeDelivaryTarget(data.delivaryTarget)">お届け先住所を変更する</b-checkbox></td>
            <td><span style="font-size:11px; color:red; text-align: left; display: inline-block;">※チェックをした場合、こちらの住所は得意先コードの住所（患者・医療機関）には反映されません。</br>※支店・営業所の住所は入力しないでください。</span></td>
          </tr>
          <template v-if="data.deliveryOther">
            <tr>
              <th>
                郵便番号<span class="require"/>
              </th>
              <td colspan="2">
                <input
                  id="deliveryPostcode"
                  style="width: 250px;"
                  v-model="data.deliveryPostcode"
                  class="deliveryInfo"
                  :class="{'border-red': invalidPostcode}"
                  name="機器納品先の郵便番号"
                  validate="required|numeric|zip"
                  maxlength="7"
                  :placeholder="postcodePlaceholder"
                  @blur="onZipBlur(data.deliveryPostcode, 'digitErrorDeliveryPostcode')"
                  @paste="onPaste"
                />
                <b-button
                  style="margin-left: 10px; width: 150px; height: 27px;"
                  v-on:click="addressSearch(data.deliveryPostcode)">自動入力
                </b-button>
                <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                <div v-show="digitErrorDeliveryPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
              </td>
            </tr>
            <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td colspan="2"><input type="text" v-model="data.deliveryAddress" class="deliveryInfo" name="機器納品先の住所（都道府県、市町村区）" validate="required" maxlength="280"/></td></tr>
            <tr><th>住所（それ以降の住所）<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryHouseNumber" class="deliveryInfo" name="機器納品先の住所（それ以降の住所）" validate="required" maxlength="256" ref="deliveryHouseNumber"/></td></tr>
            <tr><th>住所（建物名、部屋番号）</th><td colspan="2"><input type="text" v-model="data.deliveryBuilding" maxlength="256"/></td></tr>
            <tr><th>納品先宛名<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryDestination" maxlength="100" class="deliveryInfo" name="機器納品先の宛名" validate="required"/></td></tr>
            <tr>
              <th>
                連絡先（電話番号）<span class="require"/>
              </th>
              <td colspan="2">
                <input
                  type="text"
                  v-model="data.deliveryPhoneNumber"
                  maxlength="11"
                  class="deliveryInfo"
                  :class="{'border-red': invalidPhoneNumber}"
                  name="機器納品先の連絡先（電話番号）"
                  validate="required|numeric"
                  :placeholder="phonePlaceholder"
                />
                <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
              </td>
            </tr>
          </template>
          <template v-else-if="!data.deliveryOther">
            <tr>
              <th>
                郵便番号<span class="require"/>
              </th>
              <td colspan="2">
                <input
                  id="deliveryPostcode"
                  style="width: 250px;"
                  v-model="data.deliveryPostcode"
                  class="deliveryInfo"
                  name="機器納品先の郵便番号"
                  validate="required|numeric|zip"
                  maxlength="7"
                  disabled
                />
              </td>
            </tr>
            <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td colspan="2"><input type="text" v-model="data.deliveryAddress" class="deliveryInfo" name="機器納品先の住所（都道府県、市町村区）" validate="required" maxlength="280" disabled/></td></tr>
            <tr><th>住所（それ以降の住所）<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryHouseNumber" class="deliveryInfo" name="機器納品先の住所（それ以降の住所）" validate="required" maxlength="256" disabled/></td></tr>
            <tr><th>住所（建物名、部屋番号）</th><td colspan="2"><input type="text" v-model="data.deliveryBuilding" maxlength="256" disabled/></td></tr>
            <tr><th>納品先宛名<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryDestination" maxlength="100" class="deliveryInfo" name="機器納品先の宛名" validate="required" disabled/></td></tr>
            <tr>
              <th>
                連絡先（電話番号）<span class="require"/>
              </th>
              <td colspan="2">
                <input
                  type="text"
                  v-model="data.deliveryPhoneNumber"
                  maxlength="11"
                  class="deliveryInfo"
                  name="機器納品先の連絡先（電話番号）"
                  validate="required|numeric"
                  disabled
                />
              </td>
            </tr>
          </template>
          <template v-if="innerUser">
            <tr>
              <th style="vertical-align:top;">納品書コメント1</th>
              <td colspan="2"><textarea v-model="data.deliveryStatementComment1"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">納品書コメント2</th>
              <td colspan="2"><textarea v-model="data.deliveryStatementComment2"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">発送元<span class="require"/></th>
              <td colspan="2">
                <div>
                <select v-model="data.senderType" class="deliveryInfo" name="発送元" validate="required" @input="selectSender" style="width:70%;">
                  <option value=""></option>
                  <option v-for="ship in cpapSenderMaster" :key="ship.code" :value="ship.code">{{ship.name}}</option>
                </select>
                <b-button v-if="innerUser" class="is-primary" style="margin-left:10px;height:30px;" @click="cpapStockModalActive=true">在庫検索</b-button>
                </div>
              </td>
            </tr>
            <template v-if="isSendBranch()">
              <tr>
                <th style="vertical-align:top;">発送方法<span class="require"/></th>
                <td colspan="2">
                  <select v-model="data.shippingMethod" class="deliveryInfo" name="発送方法" validate="required">
                    <option value=""></option>
                    <option v-for="ship in cpapShippingMethodList" :key="ship.code" :value="ship.code">{{ship.name}}</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>持出元営業所</th>
                <td colspan="2" style="vertical-align:center;">{{officeCode | codeToValueFilter(branchOfficeMaster)}}</td>
              </tr>
              <tr>
                <th>保管場所<span class="require"/></th>
                <td colspan="2">
                  <select id="depositoryCode" class="deliveryInfo" name="保管場所" validate="required" v-model="data.depositoryCode">
                    <option value=""></option>
                    <option v-for="item in depositoryCodeMaster" :key="item.depositoryCode" :value="item.depositoryCode">{{item.depositoryName}}({{item.depositoryCode}})</option>
                  </select>
                  <span style="color:red">※他拠点を選択する場合は、事前に連絡して承諾を得てください。</span>
                </td>
              </tr>
            </template>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && !isEscrow && isSendBranch() ">
        <span style="font-size:20px;">配達情報</span>
        <table>
          <tr style="text-align:top;">
            <th style="vertical-align:top;">出荷日<span class="require"/></th>
            <td><input type="date" class="deliveryInfo" name="出荷日" validate="required" v-model="data.shippingDate" :min="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
          </tr>
        </table>
      </div>
      <!-- 
          <tr><th>配達指定日の有無<span class="require"/></th><td>
            <select v-model="data.isAppointedDelivery" class="2" name="配達指定日の有無" validate="required">
              <option value=""></option>
              <option value="0">配達指定日なし</option>
              <option value="1">配達指定日あり</option>
            </select>
          </td></tr>
          <tr v-if="data.isAppointedDelivery=='1'">
            <th style="vertical-align:top;">配達指定日<span class="require"/></th>
            <td><input type="date" class="2" name="配達指定日" validate="required" v-model="data.appointedDeliveryDate"/></td>
          </tr>
          <tr v-if="data.isAppointedDelivery=='1'">
            <th style="vertical-align:top;">配達時間帯<span class="require"/></th>
            <td>
              <select id="appointedDeliveryPeriodOfTime" name="配達時間帯" class="2" validate="required" v-model="data.appointedDeliveryPeriodOfTime">
                <option v-for="time in deliveryTimeZone" :value="time.value" :key="time.value">{{ time.text }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th style="vertical-align:top;">指定納期<span class="require"/></th>
            <td><input type="date" class="2" name="指定納期" validate="required" v-model="data.specifiedDeliveryDate"/></td>
          </tr>
      -->
      <!-- 処方変更(機種変更：返却がある場合) -->
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && isCirculation && (data.machineReturn || isSirialChange() || isReturnCheck())">
        <span style="font-size:20px;">返却情報</span>
        <table>
          <tr>
            <th>返却先<span class="require"/></th>
            <td>
              <div class="block">
                <b-radio class="td_radio" name="返却先" v-model="data.collectionDestination" :native-value="0"><span id="collectionDestination1">支店回収</span></b-radio>
                <b-radio class="td_radio" name="返却先" v-model="data.collectionDestination" :native-value="1"><span id="collectionDestination2">川越回収</span></b-radio>
              </div>
            </td>
          </tr>
          <!-- <tr> -->
          <tr v-if="innerUser">
            <th>契約終了日</th> <!-- QA353 返却情報の契約終了日に画面描画時の日付を表示 -->
            <td>{{ data.contractEndDate.replace(/-/g, "/") }}</td>
          </tr>
          <!-- <tr> -->
          <tr v-if="innerUser">
            <th>当月請求<span class="require"/></th>
            <td>
              <select id="billingCurrentMonth" class="returnInfo" name="当月請求" validate="required" v-model="data.billingCurrentMonth">
                <option v-for="billed in billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.label }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>中止理由<span class="require"/></th>
            <td>
              <select v-model="data.cancelReasonCode" class="returnInfo" name="中止理由" validate="required">
                <option v-for="cancelCode in this.cancelCodeMaster" :value="cancelCode.value" :key="cancelCode.value">{{ cancelCode.label }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th style="vertical-align:top;">中止理由コメント</th>
            <td>
              <textarea maxlength="255" style="resize:vertical;max-width:100%;height:60px;" v-model="data.cancelReasonText"></textarea>
            </td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top">
        <span style="font-size:20px;">オーダー情報</span>
        <table>
          <template v-if="innerUser && isCirculation">
            <tr>
              <th style="vertical-align:top;">請求開始日<span class="require"/></th>
              <td id="editMark"></td>
              <td><input type="date" class="orderInfo" name="請求開始日" validate="required" v-model="data.billingStartDate" :min="data.billingStartMin"/></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">請求書コメント</th>
              <td id="editMark"></td>
              <td><textarea v-model="data.billComment"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">診療科コード<span class="require"/></th>
              <td id="editMark"><span v-if="changedCheck('departmentCode')" class="change"></span></td>
              <td><select id="departmentCode" class="orderInfo" name="診療科コード" validate="required" v-model="data.departmentCode">
                <option v-for="department in this.departmentMaster" :value="department.value" :key="department.value">{{ department.label }}（{{department.value}}）</option>
              </select></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">得意先区分<span class="require"/></th>
              <td id="editMark"><span v-if="changedCheck('customerClass')" class="change"></span></td>
              <td><select id="customerClass" class="orderInfo" name="得意先区分" validate="required" v-model="data.customerClass">
                <option v-for="customer in this.customerCategory" :value="customer.value" :key="customer.value">{{ customer.label }}</option>
              </select></td>
            </tr>
            <!-- <tr v-if="innerUser && resume"> QA504 前回消耗品供給日を削除
              <th style="vertical-align:top;">前回消耗品供給日<span class="require"/></th>
              <td><span></span></td>
              <td><input type="date" class="orderInfo" name="前回消耗品供給日" validate="required" v-model="data.accessoryLastSupplyDate" /></td>
            </tr>             -->
            <tr v-if="!isChangeValue && (data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval)">
              <th style="vertical-align:top;">直送先種別</th>
              <td id="editMark"></td>
              <td><select id="directShippingType" v-model="data.directShippingType">
                <option value=""></option>
                <option v-for="directShipping in cpapDirectShippingList" :value="directShipping.code" :key="directShipping.code">{{ directShipping.name }}</option>
              </select></td>
            </tr>
            <tr v-if="!isChangeValue && (data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval)">
              <th style="vertical-align:top;">リースアップ種別</th>
              <td id="editMark"></td>
              <td><select id="leaseUpType" v-model="data.leaseUpType">
                <option value=""></option>
                <option v-for="leaseUp in cpapLeaseUpList" :value="leaseUp.code" :key="leaseUp.code">{{ leaseUp.name }}</option>
              </select></td>
            </tr>
            <tr v-if="!isChangeValue && (data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval)">
              <th></th>
              <td></td>
              <td>
                <span style="color:red">直送先種別とリースアップ種別は、空欄の場合は患者宅に配送されます。</span>
              </td>
            </tr>
            <!-- webシステムより不要との回答あり
            <tr>
              <th style="vertical-align:top;">戦略施策<span class="require"/></th>
              <select id="strategicMeasures" class="2" name="戦略施策" validate="required" v-model="data.strategicMeasures">
                <option v-for="strategic in strategicMeasures" :value="strategic.value" :key="strategic.value">{{ strategic.text }}</option>
              </select>
            </tr>
            <tr>
              <th style="vertical-align:top;">戦略施策コメント</th>
              <td><textarea v-model="data.strategicMeasuresComment"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">予備<span class="require"/></th>
              <select id="reserve" name="予備" class="2" validate="required" v-model="data.reserve">
                <option v-for="res in reserve" :value="res.value" :key="res.value">{{ res.text }}</option>
              </select>
            </tr>
            <tr>
              <th style="vertical-align:top;">予備コメント</th>
              <td><textarea v-model="data.reserveComment"></textarea></td>
            </tr> -->
          </template>
          <tr>
            <th style="vertical-align:top;">備考</th>
            <td id="editMark"><span v-if="changedCheck('remarks')" class="change"></span></td>
            <td>
              <textarea maxlength="256" style="resize:vertical;max-width:100%;height:120px" v-model="data.memo"></textarea>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <b-modal :active.sync="quotationModalActive" has-modal-card full-screen>
      <quotationSelectModal :hospital="data.medicalInstitutionCode" :selectItemModel="data.model" title="見積選択" labelForOrg="品目名称" topMsg="既に見積選択済みの場合は、情報が上書きされますのでご注意ください。" :belongs="data.belongsId" :institutionId="data.institutionId" @select="setQuotation" :showDetailTargetData="data" :directionsItems="directionsItemList" :resume="isResume"></quotationSelectModal>
    </b-modal>
    <!-- 見積一括選択 -->
    <b-modal :active.sync="bulkQuotationModalActive" has-modal-card full-screen>
      <quotationBulkSelectModal :hospital="data.medicalInstitutionCode" :selectItemModel="data.model" title="見積一括選択" labelForOrg="品目名称" topMsg="既に見積選択済みの場合は、情報が上書きされますのでご注意ください。" :belongs="data.belongsId" :institutionId="data.institutionId" @select="setQuotationBulk" :showDetailTargetData="data" :directionsItems="directionsItemList" :resume="isResume"></quotationBulkSelectModal>
    </b-modal>
    <!-- 品目単位の見積選択 -->
    <b-modal :active.sync="itemQuotationModalActive" has-modal-card full-screen>
      <quotationSelectModal :hospital="data.medicalInstitutionCode" :selectItemModel="data.model" title="品目見積選択" labelForOrg="品目名称" :topMsg="'対象品目コード：'+quotationItemCode" :belongs="data.belongsId" :institutionId="data.institutionId" @select="setQuotationItem" :showDetailTargetData="data" :directionsItems="directionsItemList" :resume="isResume"></quotationSelectModal>
    </b-modal>
    <b-modal :active.sync="cpapOrderSelectModalActive" has-modal-card full-screen>
      <cpapOrderSelectModal title="預託機選択" @select="setDepositUseOrder" :id="searchDepositUseOrderId" :item="searchOrderItemCode" :serialNumber="searchOrderSerialNumber" :order="data.orderType" :orderTypeList="this.orderProcessType" :salesOffice="data.branchOffice" :salesperson="data.salesStaffCode" :billingDestination="!data.dealerFollowFlg ? data.billingCode : ''" :hospital="data.medicalInstitutionCode" :model="data.model"></cpapOrderSelectModal>
    </b-modal>
    <b-modal :active.sync="patientModalActive" has-modal-card>
      <patientSelectModal title="患者選択" :selectPatientName="data.patient.patientFamilyName+' '+data.patient.patientFirstName" :selectHospitalName="data.hospitalName" @select="setPatient"></patientSelectModal>
    </b-modal>
    <b-modal :active.sync="maskSelectModalActive" has-modal-card full-screen>
      <cpapMaskSelectModal :formatType="formatType" @select="maskSelect"></cpapMaskSelectModal>
    </b-modal>
    <b-modal :active.sync="cpapStockModalActive" has-modal-card full-screen>
      <cpapStockModal :targetOffice="'J'+officeCode" :belongsId="data.belongsId"></cpapStockModal>
    </b-modal>
    <b-modal :active.sync="tempDeviceSelectModalActive" has-modal-card>
      <!-- <instrumentSelectModal @select="tempDeviceSelect" :selectItemCode="searchItemCode" :searchType="targetType" :selectModel="searchModel" :selectSerial="searchSerial"></instrumentSelectModal> -->
      <instrumentSelectModal @select="tempDeviceSelect" :selectItemCode="searchItemCode" :searchType="targetType" :selectModel="searchModel" :selectSerial="searchSerial" :belongsId="data.belongsId" :isShowDisconItems="(data.kind == cpapKindMap.applicationTempRemoval && !isChangeValue)" :estimateDetailCode="initEstimateDetailCode"></instrumentSelectModal>
    </b-modal>
    <!-- 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より） -->
    <b-modal :active.sync="escrowDeviceSelectModalActive" has-modal-card>
      <EscrowInstrumentSelectModal @select="tempDeviceSelect" :selectItemCode="searchItemCode" :searchType="targetType" :selectModel="searchModel" :selectSerial="searchSerial"></EscrowInstrumentSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {
  cpapPatientRegisterStatus,
  cpapShippingMethodList,
  cpapSenderMaster,
  cpapKindMap,
  cpapDirectShippingList,
  cpapLeaseUpList,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  cpapRequestStatus,
  prescriptionHardwareList, // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
  cpapChoicesType,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
import QuotationSelectModal from "@/components/mock/philips/common/QuotationSelectModal";
import QuotationBulkSelectModal from "@/components/mock/philips/common/QuotationBulkSelectModal";
import CpapOrderSelectModal from "@/components/mock/philips/common/CpapOrderSelectModal";
import PatientSelectModal from "@/components/mock/philips/common/PatientSelectModal";
import CpapMaskSelectModal from "@/components/mock/philips/common/CpapMaskSelectModal";
import CpapStockModal from "@/components/mock/philips/common/CpapStockModal";
import InstrumentSelectModal from "@/components/mock/philips/common/InstrumentSelectModal";
import EscrowInstrumentSelectModal from "@/components/mock/philips/common/EscrowInstrumentSelectModal"; // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）

export default {
  name: "CpapRequestDetailEdit",
  // props: ["data","innerUser","isUser","changeValue","temp","resume","comment","circulation","initialUseMoist","initialUseModule"],
  props:{
    data: {},
    innerUser: {},
    isUser: {},
    changeValue: {},
    temp: {},
    resume: {},
    comment: {},
    circulation: {},
    initialUseMoist: {},
    initialUseModule: {},
    isShowProject:{default:false},
    compareTarget: {},
  },
  // props: ["data","innerUser","changeValue","temp","resume"],
  methods: {
    isHideItem: function(displayName) {
      if(displayName == "登録方法"){
        var patientManagement = this.data.prescriptionItems.find(val => val.displayName == "患者情報管理")
        if(patientManagement && patientManagement.value=='0'){
          return true
        }
      }
      if(displayName == "E-mailアドレス"){
        var mobileApply = this.data.prescriptionItems.find(val => val.displayName == "モバイルアプリ")
        if(mobileApply && mobileApply.value=='0'){
          return true
        }
      }
      return false
    },
    tempDeviceSelect: async function(deviceInfo){
      var machineChange = false
      // 品目情報の選択ボタン押下時
      if(this.tempDeviceSelectFlag){
        // 品目コードと一致しない機器は紐づけしない
        if(this.searchModel != ""){
          if(this.searchModel != deviceInfo.itemCode){
            this.targetType = ""
            this.searchModel = ""
            this.searchItemCode = ""
            this.searchSerial = ""
            return
          } 
        }
        if(this.searchItemCode != ""){
          if(this.searchItemCode != deviceInfo.itemCode){
            this.targetType = ""
            this.searchModel = ""
            this.searchItemCode = ""
            this.searchSerial = ""
            return
          } 
        }
      }
      if(this.targetType==0){
        // CPAP機器
        this.data.tempDeviceId = deviceInfo.id
        this.data.model = deviceInfo.itemCode
        this.data.serial = deviceInfo.serial
        machineChange = true
      }else if(this.targetType==1){
        // 加湿器
        this.data.moistItemCode = deviceInfo.itemCode
        this.data.moistSerial = deviceInfo.serial
      }else if(this.targetType==2){
        // 通信モジュール
        this.data.moduleItemCode = deviceInfo.itemCode
        this.data.moduleSerial = deviceInfo.serial
      }
      // 3：マスク
      // 4：呼吸回路

      this.data.provisionalTakenOutItems = this.data.provisionalTakenOutItems.filter(val => {
        return val.itemCode!=deviceInfo.itemCode
      })
      this.data.provisionalTakenOutItems.push(deviceInfo)
      this.targetType = ""
      this.searchModel = ""
      this.searchItemCode = ""
      this.searchSerial = ""
      if(this.modelChangeFlg){
        var model = this.modelList.find(item => item.itemCodes && item.itemCodes.indexOf(deviceInfo.itemCode) != -1)
        if(model){
          var modelItem = model.items.find(item => item.itemCode == deviceInfo.itemCode)
          this.data.model = modelItem.itemCode
          this.data.reportFormatType = model.reportFormatType
        }
        await this.changeModel()
        this.modelChangeFlg = false
      }
      this.getDirectionsItemList()
    },
    tempDeviceModalOn: function(code, serial) {
      var target = this.cpapAccessories.find(val => val.itemCode == code)
      this.targetType = target.itemType
      this.searchModel =  target.itemType==0 ? code : ""
      this.searchItemCode = target.itemType!=0 ? code : ""
      this.searchSerial = serial
      this.tempDeviceSelectFlag = true
      this.tempDeviceSelectModalActive = true
    },
    tempDeviceChange: function(type, flg){
      this.targetType = type
      this.modelChangeFlg = flg
      this.tempDeviceSelectFlag = false
      this.tempDeviceSelectModalActive = true
    },
    // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
    escrowDeviceChange: function(type, flg){
      this.targetType = type
      this.modelChangeFlg = flg
      this.escrowDeviceSelectModalActive = true
    },
    getMachineName: function() {
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      return model ? model.itemName + "(" + this.data.model + ")" : ""
    },
    selectSender: function() {
      if(!this.data.senderType) return false
      var target = this.cpapSenderMaster.find(val => val.code == this.data.senderType)
      if(!target || target.name.indexOf("川越") != -1){
        this.data.shippingMethod = "1"
      }
    },
    isSendBranch: function() {
      if(!this.data.senderType) return false
      var target = this.cpapSenderMaster.find(val => val.code == this.data.senderType)
      if(target && target.name.indexOf("支店") != -1){
        // 支店発送の場合
        // 出荷日の表示は支店回覧のみ
        if (this.data.status == cpapRequestStatus.completion) {
          return false
        } else {
          return true
        }
      }
      return false
    },
    // シリアル交換チェック
    isSirialChange: function() {
      if(!this.innerUser) return false
      for(var directions of this.directionsItemList ){
        if(directions.shippingInstructionsFlg && directions.collectionInstructionsFlg){
          return true
        }
      }
      return false
    },
    // 支店回覧時、返却物チェック
    isReturnCheck: function() {
      if(!this.innerUser) return false
      for(var directions of this.directionsItemList ){
        if(directions.collectionInstructionsFlg){
          return true
        }
      }
      if(!this.data.machineReturn){
        this.data.collectionDestination = ""
        // this.data.contractEndDate = ""  // QA353 返却情報欄の契約終了日はラベルに変えたため空白にしないようにコメントアウト
        this.data.billingCurrentMonth = ""
        this.data.cancelReasonCode = ""
        this.data.cancelReasonText = ""
      }
      return false
    },
    setQuotation: function(quotationInfo) {
      this.data.estimateCode = quotationInfo.quotationNumber
      this.data.estimateDetailCode = quotationInfo.items
      this.data.moistItemCode = ""
      this.data.moduleItemCode = ""
      // 見積番号に含まれている加湿器/通信モジュールの品目コードをセット
      for(let item of this.data.estimateDetailCode){
        item.estimateCode = quotationInfo.quotationNumber
        var target = this.cpapAccessories.find(val => val.itemCode == item.itemCode)
        if(target){
          switch(target.type){
            case "cpap":
              // 見積詳細でCPAPが選択されている場合
              this.data.model = item.itemCode
              break;
            case "moist":
              // 見積詳細で加湿器が選択されている場合
              this.data.moistItemCode = item.itemCode
              break;
            case "module":
              // 見積詳細で通信モジュールが選択されている場合
              this.data.moduleItemCode = item.itemCode
              break;
          }
        }
      }
      this.getDirectionsItemList();
    },
    setQuotationBulk: function(quotationInfo) {
      // 見積を上書きする前の情報を保持
      var beforeEstimateDeitalCode = JSON.parse(JSON.stringify(this.data.estimateDetailCode || []));

      // 見積情報上書き
      if(this.data.estimateDetailCode && this.data.estimateDetailCode.length > 0){
        for(let target of quotationInfo.items){
          var updateTarget = this.data.estimateDetailCode.find(val => val.itemCode == target.itemCode)
          if(updateTarget){
            updateTarget.itemCode = target.itemCode ? target.itemCode:"",
            updateTarget.itemName = target.itemName ? target.itemName:"",
            updateTarget.quotationDetailsNumber = target.quotationDetailsNumber ? target.quotationDetailsNumber:"",
            updateTarget.quantity = target.quantity ? target.quantity:"",
            updateTarget.unit = target.unit ? target.unit:"",
            updateTarget.deliveryPrice = target.deliveryPrice ? target.deliveryPrice:"",
            updateTarget.unitPrice = target.unitPrice ? target.unitPrice:"",
            updateTarget.quotationPrice = target.quotationPrice ? target.quotationPrice:"",
            updateTarget.comment = target.comment ? target.comment:"",
            updateTarget.latestOrderRegisteredDate = target.latestOrderRegisteredDate ? target.latestOrderRegisteredDate:"",
            updateTarget.estimateCode = target.estimateCode ? target.estimateCode:"",
            updateTarget.billingDestinationCode = target.billingDestinationCode ? target.billingDestinationCode:"",
            updateTarget.hospitalCode = target.hospitalCode ? target.hospitalCode:""
          }else{
            this.data.estimateDetailCode.push(target)
          }
        }
      }else{
        this.data.estimateDetailCode = quotationInfo.items
      }
      this.data.moistItemCode = ""
      this.data.moduleItemCode = ""
      // 見積番号に含まれている加湿器/通信モジュールの品目コードをセット
      for(let item of this.data.estimateDetailCode){
        if(!item.estimateCode) item.estimateCode = quotationInfo.quotationNumber
        var target = this.cpapAccessories.find(val => val.itemCode == item.itemCode)
        if(target){
          switch(target.type){
            case "cpap":
              // 見積詳細でCPAPが選択されている場合
              this.data.model = item.itemCode
              this.data.estimateCode = item.estimateCode
              break;
            case "moist":
              // 見積詳細で加湿器が選択されている場合
              this.data.moistItemCode = item.itemCode
              break;
            case "module":
              // 見積詳細で通信モジュールが選択されている場合
              if(this.data.reportFormatType != 3 && this.data.reportFormatType != 5 && this.data.reportFormatType != 6) {
                // QA200 No4_モデム品目が存在する機種のみ設定する
                this.data.moduleItemCode = item.itemCode
              }
              break;
          }
        }
      }
      this.getDirectionsItemList();

      // QA301追加改修  見積選択前後の情報を比較し、条件に該当した品目は預託オーダーIDもしくは仮持出IDを空にする
      //               条件：見積選択前後で、品目コードが同じかつ（見積番号が異なる、または見積明細が異なる）
      for (var i = 0; i < this.directionsItemList.length; i++) {
        for (var j = 0; j < beforeEstimateDeitalCode.length; j++) {
          if (this.directionsItemList[i].itemCode === beforeEstimateDeitalCode[j].itemCode
            && (this.directionsItemList[i].estimateCode != beforeEstimateDeitalCode[j].estimateCode
            || this.directionsItemList[i].quotationDetailsNumber != beforeEstimateDeitalCode[j].quotationDetailsNumber)
          ) {
            if (this.data.depositUseFlag) {
              // 預託
              this.deleteDepositUseOrderInfo(this.directionsItemList[i].depositUseOrderId, this.directionsItemList[i].itemCode);
            } else if (this.data.notDirections || (this.data.kind === this.cpapKindMap.applicationResume && !this.data.cancelResume)) {
              // 仮持出または転院後再開
              this.deleteTempDeviceInfo(this.directionsItemList[i].itemCode, i);
            }
          }
        }
      }
      // QA164 Go,sbox,prisma使用の場合モデムの品目コード、シリアルをクリアする
      const validReportFormatType = [3, 5, 6]; // Go,sbox,prisma
      if (validReportFormatType.includes(this.data.reportFormatType)) {
        this.data.moduleItemCode = "";
        this.data.moduleSerial = "";
      }
    },
    setDepositUseOrder: function(order) {
      let orderItem = order.items.find(val => val.itemCode==this.searchOrderItemCode)
      if(!orderItem || orderItem.length < 1) return
      var target = this.cpapAccessories.find(val => val.itemCode == this.searchOrderItemCode)
      if(target){
        switch(target.type){
          case "cpap":
            this.data.serial = orderItem ? orderItem.serial : ""
            this.data.depositUseOrderId = order.orderId
            break;
          case "moist":
            this.data.moistSerial = orderItem ? orderItem.serial : ""
            this.data.depositUseMoistId = order.orderId
            break;
          case "module":
            this.data.moduleSerial = orderItem ? orderItem.serial : ""
            this.data.depositUseModuleId = order.orderId
            break;
        }
      }
      order.items = [orderItem]
      if(this.data.depositUseOrderDetail){
        this.data.depositUseOrderDetail = this.data.depositUseOrderDetail.filter(val => val.items[0].itemCode != this.searchOrderItemCode)
      }else{
        this.data.depositUseOrderDetail = []
      }
      this.data.depositUseOrderDetail.push(order)
      this.searchDepositUseOrderId = ""
      this.searchOrderItemCode = ""
      this.searchOrderSerialNumber = ""
      this.getDirectionsItemList()
    },
    setPatient: function(patientInfo) {
      this.data.patientCode = patientInfo.patientCode
    },
    inputBirthday: function(birthday){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.data.patient.age = age < 0 ? 0 : age
        const date = new Date(birthday);
        const options = {era: 'long'};
        this.data.patient.japaneseCalendar = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.data.patient.age = ""
      }
    },
    changeModel: async function() {
      // 処方値の取得
      if(this.wkPrevReportFormatType != 3 && this.wkPrevReportFormatType != 5 && this.wkPrevReportFormatType != 6) {
          // QA200 Go/エスボックス/プリズマライン以外であれば、前回モデムの有無を更新する。
          this.changeBeforeUseModule = this.data.useModule
      }
      this.wkPrevReportFormatType = this.data.reportFormatType
      var moduleDate = this.data.prescriptionItems.find(val => val.category==2 && val.type=="calender")
      this.beforeModuleDate = moduleDate && moduleDate.value ? moduleDate.value : ""

      this.changeBeforeUseMoist = this.data.useMoist
      var moistDate = this.data.prescriptionItems.find(val => val.category==1 && val.type=="calender")
      this.beforeMoistDate = moistDate && moistDate.value ? moistDate.value : ""

      var moistMode = this.data.prescriptionItems.find(val => val.category==1 && val.displayName == "加湿モード")
      this.beforeMoistMode = moistMode && moistMode.value ? moistMode.value : ""
 
      var moistSet = this.data.prescriptionItems.find(val => val.category==1 && val.displayName == "加湿器設定")
      this.beforeMoistSet = moistSet && moistSet.value ? moistSet.value : ""
      
      var moistK = this.data.prescriptionItems.find(val => val.category==1 && val.displayName == "回路温度設定")
      this.beforeMoistK = moistK && moistK.value ? moistK.value : ""

      var moduleM = this.data.prescriptionItems.find(val => val.category==2 && val.displayName == "モバイルアプリ")
      this.beforeModuleM = moduleM && moduleM.value ? moduleM.value : ""

      var moduleP = this.data.prescriptionItems.find(val => val.category==2 && val.displayName == "患者情報管理")
      this.beforeModuleP = moduleP && moduleP.value ? moduleP.value : ""
      
      var moduleT = this.data.prescriptionItems.find(val => val.category==2 && val.displayName == "登録方法")
      this.beforeModuleT = moduleT && moduleT.value ? moduleT.value : ""
      this.changeBeforeUseModuleSerial = this.data.moduleSerial
      this.changeBeforeUseMoistSerial = this.data.moistSerial
      this.changeBeforeUseModuleItemCode = this.data.moduleItemCode
      
      this.data.useMoist = false
      this.data.useModule = false
      if(!this.data.reportFormatType){
        return
      }
      if(this.data.changeBeforeApplicationType != this.cpapKindMap.applicationCancel) {
        if(this.data.changeBeforeReportFormatType == this.data.reportFormatType) {
          // QA200 仮持出のシリアル・処方値復活条件にシリアル追加
          if((!this.isTemp || (this.data.model == this.data.changeBeforeitemCode && this.data.serial == this.data.changeBeforeSerial)) && !this.isResume){
            this.data.serial = this.data.changeBeforeSerial;
            this.data.moduleSerial = this.data.changeBeforeModuleSerial;
            this.data.estimateDetailCode = JSON.parse(JSON.stringify(this.data.changeBeforeEstimateDetailCode))
            this.data.oldItems = [];
          }
          this.data.moistSerial = this.data.changeBeforeMoistSerial;
          this.data.moistItemCode = this.data.changeBeforeMoistItemCode;
        }
        else if(
          ((this.data.changeBeforeReportFormatType == 3 && this.data.reportFormatType != 3) || (this.data.changeBeforeReportFormatType != 3 && this.data.reportFormatType == 3)) ||
          ((this.data.changeBeforeReportFormatType == 5 && this.data.reportFormatType != 5) || (this.data.changeBeforeReportFormatType != 5 && this.data.reportFormatType == 5)) ||
          ((this.data.changeBeforeReportFormatType == 6 && this.data.reportFormatType != 6) || (this.data.changeBeforeReportFormatType != 6 && this.data.reportFormatType == 6))
          ){
          if(!this.isTemp && !this.isResume){
            this.data.serial = "";
          }
          this.data.moistSerial = "";
          this.data.moistItemCode = "";
          this.data.moduleSerial = "";
        }
        else {
          if(!this.isTemp && !this.isResume){
            this.data.serial = "";
          }
          this.data.moistSerial = this.data.changeBeforeMoistSerial;
          this.data.moistItemCode = this.data.changeBeforeMoistItemCode;
          this.data.moduleSerial = "";
        }
      }
      this.data.prescriptionItems = []
      var excuteApi = this.getPrescriptionValueItemsPOST;
      var successCallBack = this.getPrescriptionValueItemsPOSTSuccess;
      var errorCallBack = this.getPrescriptionValueItemsPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPrescriptionValueItemsPOST: function(client) {
      return client.apis.externalCpap.getPrescriptionValueItemsPOST({
        body:{
          formatType:this.data.reportFormatType
        }
      });
    },
    getPrescriptionValueItemsPOSTSuccess: function(result) {
      this.data.prescriptionItems = result.obj
      this.data.useMoist = true
      this.data.useModule = true
      this.moduleList = ""
      this.data.moduleItemCode = ""
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)

      if(model){
        var setItem = this.cpapSetItems.find(val => val.cpapItemCode == model.itemCode)
        if(setItem && setItem.module){
          // QA324 3Gモデム ディスコン
          if (this.data.moduleItemCode === "R100630C") {
            this.moduleList = setItem.module
          } else {
            this.moduleList = setItem.module.filter(val=>{ return val.itemCode === "R100631C"})
          }
          // モデム機種をデフォルトで4Gとする
          if (!this.data.moduleItemCode && this.data.useModule) {
            this.data.moduleItemCode = "R100631C"
          }
        }
        if (model.itemCode == 'RJPG500S16') {
          delete setItem.circuit["12"]
        }
      }

      for(var i=0; i<this.data.prescriptionItems.length; i++){
        var item = this.data.prescriptionItems[i]
        if(item.displayName == "モード" && item.defaultValue){
          this.data.mode = item.defaultValue
          continue
        }

        // 通信モジュール
        if(item.category==2){
          //QA73_仮持出→処方変更時に本体を変更時モデム無しに切り替わる
          if((item.type=="radio" || item.type=="sel") && item.value=="0"){
            item.value = "0"
            this.data.useModule = false
            continue
          //QA73_仮持出→処方変更時に本体を変更時モデム無しに切り替わる
          }else if((item.type=="radio" || item.type=="sel")  && item.value=="1"){
            // 通信モジュールの関連項目の場合(Prisma)
            if(model.reportFormatType==6){
              item.value = "0"
              this.data.useModule = false
              continue

            // 通信モジュールの関連項目の場合(DSgo)
            }else if(model.reportFormatType==3 ){
              if(item.displayName == "モバイルアプリ" && this.changeBeforeUseModule){
                item.value = this.beforeModuleM ? this.beforeModuleM : item.defaultValue
                continue
              }
              if(item.displayName == "患者情報管理" && this.changeBeforeUseModule){
                item.value = this.beforeModuleP
                continue
              }

            // 通信モジュールの関連項目の場合(S-BOX)
            }else if(model.reportFormatType==5){
              if(item.type=="radio" && !this.changeBeforeUseModule){
              // 処方変更前が無しだった場合、引き継ぐ
                item.value = "0"
                this.data.useModule = false
                continue
              }
              if(item.displayName == "患者情報管理" && this.changeBeforeUseModule){
                if(this.beforeModuleP !=0){
                  item.value = ""
                  continue
                }else{
                  item.value = this.beforeModuleP
                  continue
                }
              }
              if(item.displayName == "登録方法" && this.changeBeforeUseModule){
                item.value = this.beforeModuleT
                continue
              }

            // 通信モジュールの関連項目の場合(DSgo以外)
            }else if(model.reportFormatType!=3 && model.reportFormatType!=5 && model.reportFormatType!=6){
              if(item.type=="radio" && !this.changeBeforeUseModule){
              // 処方変更前が無しだった場合、引き継ぐ
                item.value = "0"
                this.data.useModule = false
                continue
              }
              if(item.displayName == "患者情報管理" && this.changeBeforeUseModule){
                item.value = this.beforeModuleP
                continue
              }
              if(item.displayName == "登録方法" && this.changeBeforeUseModule){
                item.value = this.beforeModuleT
                continue
              }
            }
          }
          //QA73_仮持出→処方変更時に本体を変更時モデム無しに切り替わる
          if(item.type=="calender" && this.changeBeforeUseModule && this.beforeModuleDate){
              // 処方変更前が有りだった場合、設置日を引き継ぐ
                item.value = this.beforeModuleDate
                continue
          }
        }
        // 加湿器の関連項目の場合
        if(item.category==1){
          if(item.type=="radio" && !this.changeBeforeUseMoist){
            // 処方変更前が無しだった場合、引き継ぐ
            item.value = "0"
            this.data.useMoist = false
            continue
          } else if(item.type=="radio" && this.changeBeforeUseMoist){
            // 処方変更前がありだった場合、引き継ぐ
            item.value = "1"
            this.data.useMoist = true
            continue
          }
          if(item.type=="calender" && this.changeBeforeUseMoist && this.beforeMoistDate){
            // 処方変更前が有りだった場合、設置日を引き継ぐ
            item.value = this.beforeMoistDate
          }
          if(item.displayName == "加湿モード" && this.changeBeforeUseMoist){
            item.value = this.beforeMoistMode
            continue
          }
          if(item.displayName == "加湿器設定" && this.changeBeforeUseMoist){
            item.value = this.beforeMoistSet
            continue
          }
          // 回路温度設定
          var circuit = this.data.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
          if(circuit){
            if(this.beforeMoistMode=="0" || this.beforeMoistMode=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = this.beforeMoistK ? this.beforeMoistK : circuit.defaultValue  // QA200 回路温度設定を引き継ぐ
              circuit.disabled = false
            }
          }
        }
        this.changeSelect(item.displayName,item.value,item.itemName)
      }

      this.getDirectionsItemList()
      if(model){
        this.controlDirectionsItem(model.itemCode,"cpap")
        var setItem = this.cpapSetItems.find(val => val.cpapItemCode == model.itemCode)
        if(this.data.useMoist && setItem.moistItemCode){
          // 加湿器
          this.controlDirectionsItem(setItem.moistItemCode,"moist")
        }
      }

      // QA200 処理順序変更　処方値が新→旧に巻き戻る（残課題対応）
      if(this.data.changeBeforeReportFormatType && this.changeBeforeUseMoist &&
        ((this.data.changeBeforeReportFormatType == 3 && this.data.reportFormatType != 3) || (this.data.changeBeforeReportFormatType != 3 && this.data.reportFormatType == 3)) ||
        ((this.data.changeBeforeReportFormatType == 5 && this.data.reportFormatType != 5) || (this.data.changeBeforeReportFormatType != 5 && this.data.reportFormatType == 5)) ||
        ((this.data.changeBeforeReportFormatType == 6 && this.data.reportFormatType != 6) || (this.data.changeBeforeReportFormatType != 6 && this.data.reportFormatType == 6))
      ){
        // Go/エスボックス/プリズマラインが絡む機種変更
        var kmode = this.data.prescriptionItems.find(val => val.displayName === "加湿モード")
        if (kmode) {  // QA200 エスボックス、プリズマに加湿モードが存在しないためチェック
          kmode.value = "1"
        }
        var kset = this.data.prescriptionItems.find(val => val.displayName === "加湿器設定")
        kset.value = "3"
      }
      if(this.data.changeBeforeReportFormatType && (this.data.changeBeforeReportFormatType == this.data.reportFormatType)){
        if(this.data.changeBeforeApplicationType != this.cpapKindMap.applicationPhilipsCorrespondence && this.data.changeBeforeApplicationType != this.cpapKindMap.applicationCancel) {
          // 加湿器
          var beforeUseMoist = this.data.changeBeforePrescriptionContent.find(val => val.displayName === "加温加湿器")
          if(beforeUseMoist && beforeUseMoist.value == "0"){
            // 前回の処方で使用されていない
            var defKmode = this.data.changeBeforePrescriptionContent.find(val => val.displayName === "加湿モード")
            if (defKmode) { // QA200 エスボックス、プリズマに加湿モードが存在しないためチェック
              defKmode.value = "1"
            }
            var defKset = this.data.changeBeforePrescriptionContent.find(val => val.displayName === "加湿器設定")
            if (defKset) {
              defKset.value = "3"
            }
            this.data.useMoist = false
          }else{
            this.data.useMoist = true
          }
          // モデム
          var beforeUseModule = this.data.changeBeforePrescriptionContent.find(val => val.displayName === "通信モジュール")
          if(beforeUseModule && beforeUseModule.value == "0"){
            // 前回の処方で使用されていない
            var defKjk = this.data.changeBeforePrescriptionContent.find(val => val.displayName === "患者情報管理")
            if (defKjk) {
              defKjk.value = "1"
            }
            var defReg = this.data.changeBeforePrescriptionContent.find(val => val.displayName === "登録方法")
            if (defReg) {
              defReg.value = "1"
            }
            this.data.useModule = false
          }else{
            this.data.useModule = true
          }
          this.data.prescriptionItems = JSON.parse(JSON.stringify(this.data.changeBeforePrescriptionContent))
          var cMode = this.data.changeBeforePrescriptionContent.find(val => val.displayName === "モード")
          this.data.mode = cMode.value
          if (!this.isTemp || (this.data.model == this.data.changeBeforeitemCode && this.data.serial == this.data.changeBeforeSerial)) {   // QA200 仮持出でノーマル品⇔F品の区別がされていない不具合
            this.data.estimateDetailCode = JSON.parse(JSON.stringify(this.data.changeBeforeEstimateDetailCode))
            this.data.changedItems = this.data.changeBeforeChangedItems
            this.data.machineChangeFlag = false
            this.data.machineReturn = false
            for(let directionsItem of this.directionsItemList){
              directionsItem.shippingInstructionsFlg = false
              directionsItem.collectionInstructionsFlg = false
            }
          }
        }
      }

      // QA335_ドリームステーションのランプ設定の誤りを修正
      // 初期表示にてランプスタート圧を活性化
      var lampStart = this.data.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】")
      if (lampStart) {
        lampStart.disabled = false
      };

      // DS Auto、DS Go、DS BiPAPの場合
      if (this.data.reportFormatType == 1 || this.data.reportFormatType == 3 || this.data.reportFormatType == 4) {
        // QA200 前処方の機種に戻したとき、ディスコン項目が使用中でなければ選択不可にする。
        // 中止再開なら使用中であっても選択不可。
        if(!this.data.cancelResume && this.data.changeBeforeReportFormatType && this.data.changeBeforeReportFormatType == this.data.reportFormatType) {
          // 呼吸回路タイプ12mmを選択不可とする
          var kokty = this.data.prescriptionItems.find(val => val.itemName === "KOKTY")
          if (kokty.value !== "12") {
            kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
            if (this.data.reportFormatType == 3 && !kokty.value) {
              kokty.value = "15"
            }
          } else {
            kokty.displayValue = kokty.displayValue.filter(v => v.key !== "")
          }
          // 患者情報管理 「アンコールエニウェア」と空白を選択不可とする
          var kjk = this.data.prescriptionItems.find(val => val.displayName === "患者情報管理")
          if (kjk.value !== "2") {
            kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
            if (this.data.reportFormatType == 3 && !kjk.value) {
              kjk.value = "1"
            }
          } else {
            kjk.displayValue = kjk.displayValue.filter(v => v.key !== "")
          }
          const order = ["1", "0", "2"]
          kjk.displayValue.sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key))
          // 登録方法 「登録しない」と空白を選択不可とする
          var trh = this.data.prescriptionItems.find(val => val.displayName === "登録方法")
          if (trh.value !== "0") {
            trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
          } else {
            trh.displayValue = trh.displayValue.filter(v => v.key !== "")
          }
        } else {
          if (this.data.reportFormatType == 1 || this.data.reportFormatType == 3 || this.data.reportFormatType == 4) {
            // 呼吸回路タイプ12mmを選択不可とする
            var kokty = this.data.prescriptionItems.find(val => val.itemName === "KOKTY")
            kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
            if (kokty.value == "12" || kokty.value == "") {
              kokty.value = "15"
            }
            // 患者情報管理 「アンコールエニウェア」と空白を選択不可とする
            var kjk = this.data.prescriptionItems.find(val => val.displayName === "患者情報管理")
            kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
            kjk.displayValue.sort((a, b) => Number(b.key) - Number(a.key))
            if (kjk.value == "2" || kjk.value == "") {
              kjk.value = "1"
            }
            // 登録方法 「登録しない」と空白を選択不可とする
            var trh = this.data.prescriptionItems.find(val => val.displayName === "登録方法")
            trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
            if (trh.value == "0" || trh.value == "") {
              trh.value = "1"
            }
          }
        }
      }
      // QA474_処方値関連残
      this.prescriptionItemsCheck(this.data.reportFormatType, this.data.mode, this.data.prescriptionItems)
    },
    getPrescriptionValueItemsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back();
    },
    inputRadioValue: function(result,name){
      switch(name){
        case "useMoist":
          // var moistDate = this.data.prescriptionItems.find(val => val.category==1 && val.type=="calender")
          this.data.useMoist = result=="1"
          if (this.isEscrow) {
            // 預託の場合、有→無に変更した際に品目コードを削除（支店回覧時の回収指示がチェックされないため）
            this.data.moistItemCode = ""
          }
          // QA408_処方変更・再開時、加湿器無⇒有の変更でデフォルト値を表示
          // QA478　新規処方時もデフォルト値を設定する
          if (this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.isChangeValue) {
            // 加湿器追加時（無⇒有）
            if (this.data.useMoist && !this.initialUseMoist) {
              // QA389追加_付属品も処方値のみの変更の場合は「変更なし」と表示
              // QA200観点テスト不具合対応_加湿器の継続使用が可能な本体であれば、加湿器の品目コードとシリアルを復活
              let oldReportFormatType = this.data.comparisonDatas.find(val => val.itemName == "reportFormatType")
              if (oldReportFormatType) {
                let oldMoistType = 0
                if (oldReportFormatType.value == 1 || oldReportFormatType.value == 2 || oldReportFormatType.value == 4) {
                  oldMoistType = 1
                } else if (oldReportFormatType.value == 3) {
                  oldMoistType = 3
                } else if (oldReportFormatType.value == 5) {
                  oldMoistType = 5
                } else if (oldReportFormatType.value == 6) {
                  oldMoistType = 6
                }
                let targetMoistType = 0
                if (this.data.reportFormatType == 1 || this.data.reportFormatType == 2 || this.data.reportFormatType == 4) {
                  targetMoistType = 1
                } else if (this.data.reportFormatType == 3) {
                  targetMoistType = 3
                } else if (this.data.reportFormatType == 5) {
                  targetMoistType = 5
                } else if (this.data.reportFormatType == 6) {
                  targetMoistType = 6
                }
                if (oldMoistType === targetMoistType) {
                  let oldMoistSerial = this.data.comparisonDatas.find(val => val.itemName == "moistSerial")
                  let oldMoistItemCode = this.data.comparisonDatas.find(val => val.itemName == "moistItemCode")
                  this.data.moistSerial = oldMoistSerial ? oldMoistSerial.value : this.data.moistSerial
                  this.data.moistItemCode = oldMoistItemCode ? oldMoistItemCode.value : this.data.moistItemCode
                }
              }
              var moistInfo = this.data.prescriptionItems.filter(val=> val.category==1)
              for (var item of moistInfo) {
                item.value = item.defaultValue ? item.defaultValue : ""
                // 加湿器項目の入力制御反映
                if (item.displayName == "回路温度設定") {
                  var moistMode = this.data.prescriptionItems.find(val => val.displayName == "加湿モード")
                  if (moistMode) {
                    if (moistMode.value=="0" || moistMode.value=="1") {
                      item.value = ""
                      item.disabled = true
                    } else {
                      item.disabled = false
                    }
                  }
                }
              }
            }
          }
          this.getDirectionsItemList()
          break;
        case "useModule":
          this.data.useModule = result=="1"
          // QA408_処方変更・再開時、モデム無⇒有の変更でデフォルト値を表示
          // QA478　新規処方時もデフォルト値を設定する
          if (this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.isChangeValue) {
            // モデム追加時（無⇒有）
            if (this.data.useModule && !this.initialUseModule) {
              // QA389追加_付属品も処方値のみの変更の場合は「変更なし」と表示
              // 本体のシリアルに変更がない場合、モデムのシリアルを復活
              let oldSerial = this.data.comparisonDatas.find(val => val.itemName == "serial")
              if (oldSerial && oldSerial.value === this.data.serial) {
                let oldModuleSerial = this.data.comparisonDatas.find(val => val.itemName == "moduleSerial")
                this.data.moduleSerial = oldModuleSerial ? oldModuleSerial.value : this.data.moduleSerial
              }
              var moduleInfo = this.data.prescriptionItems.filter(val=> val.category==2)
              for (var item of moduleInfo) {
                item.value = item.defaultValue ? item.defaultValue : ""
              }
            }
          }
          // QA324 モデム追加時（無⇒有） デフォルトで4Gモデムを設定する
          if (this.data.useModule && !this.initialUseModule && this.moduleList) {
            this.data.moduleItemCode = "R100631C"
          }
          var moduleDate = this.data.prescriptionItems.find(val => val.category==2 && val.type=="calender")
          if(!moduleDate.value) moduleDate.value = this.yyyy_hyp_MM_hyp_dd(new Date())
          this.getDirectionsItemList()
          break;
      }
    },
    patientAddressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.data.patient.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.data.patient.address1 = "";
        this.data.patient.address2 = "";

        // QA476 住所設定後フォーカスを移動する
        this.focusMove("patientAddress1");
        this.digitErrorPostcode = false;
      })
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.data.deliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.data.deliveryHouseNumber = "";
        this.data.deliveryBuilding = "";

        // QA476 住所設定後フォーカスを移動する
        this.focusMove("deliveryHouseNumber");
        this.digitErrorDeliveryPostcode = false;
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    getMode: function(){
      return this.data.mode
    },
    changeSelect: function(name, value,sapName) {
      var model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType)
      // QA474_処方値関連残　モード選択時にFlexタイプを引き継ぐ
      if(name == "モード"){
        var changeBeforeMode = this.data.mode
        this.data.mode = value
        // "Flexタイプ"
        var changeBeforeFlexType
        var flexType
        // ドリームステーションAuto
        if (model.reportFormatType == 1) {
          // モード変更前のFlexタイプ
          if (changeBeforeMode == 4) { // CPAPモード
            changeBeforeFlexType = this.data.prescriptionItems.find(val => val.displayOrder == 7)
          } else if (changeBeforeMode == 1) { // Auto CPAPモード
            changeBeforeFlexType = this.data.prescriptionItems.find(val => val.displayOrder == 8)
          }
          // モード変更後のFlexタイプ
          if (this.data.mode == 4) { // CPAPモード
            flexType = this.data.prescriptionItems.find(val => val.displayOrder == 7)
          } else if (this.data.mode == 1) { // Auto CPAPモード
            flexType = this.data.prescriptionItems.find(val => val.displayOrder == 8)
          }
        // ドリームステーションGo
        } else if (model.reportFormatType == 3) {
          //  モード変更前のFlexタイプ
          if (changeBeforeMode == 4) { // CPAPモード
            changeBeforeFlexType = this.data.prescriptionItems.find(val => val.displayOrder == 7)
          } else if (changeBeforeMode == 1) { // Auto CPAPモード
            changeBeforeFlexType = this.data.prescriptionItems.find(val => val.displayOrder == 8)
          }
          // モード変更後のFlexタイプ
          if (this.data.mode == 4) { // CPAPモード
            flexType = this.data.prescriptionItems.find(val => val.displayOrder == 7)
          } else if (this.data.mode == 1) { // Auto CPAPモード
            flexType = this.data.prescriptionItems.find(val => val.displayOrder == 8)
          }
        // ドリームステーションBiPAP Auto
        } else if (model.reportFormatType == 4) {
          // モード変更前のFlexタイプ
          if (changeBeforeMode == 4) { // CPAPモード
            changeBeforeFlexType = this.data.prescriptionItems.find(val => val.displayOrder == 10)
          } else if (changeBeforeMode == 8) { // Bi-Levelモード
            changeBeforeFlexType = this.data.prescriptionItems.find(val => val.displayOrder == 11)
          } else if (changeBeforeMode == 1) { // Auto Bi-Levelモード
            changeBeforeFlexType = this.data.prescriptionItems.find(val => val.displayOrder == 12)
          }
          // モード変更後のFlexタイプ
          if (this.data.mode == 4) { // CPAPモード
            flexType = this.data.prescriptionItems.find(val => val.displayOrder == 10)
          } else if (this.data.mode == 8) { // Bi-Levelモード
            flexType = this.data.prescriptionItems.find(val => val.displayOrder == 11)
          } else if (this.data.mode == 1) { // Auto Bi-Levelモード
            flexType = this.data.prescriptionItems.find(val => val.displayOrder == 12)
          }
        }
        // モード変更前のFlexタイプが変更後のモードのFlexタイプの選択肢にあったら引き継ぐ
        var changeBeforeDisplayValue = changeBeforeFlexType.displayValue.filter(val => val.key == changeBeforeFlexType.value)
        if (changeBeforeDisplayValue && changeBeforeDisplayValue.length > 0) {
          var targetDisplayValue = flexType.displayValue.filter(val => val.value === changeBeforeDisplayValue[0].value)
          if (targetDisplayValue && targetDisplayValue.length > 0) {
            flexType.value = targetDisplayValue[0].key
          }
        }
        // QA474追加_Bipapの活性非活性制御
        if (model.reportFormatType == 4) {
          // "Flex設定ロック"
          var flexLock = this.data.prescriptionItems.find(val => val.displayOrder == 14)
          // CPAPモードのときはFlex設定ロックを活性にする
          if (this.data.mode == 4) {
            flexLock.disabled = false
          // Bi-Levelモード・Auto Bi-LevelモードのときFlex設定ロックを非活性にする
          } else if (this.data.mode == 8 || this.data.mode == 1) {
            if (flexType.value == "0") {
              flexLock.disabled = true
              flexLock.value = ""
            }
            // "ライズタイム"
            var riseTime = this.data.prescriptionItems.find(val => val.displayOrder == 15)
            // "ライズタイムロック"
            var riseTimeLock = this.data.prescriptionItems.find(val => val.displayOrder == 16)
            if (flexType.value == "0") {
              riseTime.disabled = false
              riseTimeLock.disabled = false
              // riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
            } else {
              riseTime.disabled = true
              riseTimeLock.disabled = true
              riseTime.value = ""
              riseTimeLock.value = ""
              // riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
            }
            // QA474 仕様変更 20260410
            riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
          }
        }
        return
      }
      switch(model.reportFormatType){
        case 1:
          // ドリームステーションAuto
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayOrder == 9)
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              if (!flex.value) {
                flex.value = flex.defaultValue
              }
              flex.disabled = false
            }
            return
          }
          // Flexタイプ：0、Flex設定：値ありの場合
          // Flex設定「空白」を選択時、Flex設定を非活性とする
          if (name == "Flex設定") {
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayOrder == 9)
            // Flexタイプ
            var flexType
            if (this.data.mode == 1) { // Auto CPAPモード
              flexType = this.data.prescriptionItems.find(val => val.displayOrder == 8)
            } else if (this.data.mode == 4) { // CPAPモード
              flexType = this.data.prescriptionItems.find(val => val.displayOrder == 7)
            }
            if (value == "" && flexType.value == "0") {
              flex.disabled = true
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 28)
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              if (!circuit.value) {
                circuit.value = circuit.defaultValue
              }
              circuit.disabled = false
            }
            return
          }
          if (name == "回路温度設定") {
            // 加湿モード
            var moistMode = this.data.prescriptionItems.find(val => val.displayOrder == 26)
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 28)
            if (value == "" && (moistMode.value == "0" || moistMode.value == "1")) {
              circuit.disabled = true
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayOrder == 32)
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          // QA335_ドリームステーションのランプ設定の誤りを修正
          // ランプ時間とランプスタート圧の相関関係を削除
          // if(name == "ランプ時間【分】"){
          //   // ランプスタート圧【hPa(cmH2O)】
          //   var lampStart = this.data.prescriptionItems.find(val => val.displayOrder == 13)
          //   if(value=="0"){
          //     lampStart.value = "4"
          //     lampStart.disabled = true
          //   }else{
          //     lampStart.disabled = false
          //   }
          //   return
          // }
          break;
        case 2:
          // ドリームステーションPro
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayOrder == 5)
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              if (!flex.value) {
                flex.value = flex.defaultValue
              }
              flex.disabled = false
            }
            return
          }
          // Flexタイプ：0、Flex設定：値ありの場合
          // Flex設定「空白」を選択時、Flex設定を非活性とする
          if (name == "Flex設定") {
            // Flexタイプ
            var flexType = this.data.prescriptionItems.find(val => val.displayOrder == 4)
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayOrder == 5)
            if (value == "" && flexType.value == "0") {
              flex.disabled = true
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 24)
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              if (!circuit.value) {
                circuit.value = circuit.defaultValue
              }
              circuit.disabled = false
            }
            return
          }
          if (name == "回路温度設定") {
            // 加湿モード
            var moistMode = this.data.prescriptionItems.find(val => val.displayOrder == 22)
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 24)
            if (value == "" && (moistMode.value == "0" || moistMode.value == "1")) {
              circuit.disabled = true
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayOrder == 28)
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          // QA335_ドリームステーションのランプ設定の誤りを修正
          // ランプ時間とランプスタート圧の相関関係を削除
          // if(name == "ランプ時間【分】"){
          //   // ランプスタート圧【hPa(cmH2O)】
          //   var lampStart = this.data.prescriptionItems.find(val => val.displayOrder == 9)
          //   if(value=="0"){
          //     lampStart.value = "4"
          //     lampStart.disabled = true
          //   }else{
          //     lampStart.disabled = false
          //   }
          //   return
          // }
          break;
        case 3:
          // ドリームステーションGo
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayOrder == 9)
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              if (!flex.value) {
                flex.value = flex.defaultValue
              }
              flex.disabled = false
            }
            return
          }
          // Flexタイプ：0、Flex設定：値ありの場合
          // Flex設定「空白」を選択時、Flex設定を非活性とする
          if (name == "Flex設定") {
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayOrder == 9)
            // Flexタイプ
            var flexType
            if (this.data.mode == 1) { // Auto CPAPモード
              flexType = this.data.prescriptionItems.find(val => val.displayOrder == 8)
            } else if (this.data.mode == 4) { // CPAPモード
              flexType = this.data.prescriptionItems.find(val => val.displayOrder == 7)
            }
            if (value == "" && flexType.value == "0") {
              flex.disabled = true
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayOrder == 27)
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          // QA335_ドリームステーションのランプ設定の誤りを修正
          // ランプ時間とランプスタート圧の相関関係を削除
          // if(name == "ランプ時間【分】"){
          //   // ランプスタート圧【hPa(cmH2O)】
          //   var lampStart = this.data.prescriptionItems.find(val => val.displayOrder == 12)
          //   if(value=="0"){
          //     lampStart.value = "4"
          //     lampStart.disabled = true
          //   }else{
          //     lampStart.disabled = false
          //   }
          //   return
          // }
          break;
        case 4:
          // ドリームステーションBiPAP Auto
          // QA474_処方値関連残
          // Bipap（Auto Bi-Levelモード）IPAP＝EPAPのときPS最大圧、PS最小圧は0－0で非活性とする。
          var ipap = this.data.prescriptionItems.find(val => val.displayOrder == 5)
          var epap = this.data.prescriptionItems.find(val => val.displayOrder == 6)
          var pressureMax = this.data.prescriptionItems.find(val => val.displayOrder == 7)
          var pressureMin = this.data.prescriptionItems.find(val => val.displayOrder == 8)
          if (this.data.mode == 1) {
            if (name == "IPAP最大圧【hPa(cmH2O)】" || name == "EPAP最小圧【hPa(cmH2O)】") {
              if (ipap.value && epap.value && Number(ipap.value) == Number(epap.value)) {
                pressureMax.value = "0.0"
                pressureMin.value = "0.0"
                pressureMax.disabled = true
                pressureMin.disabled = true
              } else {
                pressureMax.disabled = false
                pressureMin.disabled = false
              }
              return
            }
            if (name == "PS最大圧【hPa(cmH2O)】" || name == "PS最小圧【hPa(cmH2O)】") {
              if (ipap.value && epap.value && pressureMax.value && pressureMin.value && Number(ipap.value) == Number(epap.value) && Number(pressureMax.value) == 0 && Number(pressureMin.value) == 0) {
                pressureMax.disabled = true
                pressureMin.disabled = true
              } else {
                pressureMax.disabled = false
                pressureMin.disabled = false
              }
              return
            }
          }
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayOrder == 13)
            // "Flex設定ロック"
            var flexLock = this.data.prescriptionItems.find(val => val.displayOrder == 14)
            // "ライズタイム"
            var riseTime = this.data.prescriptionItems.find(val => val.displayOrder == 15)
            // "ライズタイムロック"
            var riseTimeLock = this.data.prescriptionItems.find(val => val.displayOrder == 16)
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
              if (!riseTime.value) {
                riseTime.value = riseTime.defaultValue
              }
              if (!riseTimeLock.value) {
                riseTimeLock.value = riseTimeLock.defaultValue
              }
              riseTime.disabled = false
              riseTimeLock.disabled = false
              // QA474_処方値関連残
              // Bipap（Bi-Levelモード、Auto Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
              if (this.data.mode == 1 || this.data.mode == 8) {
                flexLock.value = ""
                flexLock.disabled = true
                // QA474_処方値関連残
                // Bipap（Bi-Levelモード、Auto Bi-Levelモード）Flexタイプオフのときは、ライズタイムの選択肢を「1～3」とする
                // riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
                // QA474 仕様変更 20260410
                riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
              }
            }else{
              if (!flex.value) {
                flex.value = flex.defaultValue
              }
              if (!flexLock.value) {
                flexLock.value = flexLock.defaultValue
              }
              flex.disabled = false
              riseTime.value = ""
              riseTimeLock.value = ""
              riseTime.disabled = true
              riseTimeLock.disabled = true
              flexLock.disabled = false
              // QA474_処方値関連残
              // Bipap（Bi-Levelモード、Auto Bi-Levelモード）Flexタイプオフのときは、ライズタイムの選択肢を「1～3」とする
              riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
            }
            return
          }
          if (name == "Flex設定" || name == "Flex設定ロック" || name == "ライズタイム" || name == "ライズタイムロック") {
            // Flexタイプ
            var flexType
            if (this.data.mode == 1) { // Auto Bi-Levelモード
              flexType = this.data.prescriptionItems.find(val => val.displayOrder == 12)
            } else if (this.data.mode == 4) { // CPAPモード
              flexType = this.data.prescriptionItems.find(val => val.displayOrder == 10)
            } else if (this.data.mode == 8) { // Bi-Levelモード
              flexType = this.data.prescriptionItems.find(val => val.displayOrder == 11)
            }
            if (name == "Flex設定") {
              // "Flex設定"
              var flex = this.data.prescriptionItems.find(val => val.displayOrder == 13)
              // Flexタイプ：0、Flex設定：値ありの場合
              // Flex設定「空白」を選択時、Flex設定を非活性とする
              if (value == "" && flexType.value == "0") {
                flex.disabled = true
              }
              return
            }
            if (name == "Flex設定ロック") {
              if (this.data.mode == 1 || this.data.mode == 8) {
                // "Flex設定"
                var flexLock = this.data.prescriptionItems.find(val => val.displayOrder == 14)
                // Flexタイプ：0、Flex設定：値ありの場合
                // Flex設定「空白」を選択時、Flex設定を非活性とする
                if (value == "" && flexType.value == "0") {
                  flexLock.disabled = true
                }
              }
              return
            }
            if (name == "ライズタイム") {
              // "ライズタイム"
              var riseTime = this.data.prescriptionItems.find(val => val.displayOrder == 15)
              // Flexタイプ：1or2or3、ライズタイム：値ありの場合
              // ライズタイム「空白」を選択時、ライズタイムを非活性とする
              if (value == "" && (flexType.value == "1" || flexType.value == "2" || flexType.value == "3")) {
                riseTime.disabled = true
              }
              return
            }
            if (name == "ライズタイムロック") {
              // "ライズタイムロック"
              var riseTimeLock = this.data.prescriptionItems.find(val => val.displayOrder == 16)
              // Flexタイプ：1or2or3、ライズタイムロック：値ありの場合
              // ライズタイムロック「空白」を選択時、ライズタイムロックを非活性とする
              if (value == "" && (flexType.value == "1" || flexType.value == "2" || flexType.value == "3")) {
                riseTimeLock.disabled = true
              }
              return
            }
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 34)
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              if (!circuit.value) {
                circuit.value = circuit.defaultValue
              }
              circuit.disabled = false
            }
            return
          }
          if (name == "回路温度設定") {
            // 加湿モード
            var moistMode = this.data.prescriptionItems.find(val => val.displayOrder == 32)
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 34)
            if (value == "" && (moistMode.value == "0" || moistMode.value == "1")) {
              circuit.disabled = true
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayOrder == 38)
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          // QA335_ドリームステーションのランプ設定の誤りを修正
          // ランプ時間とランプスタート圧の相関関係を削除
          // if(name == "ランプ時間【分】"){
          //   // ランプスタート圧【hPa(cmH2O)】
          //   var lampStart = this.data.prescriptionItems.find(val => val.displayOrder == 19)
          //   if(value=="0"){
          //     lampStart.value = "4"
          //     lampStart.disabled = true
          //   }else{
          //     lampStart.disabled = false
          //   }
          //   return
          // }
          break;
        case 5:
          // エスボックス バイスタルク
          if(name == "CC+"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.data.prescriptionItems.find(val => val.displayOrder == 7)
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.data.prescriptionItems.find(val => val.displayOrder == 8)
            if(value=="0"){
              ccAll.value = ""
              ccLamp.value = ""
              ccAll.disabled = true
              ccLamp.disabled = true
            }else{
              if (value == "1" && ccAll.value && ccLamp.value) {
                // 移行データの処置
                // CC+：1にした際、CC+機能有効時間　全治療時間とCC+機能有効時間　ランプのみどちらも値が登録されている場合は
                // CC+機能有効時間　全治療時間とCC+機能有効時間　ランプのみどちらか選択してもらうため、値の更新は行わない
              } else {
                ccAll.value = ""
                ccAll.disabled = true
                if (!ccLamp.value) {
                  ccLamp.value = ccLamp.defaultValue
                }
                ccLamp.disabled = false
              }
            }
            return
          }
          if (name == "CC+機能有効時間　全治療時間" || name == "CC+機能有効時間　ランプのみ") {
            // "CC+"
            var cc = this.data.prescriptionItems.find(val => val.displayOrder == 6)
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.data.prescriptionItems.find(val => val.displayOrder == 7)
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.data.prescriptionItems.find(val => val.displayOrder == 8)
            if(name == "CC+機能有効時間　全治療時間"){
              if(value!="" && value!=null && value!="null"){
                // "CC+機能有効時間　ランプのみ"　非活性
                ccLamp.value = ""
                ccLamp.disabled = true
              }else{
                if (!ccLamp.value && cc.value == "1") {
                  ccLamp.value = ccLamp.defaultValue
                  ccLamp.disabled = false
                }
                ccAll.disabled = true
              }
              // CC+：OFF（0）、CC+機能有効時間　全治療時間：空白
              // CC+機能有効時間　全治療時間「空白」を選択時、CC+機能有効時間　全治療時間を非活性とする
              if (value == "" && cc.value == "0") {
                ccAll.disabled = true
              }
              // CC+：ON（1）、CC+機能有効時間ランプのみ：値あり、CC+機能有効時間　全治療時間：値あり
              // CC+機能有効時間　全治療時間「空白」を選択時、CC+機能有効時間　全治療時間を非活性とする
              if (value == "" && cc.value == "1" && ccLamp.value != "") {
                ccAll.disabled = true
              }
              return
            }
            if(name == "CC+機能有効時間　ランプのみ"){
              if(value!="" && value!=null && value!="null"){
                ccAll.value = ""
                ccAll.disabled = true
              }else{
                if (!ccAll.value && cc.value == "1") {
                  ccAll.value = ccAll.defaultValue
                  ccAll.disabled = false
                }
                ccLamp.disabled = true
              }
              // CC+：OFF（0）、CC+機能有効時間ランプのみ：空白
              // CC+機能有効時間ランプのみ「空白」を選択時、CC+機能有効時間ランプのみを非活性とする
              if (value == "" && cc.value == "0") {
                ccLamp.disabled = true
              }
              // CC+：ON（1）、CC+機能有効時間ランプのみ：値あり、CC+機能有効時間　全治療時間：値あり
              // CC+機能有効時間　ランプのみ「空白」を選択時、CC+機能有効時間　ランプのみを非活性とする
              if (value == "" && cc.value == "1" && ccAll.value != "") {
                ccLamp.disabled = true
              }
              return
            }
          }
          if(name == "ランプ機能"){
            // "ランプタイム"
            var lampTime = this.data.prescriptionItems.find(val => val.displayOrder == 10)
            // "ランプ時間【分】"
            var lampTimeMinutes = this.data.prescriptionItems.find(val => val.displayOrder == 11)
            // "ランプ開始圧【hPa(cmH2O)】"
            var lampStart = this.data.prescriptionItems.find(val => val.displayOrder == 12)
            if(value=="0"){
              lampTime.value = ""
              lampTimeMinutes.value = ""
              lampStart.value = ""
              lampTime.disabled = true
              lampTimeMinutes.disabled = true
              lampStart.disabled = true
            }else{
              if (!lampTime.value) {
                lampTime.value = lampTime.defaultValue
              }
              if (!lampTimeMinutes.value) {
                lampTimeMinutes.value = lampTimeMinutes.defaultValue
              }
              if (!lampStart.value) {
                lampStart.value = lampStart.defaultValue
              }
              lampTime.disabled = false
              lampTimeMinutes.disabled = false
              lampStart.disabled = false
            }
            return
          }
          if(name == "ランプタイム"){
            // "ランプ時間【分】"

            var lampTimeMinutes = this.data.prescriptionItems.find(val => val.displayOrder == 11)
            // ランプ機能
            var lamp = this.data.prescriptionItems.find(val => val.displayOrder == 9)
            if(value=="1"){
              lampTimeMinutes.value = ""
              lampTimeMinutes.disabled = true
            }else{
              if(lamp.value!="0"){
                if (!lampTimeMinutes.value) {
                  lampTimeMinutes.value = lampTimeMinutes.defaultValue
                }
                lampTimeMinutes.disabled = false
              }
            }
            // ランプ機能：0、ランプタイム：値ありの場合
            // ランプタイム「空白」を選択時、ランプタイムを非活性とする
            // "ランプタイム"
            var lampTime = this.data.prescriptionItems.find(val => val.displayOrder == 10)
            if (value == "" && lamp.value == "0") {
              lampTime.disabled = true
            }
            return
          }
          if (name == "ランプ時間【分】") {
            // ランプ機能
            var lamp = this.data.prescriptionItems.find(val => val.displayOrder == 9)
            // "ランプ時間【分】"
            var lampTimeMinutes = this.data.prescriptionItems.find(val => val.displayOrder == 11)
            // ランプ機能：0、ランプ時間【分】：値ありの場合
            // ランプ時間【分】「空白」を選択時、ランプ時間【分】を非活性とする
            if (value == "" && lamp.value == "0") {
              lampTimeMinutes.disabled = true
            }
            // ランプ機能：1（オン）、ランプタイム：I.RAMP（1）、ランプ時間【分】：値あり
            // ランプ時間【分】「空白」を選択時、ランプ時間【分】を非活性とする
            // "ランプタイム"
            var lampTime = this.data.prescriptionItems.find(val => val.displayOrder == 10)
            if (value == "" && lamp.value == "1" && lampTime.value == "1") {
              lampTimeMinutes.disabled = true
            }
            return
          }
          if (name == "ランプ開始圧【hPa(cmH2O)】") {
            // ランプ機能
            var lamp = this.data.prescriptionItems.find(val => val.displayOrder == 9)
            // "ランプ開始圧【hPa(cmH2O)】"
            var lampStart = this.data.prescriptionItems.find(val => val.displayOrder == 12)
            // ランプ機能：0、ランプ開始圧【hPa(cmH2O)】：値ありの場合
            // ランプ開始圧【hPa(cmH2O)】「空白」を選択時、ランプ開始圧【hPa(cmH2O)】を非活性とする
            if (value == "" && lamp.value == "0") {
              lampStart.disabled = true
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayOrder == 25)
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          break;
        case 6:
          // プリズマ ライン (prisma25S)
          break;
      }
      if(sapName=="KOKTY"){
        // 回路変更前の品目コード
        let deleteCircuitItemCode = ""
        let changedCircuitItemCode = ""
        if(this.data.circuitItemCode) deleteCircuitItemCode = this.data.circuitItemCode.split('_')
        // 回路入力時
        this.getDirectionsItemList()
        if(this.data.circuitItemCode) changedCircuitItemCode = this.data.circuitItemCode.split('_')
        if(changedCircuitItemCode != ""){
          for(let i =1 ; i < changedCircuitItemCode.length; i++){
            for(let directionsItem of this.directionsItemList){
              if(directionsItem.itemCode == changedCircuitItemCode[i]){
                // 変更後の出荷指示フラグ=true
                directionsItem.shippingInstructionsFlg = true
              }
            }
          }
        }
        if(deleteCircuitItemCode != ""){
          for(let i =1 ; i < deleteCircuitItemCode.length; i++){
            // 旧回路の見積を削除
            let deleteDirection = this.directionsItemList.filter(val => val.itemCode == deleteCircuitItemCode[i])
            this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => val.itemCode != deleteCircuitItemCode[i])
            if(deleteDirection.length > 0){
              deleteDirection[0].estimateCode= ""
              deleteDirection[0].quotationDetailsNumber= ""
              deleteDirection[0].shippingInstructionsFlg = false
            }
          }
        }
      }
    },
    getMaskMaster: function() {
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      if(model){
        this.formatType = model.reportFormatType
        this.maskSelectModalActive=true
      }else{
        this.showErrorMessage("CPAP機種が選択されていません。")
      }
    },
    maskSelect: function(maskInfo) {
      // マスク変更前の品目コード
      let deleteMaskItemCodes = this.data.maskInfo
      this.data.maskId = maskInfo.id
      this.data.maskType = maskInfo.maskType
      this.data.maskItemCode = maskInfo.itemCode1
      this.data.cushionSize = maskInfo.cushionSize
      this.data.frameSize = maskInfo.frameSize
      this.data.fixingMethod = maskInfo.fixingMethod
      this.data.maskInfo = maskInfo.items
      this.getDirectionsItemList()
      if(this.data.maskInfo){
        for(let items of this.data.maskInfo){
          let addShipping = this.directionsItemList.filter(val => val.itemCode == items.itemCode)
          if(addShipping.length > 0){
            // 変更後の出荷指示フラグ=true
            addShipping[0].shippingInstructionsFlg = true
          }
        }
      }
      if(deleteMaskItemCodes){
        // 旧マスクの見積を削除
        for(let items of deleteMaskItemCodes){
          let deleteDirection = this.directionsItemList.filter(val => val.itemCode == items.itemCode)
          this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => val.itemCode != items.itemCode)
          if(deleteDirection.length > 0){
            deleteDirection[0].estimateCode= ""
            deleteDirection[0].quotationDetailsNumber= ""
            deleteDirection[0].shippingInstructionsFlg = false
          }
        }
      }
      // this.controlDirectionsItem(this.data.maskItemCode,"mask")
    },
    controlDirectionsItem: function(directionsItemCode, targetType) {
      for(let directionsItem of this.directionsItemList){
        let target = this.cpapAccessories.find(val => val.itemCode == directionsItem.itemCode)
        let estimate = this.data.estimateDetailCode.find(val => val.itemCode == directionsItem.itemCode)
        let oldEstimate = this.saveOldEstimateDetailCode.find(val => val.itemCode == directionsItem.itemCode && val.itemCode != directionsItemCode)
        if(target && target.type && target.type == targetType){
          if(directionsItem.itemCode == directionsItemCode){
            if(!estimate){
              // 変更後の出荷指示フラグ=true
              directionsItem.shippingInstructionsFlg = true
            }
          }else{
            // それ以外の出荷指示フラグ=false
            directionsItem.shippingInstructionsFlg = false
            if(oldEstimate){
              if(targetType == "cpap" || targetType == "moist" || targetType == "module"){
                // 変更前の回収指示フラグ=true
                directionsItem.collectionInstructionsFlg = true
              }
            }
          }
        }
      }
    },
    isRequiredSerial: function() {
      // 預託在庫からの処方申込みの場合は、「シリアル」が必須
      return this.isEscrow
    },
    getDepositoryCodeMaster: function() {
      this.depositoryCodeMaster = []
      if(!this.officeCode) return
      // Web Api Call
      var _this = this;
      if(!_this.data.belongsId){
         return;
      }
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getCpapStorageLocationPOST({
            body:{
              belongsId: _this.data.belongsId,
              institutionId: _this.data.institutionId,
              salesOfficeCode: "J"+_this.officeCode
            }
          });
        },
        async function(result){
          _this.depositoryCodeMaster = result.obj;
          if(!_this.data.depositoryCode){
            var targetOffice = _this.depositoryCodeMaster.find(val => val.depositoryCode=="J"+_this.officeCode)
            if(targetOffice){
              _this.data.depositoryCode = targetOffice.depositoryCode
            }
          }
        },
        function(result){
          _this.showErrorMessage(result);
          _this.webHtApiErr = true
        }
      );
    },
    getDirectionsItemList: function() {
      let saveDirectionsItemList = []//フラグ保存用
      if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
        // 処方変更でない場合
        saveDirectionsItemList = this.directionsItemList
        this.directionsItemList = []
      }
      this.data.circuitItemCode = ""
      var setItem = this.cpapSetItems.find(val => val.cpapItemCode == this.data.model)
      var model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType && item.itemCode == this.data.model)
      if(!model && this.data.reportFormatType){
        model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType)
        setItem = this.cpapSetItems.find(val => val.cpapItemCode == model.itemCode)
      }

      var estimateList = this.data.estimateDetailCode && this.data.estimateDetailCode.length > 0 ? this.data.estimateDetailCode : []
      var provisionalTakenOutItems = this.data.provisionalTakenOutItems && this.data.provisionalTakenOutItems.length > 0 ? this.data.provisionalTakenOutItems : []
      for(var estimate of estimateList){
        if(!this.data.depositUseOrderDetail){
          estimate.depositUseOrderId = ""
          estimate.orderDetailNumber = ""
        }else{
          for(var detail of this.data.depositUseOrderDetail){
            var target = detail.items.find(val => val.itemCode==estimate.itemCode)
            if(target){
              estimate.depositUseOrderId = detail.orderId
              estimate.orderDetailNumber = target.orderDetailsNumber
              break;
            }
          }
        }
      }
      // CPAP本体
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      let cpapItems = model ? model.items : []
      for(var item of cpapItems){
        if(this.isTemp && this.data.model != item.itemCode) continue

        let target = estimateList.find(val => val.itemCode == item.itemCode)
        let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == item.itemCode)
        if(target) this.data.model = item.itemCode
        if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
          // 処方変更でない場合
          // 出荷指示フラグ
          let shipping = saveDirectionsItemList.find(val => val.itemCode == item.itemCode)
          if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
            //新規、再開、仮持出初期表示の場合　
            shipping = target
          }
          let shippingFlg = false
          if(shipping) shippingFlg = shipping.shippingInstructionsFlg
          this.directionsItemList.push({
            itemCode:item.itemCode,
            name:item.itemName,
            estimateCode:target ? target.estimateCode : "",
            quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
            depositUseOrderId:target ? target.depositUseOrderId : "",
            orderDetailNumber:target ? target.orderDetailNumber : "",
            tempDeviceId : tempDevice ? tempDevice.id : "",
            serial: this.data.serial && this.data.changeBeforeitemCode == item.itemCode ? this.data.serial : "", // QA200 ノーマル品⇔F品のシリアル変更時、仮持出/オーダーIDが「変更なし」になる
            shippingInstructionsFlg: shippingFlg
          })
        }else{
          var cpap = this.directionsItemList.find(val => val.itemCode == item.itemCode)
          if(!cpap){
            var sameNameCpap = this.directionsItemList.find(val => val.name == item.itemName)
            //指示書未選択で同名の機種がある場合
            if(sameNameCpap){
              var oldEstimateCpap = this.saveOldEstimateDetailCode.find(val => val.itemCode == item.itemCode)
              if(oldEstimateCpap){
                oldEstimateCpap.shippingInstructionsFlg = false
                oldEstimateCpap.collectionInstructionsFlg = false
                estimateList.push(oldEstimateCpap)
                sameNameCpap.itemCode = oldEstimateCpap.itemCode
                sameNameCpap.estimateCode = oldEstimateCpap.estimateCode
                sameNameCpap.quotationDetailsNumber = oldEstimateCpap.quotationDetailsNumber
                sameNameCpap.depositUseOrderId = oldEstimateCpap.depositUseOrderId
                sameNameCpap.orderDetailNumber = oldEstimateCpap.orderDetailNumber
                sameNameCpap.tempDeviceId = tempDevice ? tempDevice.id : ""
                sameNameCpap.serial = this.data.serial && this.data.changeBeforeitemCode == oldEstimateCpap.itemCode ? this.data.serial : "" // QA200 ノーマル品⇔F品のシリアル変更時、仮持出/オーダーIDが「変更なし」になる
                sameNameCpap.shippingInstructionsFlg = false
                sameNameCpap.collectionInstructionsFlg = false
              }
            }else{
              this.directionsItemList.push({
                itemCode:item.itemCode,
                name:item.itemName,
                estimateCode:target ? target.estimateCode : "",
                quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                depositUseOrderId:target ? target.depositUseOrderId : "",
                orderDetailNumber:target ? target.orderDetailNumber : "",
                tempDeviceId : tempDevice ? tempDevice.id : "",
                serial: this.data.serial && this.data.changeBeforeitemCode == item.itemCode ? this.data.serial : "", // QA200 ノーマル品⇔F品のシリアル変更時、仮持出/オーダーIDが「変更なし」になる
                shippingInstructionsFlg:target ? target.shippingInstructionsFlg : false,
                collectionInstructionsFlg:target ? target.collectionInstructionsFlg : false
              })
            }
          }else{
            cpap.estimateCode = target ? target.estimateCode : ""
            cpap.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
            cpap.depositUseOrderId = target ? target.depositUseOrderId : ""
            cpap.orderDetailNumber = target ? target.orderDetailNumber : ""
            cpap.tempDeviceId = tempDevice ? tempDevice.id : ""
            cpap.serial = this.data.serial && this.data.changeBeforeitemCode == item.itemCode ? this.data.serial : "" // QA200 ノーマル品⇔F品のシリアル変更時、仮持出/オーダーIDが「変更なし」になる
          }
        }
      }

      if(this.data.useMoist && setItem.moistItemCode){
        // 加湿器
        if(setItem.moist){
          for(let moistItem of setItem.moist){
            let target = estimateList.find(val => val.itemCode == moistItem.itemCode)
            let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == moistItem.itemCode)

            if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
              // 処方変更でない場合
              // 出荷指示フラグ
              let shipping = saveDirectionsItemList.find(val => val.itemCode == moistItem.itemCode)
              let shippingFlg = false
              if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
                //新規、再開、仮持出初期表示の場合　
                shipping = target
              }
              if(shipping) shippingFlg = shipping.shippingInstructionsFlg
              this.directionsItemList.push({
                  itemCode:moistItem.itemCode,
                  name:moistItem.itemName,
                  estimateCode:target ? target.estimateCode : "",
                  quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                  orderDetailNumber:target ? target.orderDetailNumber : "",
                  tempDeviceId : tempDevice ? tempDevice.id : "",
                  serial : this.data.moistSerial ? this.data.moistSerial : "",
                  shippingInstructionsFlg: shippingFlg
                })
            }else{
              var moist = this.directionsItemList.find(val => val.itemCode == moistItem.itemCode)
              if(!moist){
                var sameNameMoist = this.directionsItemList.find(val => val.name == moistItem.itemName)
                //指示書未選択で同名の加湿器がある場合
                if(sameNameMoist){
                var oldEstimateMoist = this.saveOldEstimateDetailCode.find(val => val.itemCode == moistItem.itemCode)
                  if(oldEstimateMoist){
                    oldEstimateMoist.shippingInstructionsFlg = false
                    oldEstimateMoist.collectionInstructionsFlg = false
                    estimateList.push(oldEstimateMoist)
                    sameNameMoist.itemCode = oldEstimateMoist.itemCode
                    sameNameMoist.estimateCode = oldEstimateMoist.estimateCode
                    sameNameMoist.quotationDetailsNumber = oldEstimateMoist.quotationDetailsNumber
                    sameNameMoist.depositUseOrderId = oldEstimateMoist.depositUseOrderId
                    sameNameMoist.orderDetailNumber = oldEstimateMoist.orderDetailNumber
                    sameNameMoist.tempDeviceId = tempDevice ? tempDevice.id : ""
                    sameNameMoist.serial = this.data.moistSerial ? this.data.moistSerial : "" // QA200観点テスト不具合対応
                    sameNameMoist.shippingInstructionsFlg = false
                    sameNameMoist.collectionInstructionsFlg = false
                  }
                }else{
                  this.directionsItemList.push({
                    itemCode:moistItem.itemCode,
                    name:moistItem.itemName,
                    estimateCode:target ? target.estimateCode : "",
                    quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                    orderDetailNumber:target ? target.orderDetailNumber : "",
                    tempDeviceId : tempDevice ? tempDevice.id : "",
                    serial : this.data.moistSerial ? this.data.moistSerial : "",
                    shippingInstructionsFlg:target ? target.shippingInstructionsFlg : false,
                    collectionInstructionsFlg:target ? target.collectionInstructionsFlg : false
                  })
                }
              }else{
                moist.Code = moistItem.itemCode
                moist.name = moistItem.itemName
                moist.estimateCode = target ? target.estimateCode : ""
                moist.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
                moist.orderDetailNumber = target ? target.orderDetailNumber : ""
                moist.tempDeviceId = tempDevice ? tempDevice.id : ""
                moist.serial = this.data.moistSerial ? this.data.moistSerial : ""
                moist.depositUseOrderId = target ? target.depositUseOrderId : "" // 預託QA　エスボックス処方の場合加湿器のオーダーが選択できない事象を解消
              }
            }
          }
        }else{
          let target = estimateList.find(val => val.itemCode == setItem.moistItemCode)
          let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == setItem.moistItemCode)
          if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
            // 処方変更でない場合
            // 出荷指示フラグ
            let shipping = saveDirectionsItemList.find(val => val.itemCode == setItem.moistItemCode)
            let shippingFlg = false
            if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
              //新規、再開、仮持出初期表示の場合　
              shipping = target
            }
            if(shipping) shippingFlg = shipping.shippingInstructionsFlg
            this.directionsItemList.push({
              itemCode:setItem.moistItemCode,
              name:setItem.moistItemName,
              estimateCode:target ? target.estimateCode : "",
              quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
              depositUseOrderId:target ? target.depositUseOrderId : "",
              orderDetailNumber:target ? target.orderDetailNumber : "",
              tempDeviceId : tempDevice ? tempDevice.id : "",
              serial : this.data.moistSerial ? this.data.moistSerial : "",
              shippingInstructionsFlg: shippingFlg
            })
          }else{
            var moist = this.directionsItemList.find(val => val.itemCode == setItem.moistItemCode)
            if(!moist){
              var sameNameMoist = this.directionsItemList.find(val => val.name == setItem.moistItemName)
              //指示書未選択で同名の加湿器がある場合
              if(sameNameMoist){
                var oldEstimateMoist = this.saveOldEstimateDetailCode.find(val => val.itemCode == setItem.moistItemCode)
                if(oldEstimateMoist){
                  oldEstimateMoist.shippingInstructionsFlg = false
                  oldEstimateMoist.collectionInstructionsFlg = false
                  this.data.estimateDetailCode.push(oldEstimateMoist) // QA200観点テスト不具合対応
                  sameNameMoist.itemCode = oldEstimateMoist.itemCode
                  sameNameMoist.estimateCode = oldEstimateMoist.estimateCode
                  sameNameMoist.quotationDetailsNumber = oldEstimateMoist.quotationDetailsNumber
                  sameNameMoist.depositUseOrderId = oldEstimateMoist.depositUseOrderId
                  sameNameMoist.orderDetailNumber = oldEstimateMoist.orderDetailNumber
                  sameNameMoist.tempDeviceId = tempDevice ? tempDevice.id : ""
                  sameNameMoist.serial = this.data.moistSerial ? this.data.moistSerial : "" // QA200観点テスト不具合対応
                  sameNameMoist.shippingInstructionsFlg = false
                  sameNameMoist.collectionInstructionsFlg = false
                }
              }else{
                this.directionsItemList.push({
                  itemCode:setItem.moistItemCode,
                  name:setItem.moistItemName,
                  estimateCode:target ? target.estimateCode : "",
                  quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                  depositUseOrderId:target ? target.depositUseOrderId : "",
                  orderDetailNumber:target ? target.orderDetailNumber : "",
                  tempDeviceId : tempDevice ? tempDevice.id : "",
                  serial : this.data.moistSerial ? this.data.moistSerial : "",
                  shippingInstructionsFlg:target ? target.shippingInstructionsFlg : false,
                  collectionInstructionsFlg:target ? target.collectionInstructionsFlg : false
                })
              }
            }else{
              moist.itemCode = setItem.moistItemCode
              moist.name = setItem.moistItemName
              moist.estimateCode = target ? target.estimateCode : ""
              moist.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
              moist.depositUseOrderId = target ? target.depositUseOrderId : ""
              moist.orderDetailNumber = target ? target.orderDetailNumber : ""
              moist.tempDeviceId = tempDevice ? tempDevice.id : ""
              moist.serial = this.data.moistSerial ? this.data.moistSerial : ""
            }
          }
        }
      }

      if(this.data.useModule && setItem.module){
        // 通信モジュール
        for(let moduleItem of setItem.module){
          if(this.data.moduleItemCode && this.data.moduleItemCode != moduleItem.itemCode) continue
          let target = estimateList.find(val => val.itemCode == moduleItem.itemCode)
          let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == moduleItem.itemCode)
          if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
            // 処方変更でない場合
            // 出荷指示フラグ
            let shipping = saveDirectionsItemList.find(val => val.itemCode == moduleItem.itemCode)
            let shippingFlg = false
            if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
              //新規、再開、仮持出初期表示の場合　
              shipping = target
            }
            if(shipping) shippingFlg = shipping.shippingInstructionsFlg
            this.directionsItemList.push({
              itemCode:moduleItem.itemCode,
              name:moduleItem.itemName,
              estimateCode:target ? target.estimateCode : "",
              quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
              depositUseOrderId:target ? target.depositUseOrderId : "",
              orderDetailNumber:target ? target.orderDetailNumber : "",
              tempDeviceId : tempDevice ? tempDevice.id : "",
              serial : this.data.moduleSerial ? this.data.moduleSerial : "",
              shippingInstructionsFlg: shippingFlg
            })
          }else{
            var moduleUnit = this.directionsItemList.find(val => val.itemCode == moduleItem.itemCode)
            if(!moduleUnit){
              var sameNameModule = this.directionsItemList.find(val => val.name == moduleItem.itemName)
              //指示書未選択で同名の通信モジュールがある場合
              if(sameNameModule){
                var oldEstimateModule = this.saveOldEstimateDetailCode.find(val => val.itemCode == moduleItem.itemCode)
                if(oldEstimateModule){
                  this.data.moduleItemCode = oldEstimateModule.itemCode
                  oldEstimateModule.shippingInstructionsFlg = false
                  oldEstimateModule.collectionInstructionsFlg = false
                  this.data.estimateDetailCode.push(oldEstimateModule) // QA200観点テスト不具合対応
                  sameNameModule.itemCode = oldEstimateModule.itemCode
                  sameNameModule.estimateCode = oldEstimateModule.estimateCode
                  sameNameModule.quotationDetailsNumber = oldEstimateModule.quotationDetailsNumber
                  sameNameModule.depositUseOrderId = oldEstimateModule.depositUseOrderId
                  sameNameModule.orderDetailNumber = oldEstimateModule.orderDetailNumber
                  sameNameModule.tempDeviceId = tempDevice ? tempDevice.id : ""
                  sameNameModule.serial = this.data.moduleSerial ? this.data.moduleSerial : "" // QA200観点テスト不具合対応
                  sameNameModule.shippingInstructionsFlg = false
                  sameNameModule.collectionInstructionsFlg = false
                }
              }else{
                this.directionsItemList.push({
                  itemCode:moduleItem.itemCode,
                  name:moduleItem.itemName,
                  estimateCode:target ? target.estimateCode : "",
                  quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                  depositUseOrderId:target ? target.depositUseOrderId : "",
                  orderDetailNumber:target ? target.orderDetailNumber : "",
                  tempDeviceId : tempDevice ? tempDevice.id : "",
                  serial : this.data.moduleSerial ? this.data.moduleSerial : "",
                  shippingInstructionsFlg:target ? target.shippingInstructionsFlg : false,
                  collectionInstructionsFlg:target ? target.collectionInstructionsFlg : false
                })
              }
            }else{
              moduleUnit.itemCode = moduleItem.itemCode
              moduleUnit.name = moduleItem.itemName
              moduleUnit.estimateCode = target ? target.estimateCode : ""
              moduleUnit.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
              moduleUnit.depositUseOrderId = target ? target.depositUseOrderId : ""
              moduleUnit.orderDetailNumber = target ? target.orderDetailNumber : ""
              moduleUnit.tempDeviceId = tempDevice ? tempDevice.id : ""
              moduleUnit.serial = this.data.moduleSerial ? this.data.moduleSerial : ""
            }
          }
        }
      }

      // if(this.data.maskInfo && this.data.maskInfo.length > 0){
      if(!this.data.depositUseFlag && this.data.maskInfo && this.data.maskInfo.length > 0){
        // NOTE: マスクと回路は預託の対象ではないので、depositUseFlagがオンの場合をはじいている
        for(var mask of this.data.maskInfo){
          let target = estimateList.find(val => val.itemCode == mask.itemCode)
          let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == mask.itemCode)
          if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
            // 処方変更でない場合
            // 出荷指示フラグ
            let shipping = saveDirectionsItemList.find(val => val.itemCode == mask.itemCode)
            let shippingFlg = false
            if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
              //新規、再開、仮持出初期表示の場合　
              shipping = target
            }
            if(shipping) shippingFlg = shipping.shippingInstructionsFlg
            this.directionsItemList.push({
            itemCode:mask.itemCode,
            name:mask.itemName,
            estimateCode:target ? target.estimateCode : "",
            quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
            depositUseOrderId:target ? target.depositUseOrderId : "",
            orderDetailNumber:target ? target.orderDetailNumber : "",
            tempDeviceId : tempDevice ? tempDevice.id : "",
            shippingInstructionsFlg: shippingFlg
          })
          }else{
            var maskItem = this.directionsItemList.find(val => val.itemCode == mask.itemCode)
            if(!maskItem){
              var sameNameMask = this.directionsItemList.find(val => val.name == mask.itemName)
              //指示書未選択で同名のマスクがある場合
              if(sameNameMask){
                var oldEstimateMask = this.saveOldEstimateDetailCode.find(val => val.itemCode == mask.itemCode)
                  if(oldEstimateMask){
                    oldEstimateMask.shippingInstructionsFlg = false
                    oldEstimateMask.collectionInstructionsFlg = false
                    estimateList.push(oldEstimateMask)
                    sameNameMask.itemCode = oldEstimateMask.itemCode
                    sameNameMask.estimateCode = oldEstimateMask.estimateCode
                    sameNameMask.quotationDetailsNumber = oldEstimateMask.quotationDetailsNumber
                    sameNameMask.depositUseOrderId = oldEstimateMask.depositUseOrderId
                    sameNameMask.orderDetailNumber = oldEstimateMask.orderDetailNumber
                    sameNameMask.tempDeviceId = tempDevice ? tempDevice.id : ""
                    sameNameMask.shippingInstructionsFlg = false
                    sameNameMask.collectionInstructionsFlg = false
                  }
              }else{
                this.directionsItemList.push({
                  itemCode:mask.itemCode,
                  name:mask.itemName,
                  estimateCode:target ? target.estimateCode : "",
                  quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                  depositUseOrderId:target ? target.depositUseOrderId : "",
                  orderDetailNumber:target ? target.orderDetailNumber : "",
                  tempDeviceId : tempDevice ? tempDevice.id : "",
                  shippingInstructionsFlg: target ? target.shippingInstructionsFlg : false,
                  collectionInstructionsFl: target ? target.collectionInstructionsFlg : false
                })
              }
            }else{
              maskItem.itemCode = mask.itemCode
              maskItem.name = mask.itemName
              maskItem.estimateCode = target ? target.estimateCode : ""
              maskItem.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
              maskItem.depositUseOrderId = target ? target.depositUseOrderId : ""
              maskItem.orderDetailNumber = target ? target.orderDetailNumber : ""
              maskItem.tempDeviceId = tempDevice ? tempDevice.id : ""
            }
          }
        }
      }
      var circuitValue = this.data.prescriptionItems ? this.data.prescriptionItems.find(val => val.itemName == "KOKTY") : ""

      // if(circuitValue && circuitValue.value){
      if(!this.data.depositUseFlag && circuitValue && circuitValue.value){
        // NOTE: マスクと回路は預託の対象ではないので、depositUseFlagがオンの場合をはじいている
        // 回路
        var circuitList = setItem.circuit ? setItem.circuit[circuitValue.value] : ""
        if(circuitList && circuitList.length > 0){
          for(var circuit of circuitList){
            let target = estimateList.find(val => val.itemCode == circuit.itemCode)
            let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == circuit.itemCode)

            if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
              // 処方変更でない場合
              // 出荷指示フラグ
              let shipping = saveDirectionsItemList.find(val => val.itemCode == circuit.itemCode)
              let shippingFlg = false
              if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
                //新規、再開、仮持出初期表示の場合　
                shipping = target
              }
              if(shipping) shippingFlg = shipping.shippingInstructionsFlg
              this.directionsItemList.push({
                itemCode:circuit.itemCode,
                name:circuit.itemName,
                estimateCode:target ? target.estimateCode : "",
                quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                depositUseOrderId:target ? target.depositUseOrderId : "",
                orderDetailNumber:target ? target.orderDetailNumber : "",
                tempDeviceId : tempDevice ? tempDevice.id : "",
                shippingInstructionsFlg: shippingFlg
              })
              this.data.circuitItemCode = this.data.circuitItemCode + "_" + circuit.itemCode
            }else{
              var circuitItem = this.directionsItemList.find(val => val.itemCode == circuit.itemCode)
              if(!circuitItem){
                var sameNameCircuit = this.directionsItemList.find(val => val.name == circuit.itemName)
                //指示書未選択で同名の回路がある場合
                if(sameNameCircuit){
                  var oldEstimateCircuit = this.saveOldEstimateDetailCode.find(val => val.itemCode == circuit.itemCode)
                    if(oldEstimateCircuit){
                      oldEstimateCircuit.shippingInstructionsFlg = false
                      oldEstimateCircuit.collectionInstructionsFlg = false
                      estimateList.push(oldEstimateCircuit)
                      sameNameCircuit.itemCode = oldEstimateCircuit.itemCode
                      sameNameCircuit.estimateCode = oldEstimateCircuit.estimateCode
                      sameNameCircuit.quotationDetailsNumber = oldEstimateCircuit.quotationDetailsNumber
                      sameNameCircuit.depositUseOrderId = oldEstimateCircuit.depositUseOrderId
                      sameNameCircuit.orderDetailNumber = oldEstimateCircuit.orderDetailNumber
                      sameNameCircuit.tempDeviceId = tempDevice ? tempDevice.id : ""
                      sameNameCircuit.shippingInstructionsFlg = false
                      sameNameCircuit.collectionInstructionsFlg = false
                    }
                }else{
                  this.directionsItemList.push({
                    itemCode:circuit.itemCode,
                    name:circuit.itemName,
                    estimateCode:target ? target.estimateCode : "",
                    quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                    depositUseOrderId:target ? target.depositUseOrderId : "",
                    orderDetailNumber:target ? target.orderDetailNumber : "",
                    tempDeviceId : tempDevice ? tempDevice.id : "",
                    shippingInstructionsFlg: target ? target.shippingInstructionsFlg : false,
                    collectionInstructionsFl: target ? target.collectionInstructionsFlg : false
                  })
                  this.data.circuitItemCode = this.data.circuitItemCode + "_" + circuit.itemCode
                }
              }else{
                circuitItem.itemCode = circuit.itemCode
                circuitItem.name = circuit.itemName
                circuitItem.estimateCode = target ? target.estimateCode : ""
                circuitItem.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
                circuitItem.depositUseOrderId = target ? target.depositUseOrderId : ""
                circuitItem.orderDetailNumber = target ? target.orderDetailNumber : ""
                circuitItem.tempDeviceId = tempDevice ? tempDevice.id : ""
                this.data.circuitItemCode = this.data.circuitItemCode + "_" + circuit.itemCode
              }
            }
          }
        }
      }

      if(estimateList && estimateList.length > 0){
        for(var estimate of estimateList){
          let target = this.directionsItemList.find(val => val.itemCode == estimate.itemCode)
          let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == estimate.itemCode)
          // 追加済みの指示書未選択のものは除外
          let addedTarget = this.directionsItemList.find(val => val.name == estimate.itemName)
          if(target) {
            if(estimate.itemCode != ""){
              continue
            }
          }
          if(addedTarget) continue
          this.directionsItemList.push({
            itemCode:"",
            name:estimate.itemName,
            estimateCode: estimate.estimateCode,
            quotationDetailsNumber:estimate.quotationDetailsNumber,
            orderDetailNumber:estimate.orderDetailNumber,
            tempDeviceId : tempDevice ? tempDevice.id : "",
            depositUseOrderId:target ? target.depositUseOrderId : "",
            shippingInstructionsFlg:estimate ? estimate.shippingInstructionsFlg : false,
            collectionInstructionsFlg:estimate ? estimate.collectionInstructionsFlg : false
          })
        }
      }
      this.renderKey = !this.renderKey
    },
    changeModule: function() {
      this.getDirectionsItemList();
      this.controlDirectionsItem(this.data.moduleItemCode,"module");
    },
    getConsistencyCheck: function() {
      var target
      if(this.data.depositUseFlag){
        // 預託機使用の場合
        target = this.directionsItemList.find(val => !val.orderDetailNumber)
      }else{
        target = this.directionsItemList.find(val => !val.itemCode || !val.quotationDetailsNumber)
      }
      if(target){
        return false
      }
      return true
    },
    cpapConsistencyCheckErr: function() {
      var target = this.directionsItemList.find(val => val.itemCode == this.data.model)
      if(!target || !target.quotationDetailsNumber || !target.orderDetailNumber){
        return true
      }
      return false
    },
    cpapConsistencyCheckErr: function() {
      var target = this.directionsItemList.find(val => val.itemCode == this.data.model)
      // 預託処方変更ではバリデーションをスルー　// 2023.12.12
      if(!(this.data.kind == this.cpapKindMap.applicationChange) && (!target || !target.quotationDetailsNumber || !target.orderDetailNumber)){
        return true
      }
      return false
    },
    modulchangedCheck: function(areaName) {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == areaName)
          // 変更項目の有無を返却
          return target && target.modulChange
        }
      }
    },
    addCheck: function(areaName) {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == areaName)
          // 変更項目の有無を返却
          if(areaName == "moistArea"){
            return target && target.moistAdd
          }else{
            return target && target.modulAdd
          }
        }
      }
    },
    singleChangedCheck: function(areaName,itemName) {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == areaName)
          if(target.items && target.items.length>0){
            let targetItem = target.items.find((val => val.itemName == itemName))
              // 変更項目の有無を返却
              return targetItem && target.isChange
          }
        }
      }
    },
    simultaneousExchangeCheck: function() {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == "moduleArea")
          // 変更項目の有無を返却
          return target && target.simultaneousExchange
        }
      }
      return false;
    },
    changedCheck: function(itemName) {
      // QA358_変更ありマークの改修（カラム値の比較）
      // 支店回覧時のみ
      if (this.circulation) {
        // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            // 比較値
            let target = this.compareTarget[itemName]
            let oldtarget = this.data.previousRequestCpap[itemName]
            if (itemName == 'patientName' || itemName == 'patientNameKana' || itemName == 'deliveryDestination') {
              target = target ? target.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : target
              oldtarget = oldtarget ? oldtarget.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : oldtarget
            // 電話番号＆機器納品先電話番号の比較値成形
            } else if (itemName == 'patientMobilePhone' || itemName == 'patientPhoneNumber' || itemName == 'deliveryPhoneNumber') {
              target = target ? target.replace(/-/g, '') : target
              oldtarget = oldtarget ? oldtarget.replace(/-/g, '') : oldtarget
            // 住所の比較値成形&全体比較
            } else if (itemName == 'patientAddress' || itemName == 'patientHouseNumber' || itemName == 'patientBuilding') {
              let targetAdress = this.data.patientAdressAll
              let oldTargetAdress = this.data.previousRequestCpap['patientAddress'] + this.data.previousRequestCpap['patientHouseNumber'] + this.data.previousRequestCpap['patientBuilding']
              targetAdress = targetAdress ? targetAdress.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : targetAdress
              oldTargetAdress = oldTargetAdress ? oldTargetAdress.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : oldTargetAdress
              if (targetAdress == oldTargetAdress) {
                return false
              }
            // 機器納品先住所の比較値成形&全体比較
            } else if (itemName == 'deliveryAddress' || itemName == 'deliveryHouseNumber' || itemName == 'deliveryBuilding') {
              let targetAdress = this.data.deliveryAddressAll
              let oldTargetAdress = this.data.previousRequestCpap['deliveryAddress'] + this.data.previousRequestCpap['deliveryHouseNumber'] + this.data.previousRequestCpap['deliveryBuilding']
              targetAdress = targetAdress ? targetAdress.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : targetAdress
              oldTargetAdress = oldTargetAdress ? oldTargetAdress.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : oldTargetAdress
              if (targetAdress == oldTargetAdress) {
                return false
              }
            // 備考欄の比較値成形
            } else if (itemName == 'remarks') {
              target = target ? target.replace(/\n/g, '').replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, ''): target
              oldtarget = oldtarget ? oldtarget.replace(/\n/g, '').replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '') : oldtarget
            // 機種・シリアル変更
            } else if (itemName == 'reportFormatType' || itemName == 'serial') {
              if (this.data.previousRequestCpap.reportFormatType && this.data.previousRequestCpap.reportFormatType != this.compareTarget.reportFormatType) {
                return true
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              } else if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
                  if (!this.compareTarget[itemName]) {
                    return false
                  }
                }
                let beforeCorrespondReportFormatType = this.data.beforeCorrespondItems.reportFormatType
                let beforeCorrespondSerial = this.data.beforeCorrespondItems.serial
                // 機種変更・シリアル変更を確認
                if (beforeCorrespondReportFormatType != this.compareTarget.reportFormatType) {
                  return true
                } else if (itemName == 'serial' && beforeCorrespondSerial != this.compareTarget[itemName]) {
                  return true
                } else if (itemName == 'serial' && beforeCorrespondSerial == this.compareTarget[itemName]) {
                  return false
                } else if (itemName == 'reportFormatType' && beforeCorrespondReportFormatType == this.compareTarget[itemName]) {
                  return false
                }
              }
            }
            // NULL値と空値の比較を考慮
            if (!target && !oldtarget) {
              return false
            // 一つ前の処方と値を比較し変更がある場合はtrueを返却
            } else if (target != oldtarget) {
              return true
            }
          }
        }
      }
      return false
    },
    changedPrescriptionCheck: function(displayOrder,displayName) {
      // QA358_変更ありマークの改修（JSON値の比較（本体））
      // 支店回覧時のみ
      if (this.circulation) {
        // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            // 本体機種変更時は、機種、シリアル欄以外には変更ありラベルを表示しない
            if (this.data.previousRequestCpap.reportFormatType && this.data.previousRequestCpap.reportFormatType != this.compareTarget.reportFormatType) {
              return false
            // 当該処方・ひとつ前の処方が内部指示書連携の場合
            } else if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
              let beforeCorrespondReportFormatType = this.data.beforeCorrespondItems.reportFormatType
              // 機種変更を確認
              if (beforeCorrespondReportFormatType != this.compareTarget.reportFormatType) {
                return false
              }
            }
            // JSON値を比較
            let target = this.compareTarget.prescriptionContent.find(val => val.displayOrder == displayOrder && val.displayName == displayName)
            let oldTarget = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayOrder == displayOrder && val.displayName == displayName)
            if (displayName == 'Flexタイプ') {
              let targetmode = this.compareTarget.prescriptionContent.find(val => val.displayName == 'モード')
              let oldTargetmode = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == 'モード')
              if (targetmode && oldTargetmode) {
                if (targetmode != oldTargetmode) {
                  target = this.compareTarget.prescriptionContent.find(val => val.displayName == 'Flexタイプ' && val.mode.indexOf(Number(targetmode.value)) != -1)
                  oldTarget = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == 'Flexタイプ' && val.mode.indexOf(Number(oldTargetmode.value)) != -1)
                }
              }
            }
            if (target && oldTarget) {
              if (target.value != oldTarget.value) {
                return true
              }
            }
          }
        }
      }
      return false
    },
    modulePrescriptionCheck: function(displayName) {
      // QA358_変更ありマークの改修（JSON値の比較（モデム））
      // 支店回覧時のみ
      if (this.circulation) {
        // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            // 有無欄以外
            if (displayName != '通信モジュール') {
              // モデム機種変更時は、処方値欄には変更ありラベルを表示しない
              if (this.data.previousRequestCpap.moduleItemCode && this.data.previousRequestCpap.moduleItemCode != this.compareTarget.moduleItemCode) {
                return false
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              } else if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                let beforeCorrespondModuleItemCode = this.data.beforeCorrespondItems.moduleItemCode
                // 機種変更・追加を確認
                if (beforeCorrespondModuleItemCode != this.compareTarget.moduleItemCode) {
                  return false
                }
              }
              let targetmoduleUse = this.compareTarget.prescriptionContent.find(val => val.displayName == "通信モジュール")
              let oldModuleUse = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == "通信モジュール")
              if (targetmoduleUse && oldModuleUse) {
                // モデム無➡有の場合、処方値欄には変更ありマークを表示しない
                if (targetmoduleUse.value == 1 && oldModuleUse.value == 0) {
                  return false
                  // モデム無の場合、処方値欄には変更ありマークを表示しない
                } else if (targetmoduleUse.value == 0) {
                  return false
                }
              } else if (targetmoduleUse && !oldModuleUse) {
                return false
              }
            // 有無欄
            } else {
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                let beforeCorrespondModuleItemCode = this.data.beforeCorrespondItems.moduleItemCode
                // 追加を確認
                if (beforeCorrespondModuleItemCode == "" && this.compareTarget.moduleItemCode) {
                  return true
                }
              }
            }
            // JSON値を比較
            let target = this.compareTarget.prescriptionContent.find(val => val.displayName == displayName)
            let oldTarget = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == displayName)
            if (target && oldTarget) {
              if (target.value != oldTarget.value) {
                return true
              }
            // 前処方にモデムの各項目がなかったときに変更ありマークを表示する
            } else if (target && !oldTarget) {
              return true
            }
          }
        }
      }
      return false
    },
    moistPrescriptionCheck: function(displayName) {
      // QA358_変更ありマークの改修（JSON値の比較（加湿器））
      // 支店回覧時のみ
      if (this.circulation) {
        // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            // 有無欄以外
            if (displayName != '加温加湿器') {
              // 加湿器機種変更時は、処方値欄には変更ありラベルを表示しない
              if (this.data.previousRequestCpap.moistItemCode && this.data.previousRequestCpap.moistItemCode != this.compareTarget.moistItemCode) {
                return false
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              } else if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                let beforeCorrespondMoistItemCode = this.data.beforeCorrespondItems.moistItemCode
                // 機種変更・追加を確認
                if (beforeCorrespondMoistItemCode != this.compareTarget.moistItemCode) {
                  return false
                }
              }
              let targetmoistUse = this.compareTarget.prescriptionContent.find(val => val.displayName == "加温加湿器")
              let oldMoistUse = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == "加温加湿器")
              if (targetmoistUse && oldMoistUse) {
                // 加湿器無➡有の場合、有無欄以外に変更ありマークを表示しない
                if (targetmoistUse.value == 1 && oldMoistUse.value == 0) {
                  return false
                // 加湿器無の場合、有無欄以外に変更ありマークを表示しない
                } else if (targetmoistUse.value == 0) {
                  return false
                }
              }
            // 有無欄
            } else {
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                let beforeCorrespondMoistItemCode = this.data.beforeCorrespondItems.moistItemCode
                // 追加を確認
                if (beforeCorrespondMoistItemCode == "" && this.compareTarget.moistItemCode) {
                  return true
                }
              }
            }
            // JSON値を比較
            let target = this.compareTarget.prescriptionContent.find(val => val.displayName == displayName)
            let oldTarget = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == displayName)
            if (target && oldTarget) {
              if (target.value != oldTarget.value) {
                return true
              }
            // 前処方に加湿器の各項目がなかったときに変更ありマークを表示する
            } else if (target && !oldTarget) {
              return true
            }
          }
        }
      }
      return false
    },
    moduleMoistCheck: function(areaName,itemName) {
      // QA358_変更ありマークの改修（カラム値の比較（加湿器・モデム））
      // 支店回覧時のみ
      if (this.circulation) {
        // 処方変更・転院再開・中止再開・内部指示書連携にのみ表示
        if (this.data.kind == this.cpapKindMap.applicationChange || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
          if (this.data.previousRequestCpap) {
            let target = this.compareTarget[itemName]
            let oldtarget = this.data.previousRequestCpap[itemName]
            // 加湿器
            if (areaName == "moistArea") {
              let moistUse = this.compareTarget.prescriptionContent.find(val => val.displayName == "加温加湿器")
              let oldMoistUse = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == "加温加湿器")
              if (moistUse && oldMoistUse) {
                // 加湿器追加の場合、機種、シリアル欄には変更ありラベルを表示しない
                if (moistUse.value == 1 && oldMoistUse.value == 0) {
                  return false
                // 加湿器無の場合、機種、シリアル欄には変更ありラベルを表示しない
                }　else if (moistUse.value == 0) {
                  return false
                }
              }
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
                  if (!this.compareTarget[itemName]) {
                    return false
                  }
                }
                let beforeCorrespondMoistItemCode = this.data.beforeCorrespondItems.moistItemCode
                let beforeCorrespondMoistSerial = this.data.beforeCorrespondItems.moistSerial
                if (beforeCorrespondMoistItemCode && this.compareTarget.moistItemCode) {
                  // 機種変更・シリアル変更を確認
                  if (beforeCorrespondMoistItemCode != this.compareTarget.moistItemCode) {
                    return true
                  } else if (itemName == 'moistSerial' && beforeCorrespondMoistSerial != this.compareTarget[itemName]) {
                    return true
                  } else if (itemName == 'moistSerial' && beforeCorrespondMoistSerial == this.compareTarget[itemName]) {
                    return false
                  } else if (itemName == 'moistItemCode' && beforeCorrespondMoistItemCode == this.compareTarget[itemName]) {
                    return false
                  }
                } else if (beforeCorrespondMoistItemCode == "" && this.data.compareTarget.moistItemCode) {
                  return false
                }
              }
            // モデム
            } else if (areaName == "moduleArea") {
              let moduleUse = this.compareTarget.prescriptionContent.find(val => val.displayName == "通信モジュール")
              let oldModuleUse = this.data.previousRequestCpap.prescriptionContent.find(val => val.displayName == "通信モジュール")
              if (moduleUse && oldModuleUse) {
                // モデム追加の場合、機種、シリアル欄には変更ありラベルを表示しない
                if (moduleUse.value == 1 && oldModuleUse.value == 0) {
                  return false
                // モデム無の場合、機種、シリアル欄には変更ありラベルを表示しない
                } else if (moduleUse.value == 0) {
                  return false
                }
              // 前処方の本体にモデムの概念がなかったときに変更ありマークを表示しない
              } else if (moduleUse && !oldModuleUse) {
                return false
              }
              // 当該処方・ひとつ前の処方が内部指示書連携の場合
              if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence || this.data.previousRequestCpap.applicationType == this.cpapKindMap.applicationPhilipsCorrespondence) {
                if (this.data.kind == this.cpapKindMap.applicationPhilipsCorrespondence) {
                  if (!this.compareTarget[itemName]) {
                    return false
                  }
                }
                let beforeCorrespondModuleItemCode = this.data.beforeCorrespondItems.moduleItemCode
                let beforeCorrespondModuleSerial = this.data.beforeCorrespondItems.moduleSerial
                if (beforeCorrespondModuleItemCode && this.compareTarget.moduleItemCode) {
                  // 機種変更・シリアル変更を確認
                  if (beforeCorrespondModuleItemCode != this.compareTarget.moduleItemCode) {
                    return true
                  } else if (itemName == 'moduleSerial' && beforeCorrespondModuleSerial != this.compareTarget[itemName]) {
                    return true
                  } else if (itemName == 'moduleSerial' && beforeCorrespondModuleSerial == this.compareTarget[itemName]) {
                    return false
                  } else if (itemName == 'moduleItemCode' && beforeCorrespondModuleItemCode == this.compareTarget[itemName]) {
                    return false
                  }
                } else if (beforeCorrespondModuleItemCode =="" && this.compareTarget.moduleItemCode) {
                  return false
                }
              }
            }
            // NULL値と空値の比較を考慮
            if (!target && !oldtarget) {
              return false
            // 一つ前の処方と値を比較し変更がある場合はtrueを返却
            } else if (target != oldtarget) {
              return true;
            }
          }
        }
      }
      return false
    },
    simultaneousExchange: function() {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          if(this.modulchangedCheck('moduleArea')){// 機種
            let target = this.data.changedItems.find(val => val.areaName == "moduleArea")
            if(target){
              // 申込時にモデム処方、機種情報に変更があれば同時交換対象外
              target.simultaneousExchange = false
            }
          }
        }
      }
    },
    simultaneousExchangeCheck2: function() {
      // CPAP本体がシリアル交換予定（出荷指示、回収指示ON）で見積が入っている場合モデム同時交換の注記表示
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        let cpapShipping = false
        let cpapCollection = false
        let cpapEstimate = ""
        if(!this.simultaneousExchangeCheck()){
          //申込時にモデム同時交換の場合は機器交換の為、シリアル交換不可
          if(this.data.estimateDetailCode.length > 0 && this.directionsItemList.length > 0){
            let cpap = this.data.estimateDetailCode.find(val => val.itemCode == this.data.model)
            let cpapDirections = this.directionsItemList.find(val => val.itemCode == this.data.model)
            if(cpap && cpapDirections){
              cpapShipping = cpapDirections.shippingInstructionsFlg
              cpapCollection = cpapDirections.collectionInstructionsFlg
              cpapEstimate = cpap.estimateCode
            }
          }
          if(cpapShipping && cpapCollection && (cpapEstimate != "")){
            return true;
          }
        }
      }
      return false;
    },
    saveSimultaneousExchangeCheck: function() {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == "moduleArea")
          // 変更項目の有無を返却
          return target && target.saveSimultaneousExchange
        }
      }
      return false;
    },
    moduleSimultaneousExchange: function() {
      //機種変更時
      let machineChangeFlag = this.singleChangedCheck('hardwareArea','reportFormatType');

      //申込時にモデム処方、機種情報に変更があれば同時交換対象外
      if(machineChangeFlag) this.simultaneousExchange();

      // 通信モジュール有→有の場合false
      let moduleSimultaneousExchangeFlag =false;
      moduleSimultaneousExchangeFlag = this.simultaneousExchangeCheck();

      // 保存している場合はtrue
      let saveModuleSimultaneousExchangeFlag =false;
      saveModuleSimultaneousExchangeFlag = this.saveSimultaneousExchangeCheck();

      var setItem = this.cpapSetItems.find(val => val.cpapItemCode == this.data.model)

      if(this.data.kind == cpapKindMap.applicationChange &&
         this.data.status == "1" &&
         machineChangeFlag &&
         moduleSimultaneousExchangeFlag){

        //同時交換の場合、比較用の旧見積情報からモデムを削除（預託処方変更を除く）
        if (!this.data.depositUseFlag) {
          this.data.oldEstimateDetailCode = this.data.oldEstimateDetailCode.filter(val=>{ return val.itemCode !== this.data.moduleItemCode});
          if(!saveModuleSimultaneousExchangeFlag){
            if(this.data.moduleItemCode){
              // QA324・389_ディスコン対応に伴い無効化（モデム機種が初期化されて3Gモデムが復活してしまうため）
              // this.data.moduleItemCode = "";// 機種
            }
            if(this.data.moduleSerial){
              this.data.moduleSerial = "";// シリアル
            }
          }
        }
      }
    },
    deleteTempDeviceInfo: function(code,index) {
      this.data.provisionalTakenOutItems = this.data.provisionalTakenOutItems.filter(val => {
        return val.itemCode!=code
      })
      this.directionsItemList[index].tempDeviceId = ""
    },
    deleteDepositUseOrderInfo: function(orderId, itemCode) {
      this.data.depositUseOrderDetail = this.data.depositUseOrderDetail.filter(val => {
        if(val.items.length > 0) return val.items[0].itemCode!=itemCode
      })
      for(var directionsItem of this.directionsItemList){
        if(directionsItem.depositUseOrderId == orderId && directionsItem.itemCode == itemCode){
          directionsItem.depositUseOrderId = ""
          directionsItem.orderDetailNumber = ""
          var target = this.cpapAccessories.find(val => val.itemCode == directionsItem.itemCode)
          if(target){
            switch(target.type){
              case "cpap":
                this.data.depositUseOrderId = ""
                break;
              case "moist":
                this.data.depositUseMoistId = ""
                break;
              case "module":
                this.data.depositUseModuleId = ""
                break;
            }
          }
          break;
        }
      }
      for(var estimateDetail of this.data.estimateDetailCode){
        if(estimateDetail.depositUseOrderId == orderId && estimateDetail.itemCode == itemCode){
          estimateDetail.depositUseOrderId = ""
          estimateDetail.orderDetailNumber = ""
          break;
        }
      }
    },
    orderSelectModalOn: function(orderId,code) {
      this.searchOrderSerialNumber = ""
      var target = this.cpapAccessories.find(val => val.itemCode == code)
      if(target){
        switch(target.type){
          case "cpap":
            this.searchOrderSerialNumber = this.data.serial
            break;
          case "moist":
            this.searchOrderSerialNumber = this.data.moistSerial
            break;
          case "module":
            this.searchOrderSerialNumber = this.data.moduleSerial
            break;
        }
      }
      this.searchDepositUseOrderId = orderId ? orderId : ""
      this.searchOrderItemCode = code
      this.cpapOrderSelectModalActive = true
    },
    deleteQuotation: function(code,name,index) {
      console.log(code)
      console.log(name)
      this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => {
        if(code){
          if(val.itemCode!=code) return true
        } else {
          if (val.itemName!=name) return true
        }
      })
      this.directionsItemList[index].estimateCode = ""
      this.directionsItemList[index].quotationDetailsNumber = ""
      this.getDirectionsItemList();
      this.estimateDisabled(code, this.directionsItemList[index], 'shipping')
    },
    quotationModalOn: function(code,name) {
      this.quotationItemCode = code
      this.quotationItemName = name
      this.itemQuotationModalActive = true
    },
    setQuotationItem: function(quotationInfo) {
      var target = this.cpapAccessories.find(val => val.itemCode == this.quotationItemCode)
      for(let item of quotationInfo.items){
        if(this.quotationItemCode != item.itemCode) continue
        item.estimateCode = quotationInfo.quotationNumber
        if(target){
          switch(target.type){
            case "cpap":
              this.data.estimateCode = quotationInfo.quotationNumber
              break;
            case "moist":
              this.data.moistItemCode = item.itemCode
              break;
            case "module":
              this.data.moduleItemCode = item.itemCode
              break;
          }
        }
        this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => {
          if(this.quotationItemCode){
            if(val.itemCode != this.quotationItemCode) return true
          } else {
            if (val.itemName!=this.quotationItemName) return true
          }
        })
        this.data.estimateDetailCode.push(item)
      }
      this.quotationItemCode = ""
      this.quotationItemName = ""
      this.getDirectionsItemList();
    },
    // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）(getEscrowStock)
    getEscrowStock: async function() {
      var excuteApi = this.getEscrowStockPOST;
      var successCallBack = this.getEscrowStockPOSTSuccess;
      var errorCallBack = this.getEscrowStockPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getEscrowStockPOST: function(client) {
      return client.apis.externalCpap.getEscrowStockPOST({
        body:{
          hospitalCode:this.medicalInstitutionCode,
        }
      });
    },
    getEscrowStockPOSTSuccess: function(result) {
      this.escrowStockList = result.body.map((value) => value.items).flat();
      this.stockItemNameList = this.escrowStockList.map((value) => value.itemName);
      this.stockItemCodeList = this.escrowStockList.map((value) => value.itemCode);
      this.stockItemSeialList = this.escrowStockList.map((value) => value.serial);
    },
    getEscrowStockPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    // 院内在庫をWEBから取得し本体、加湿器、モジュールそれぞれプルダウンから選ぶ仕様に改修中でペンディング（2024年に持ち越し、フィリップス佐藤様より）
    // 2023.11現在、WEB/HTからのレスポンスだけではシリアルの古い順の並び替え及び本体、加湿器、モジュールのグルーピングは実現不可
    // ソフトコム側のAPIの改修無しで実現する場合、PCP側で院内在庫注文時にテーブルに在庫情報を保持し、預託在庫からの処方時にテーブルを検索する
    // selectionStock: function(event,selectItem,kinds) {
    //   if (selectItem) {
    //     let findStock = this.escrowStockList.find(val => val.itemCode == selectItem)
    //     if (kinds == 'moist') {
    //       this.data.moistSerial = JSON.stringify(findStock.serial).replace(/[\"]/g,"");
    //     } else if (kinds == 'module') {
    //       this.data.moduleSerial = JSON.stringify(findStock.serial).replace(/[\"]/g,"");
    //     }
    //   }
    // },
    setDirectionsItemList: function() {
      //機種変更時
      let machineChangeFlag = false
      let oldItemCode, oldMoistItemCode, oldCircuitItemCode, oldReportFormatType
      if(this.data.comparisonDatas){
        oldItemCode = this.data.comparisonDatas.find(val => val.itemName == "model")
        oldMoistItemCode = this.data.comparisonDatas.find(val => val.itemName == "moistItemCode")
        oldCircuitItemCode = this.data.comparisonDatas.find(val => val.itemName == "circuitItemCode")
        oldReportFormatType = this.data.comparisonDatas.find(val => val.itemName == "reportFormatType")
      }
      let oldModuleItemCode = ""
      if(oldItemCode){
        if(this.data.model != oldItemCode.value){
          machineChangeFlag = true
        }
      }

      // QA521 持出オーダー、直送オーダーに連携する個数について、品目マスタの個数を連携する
      let moist=[]
      let module=[]
      let mask=[]
      // 通信モジュール有→有の場合false
      let moduleSimultaneousExchangeFlag =false;
      // 保存している場合はtrue
      let saveModuleSimultaneousExchangeFlag =false;
      if(this.data.changedItems && (this.data.changedItems.length > 0)){
        //加温加湿器
        moist = this.data.changedItems.find(val => val.areaName == "moistArea")
        //通信モジュール
        module = this.data.changedItems.find(val => val.areaName == "moduleArea")
        //マスク
        mask = this.data.changedItems.find(val => val.areaName == "maskArea")

        moduleSimultaneousExchangeFlag = module.simultaneousExchange

        saveModuleSimultaneousExchangeFlag = module.saveSimultaneousExchange
      }

      if(this.data.comparisonDatas && this.data.comparisonDatas.length >0){
        let moduleItem = this.data.comparisonDatas.find(val => val.itemName == "moduleItemCode")
        if(moduleItem){
          oldModuleItemCode = moduleItem.value
        }        
      }

      for(var directionsItem of this.directionsItemList){
        //指示書未選択のものは見積情報削除
        if(directionsItem.itemCode == ""){
          this.saveEstimateDetail.push({
            itemCode:directionsItem.itemCode,
            itemName:directionsItem.name,
            quotationDetailsNumber: directionsItem.quotationDetailsNumber,
            quantity: directionsItem.quantity,
            unit: directionsItem.unit,
            deliveryPrice: directionsItem.deliveryPrice,
            unitPrice: directionsItem.unitPrice,
            quotationPrice: directionsItem.quotationPrice,
            comment: directionsItem.comment,
            estimateCode: directionsItem.estimateCode,
            latestOrderRegisteredDate: directionsItem.latestOrderRegisteredDate,
            shippingInstructionsFlg: directionsItem.shippingInstructionsFlg? directionsItem.shippingInstructionsFlg:false,
            collectionInstructionsFlg: directionsItem.collectionInstructionsFlg? directionsItem.collectionInstructionsFlg:false
          })
          this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => {
            return directionsItem.name.indexOf(val.itemName)==-1
          })
          directionsItem.estimateCode= ""
          directionsItem.quotationDetailsNumber= ""
        }
        let target = this.cpapAccessories.find(val => val.itemCode == directionsItem.itemCode)
        let setItem = this.cpapSetItems.find(val => val.cpapItemCode == this.data.model)
        if (this.isEscrow && (this.data.kind == this.cpapKindMap.applicationChange)) {
          if(!saveModuleSimultaneousExchangeFlag && machineChangeFlag){// 保存済みかつ本体機種が変わってたらスキップ
            // 預託処方変更時、変更元の預託オーダーIDは削除
            directionsItem.depositUseOrderId = "";
            this.data.depositUseOrderId = "";
          }
        }
        if(this.data.kind != cpapKindMap.application){
        if(target){
          switch(target.type){
              case "cpap":
                if(!saveModuleSimultaneousExchangeFlag){
                  //保存済みの初期表示の場合スキップ
                  if(machineChangeFlag){
                    //新機器
                    if(directionsItem.itemCode == this.data.model){
                      directionsItem.shippingInstructionsFlg = true
                    }
                  }
                }
                break;
              case "moist":
                if(!saveModuleSimultaneousExchangeFlag){
                  //保存済みの初期表示の場合スキップ
                  if(moist.moistAdd){
                    //追加
                    directionsItem.shippingInstructionsFlg = true
                  }
                  if(moist.isChange){
                    //変更
                    if(setItem){
                      if(oldMoistItemCode){
                        if (setItem.moist) {
                          // Sboxは加湿器が2種あるため、考慮追加
                          if(directionsItem.itemCode == oldMoistItemCode){
                            if(this.data.moistItemCode && this.data.moistItemCode != oldMoistItemCode.value){
                              directionsItem.shippingInstructionsFlg = true
                            }
                          }
                        } else {
                          if(setItem.moistItemCode != oldMoistItemCode.value){
                            directionsItem.shippingInstructionsFlg = true
                          }
                        }
                      }
                    }

                  }
                }
                break;
              case "module":
                if(!saveModuleSimultaneousExchangeFlag){
                  if(module.modulAdd || module.modulChange){
                    //保存済みの初期表示の場合スキップ
                    //新モデム
                    if(directionsItem.itemCode == this.data.moduleItemCode){
                      directionsItem.shippingInstructionsFlg = true
                    }
                  }
                }
                if(this.data.kind == cpapKindMap.applicationChange &&
                  this.data.status == "1" &&
                  machineChangeFlag &&
                  moduleSimultaneousExchangeFlag){
                  //モデムの見積情報を削除
                  if(!saveModuleSimultaneousExchangeFlag){
                    //保存済みの初期表示の場合スキップ
                    this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val=>{ return val.itemCode !== oldModuleItemCode});
                    directionsItem.estimateCode= ""
                    directionsItem.quotationDetailsNumber= ""
                  }
                  this.saveEstimateDetail.push({
                    itemCode:directionsItem.itemCode,
                    itemName:directionsItem.name,
                    quotationDetailsNumber: directionsItem.quotationDetailsNumber,
                    quantity: directionsItem.quantity,
                    unit: directionsItem.unit,
                    deliveryPrice: directionsItem.deliveryPrice,
                    unitPrice: directionsItem.unitPrice,
                    quotationPrice: directionsItem.quotationPrice,
                    comment: directionsItem.comment,
                    estimateCode: directionsItem.estimateCode,
                    latestOrderRegisteredDate: directionsItem.latestOrderRegisteredDate,
                    shippingInstructionsFlg: directionsItem.shippingInstructionsFlg? directionsItem.shippingInstructionsFlg:false,
                    collectionInstructionsFlg: directionsItem.collectionInstructionsFlg? directionsItem.collectionInstructionsFlg:false
                  })
                }
                break;
              case "mask":
                if(!saveModuleSimultaneousExchangeFlag){
                  //保存済みの初期表示の場合スキップ
                  if(mask.isChange){
                    //新マスク
                    if(directionsItem.itemCode == this.data.maskItemCode){
                      directionsItem.shippingInstructionsFlg = true
                    }
                  }
                }
                break;
              case "circuit":
                if(!saveModuleSimultaneousExchangeFlag){
                  //保存済みの初期表示の場合スキップ
                  if(oldCircuitItemCode){
                    // 預託新規⇒処方変更の場合、
                    if(oldCircuitItemCode.value == ""){
                      var cuitItemCode = ""
                        if(oldItemCode){
                          if(this.data.comparisonPrescriptionItems && this.data.comparisonPrescriptionItems.length > 0){
                            var circuitItems = ""
                            if(oldReportFormatType && oldReportFormatType.value == "6"){
                              circuitItems = this.data.comparisonPrescriptionItems.find(val => val.displayName == "チューブタイプ")
                            }else if(oldReportFormatType && oldReportFormatType.value != "6"){
                              circuitItems = this.data.comparisonPrescriptionItems.find(val => val.displayName == "呼吸回路タイプ")
                            }
                            if(circuitItems != ""){
                              var oldSetItem = this.cpapSetItems.find(val => val.cpapItemCode == oldItemCode.value)
                              if(oldSetItem){
                                var olditems = oldSetItem.circuit[circuitItems.value]
                                if(setItem){
                                  cuitItemCode = olditems[0].itemCode
                                }
                              }
                            }
                          }
                          if(cuitItemCode != ""){
                            if(cuitItemCode != directionsItem.itemCode){
                              directionsItem.shippingInstructionsFlg = true
                            }
                          }
                      }
                    } else{
                      oldCircuitItemCode = oldCircuitItemCode.value.split('_')
                      if(oldCircuitItemCode[1] != directionsItem.itemCode){
                        directionsItem.shippingInstructionsFlg = true
                      }
                    }
                  }
                }
                break;
            }
          }
        }
      }
    },
    estimateDisabled: function(directionsItemCode, estimateCode, InstructionsType) {
      // 指示書未選択の場合、出荷指示、回収指示非活性
      if(!directionsItemCode){
        return true
      }
      //見積選択済の場合、出荷指示、回収指示非活性
      if(estimateCode){
        return true
      }
      let oldItemCode = this.data.comparisonDatas.find(val => val.itemName == "model")
      let oldModuleItemCode = this.data.comparisonDatas.find(val => val.itemName == "moduleItemCode")
      // QA324・389_転院再開・仮持出新規以外はディスコン品の出荷指示チェックを非活性化
      if (!this.resume && this.data.kind != cpapKindMap.applicationTempRemoval) {
        // QA324 DS Auto12mmディスコン
        // QA389_仮持出処方変更かつ前の処方機器がディスコン品の場合は出荷指示チェックを活性化する
        if (this.isTemp && this.data.kind == cpapKindMap.applicationChange) {
          if (oldItemCode && oldItemCode.value == 'RJPX501S16' && directionsItemCode == 'RJPX501S16' && InstructionsType == 'shipping') {
            return false
          }
        }
        if (directionsItemCode == 'RJPX501S16' && InstructionsType == 'shipping') {
          return true
        }
        // DS Proディスコン
        // QA389_仮持出処方変更かつ前の処方機器がディスコン品の場合は出荷指示チェックを活性化する
        if (this.isTemp && this.data.kind == cpapKindMap.applicationChange) {
          if (oldItemCode && oldItemCode.value == 'RJPX400S16' && directionsItemCode == 'RJPX400S16' && InstructionsType == 'shipping') {
            return false
          }
        }
        if (directionsItemCode == 'RJPX400S16' && InstructionsType == 'shipping') {
          return true
        }
        // エスボックスバイスタルクディスコン
        // QA389_仮持出処方変更かつ前の処方機器がディスコン品の場合は出荷指示チェックを活性化する
        if (this.isTemp && this.data.kind == cpapKindMap.applicationChange) {
          if (oldItemCode && oldItemCode.value == 'R1152708' && directionsItemCode == 'R1152708' && InstructionsType == 'shipping') {
            return false
          }
        }
        if (directionsItemCode == 'R1152708' && InstructionsType == 'shipping') {
          return true
        }
        // エスボックスバイスタルクディスコン
        // QA389_仮持出処方変更かつ前の処方機器がディスコン品の場合は出荷指示チェックを活性化する
        if (this.isTemp && this.data.kind == cpapKindMap.applicationChange) {
          if (oldItemCode && oldItemCode.value == 'R1151127' && directionsItemCode == 'R1151127' && InstructionsType == 'shipping') {
            return false
          }
        }
        if (directionsItemCode == 'R1151127' && InstructionsType == 'shipping') {
          return true
        }
        // プリズマラインディスコン
        // QA389_仮持出処方変更かつ前の処方機器がディスコン品の場合は出荷指示チェックを活性化する
        if (this.isTemp && this.data.kind == cpapKindMap.applicationChange) {
          if (oldItemCode && oldItemCode.value == 'R1151882' && directionsItemCode == 'R1151882' && InstructionsType == 'shipping') {
            return false
          }
        }
        if (directionsItemCode == 'R1151882' && InstructionsType == 'shipping') {
          return true
        }
        // 3Gモデムディスコン
        // QA389_仮持出処方変更かつ前の処方機器がディスコン品の場合は出荷指示チェックを活性化する
        if (this.isTemp && this.data.kind == cpapKindMap.applicationChange) {
          if (oldModuleItemCode && oldModuleItemCode.value == 'R100630C' && directionsItemCode == 'R100630C' && InstructionsType == 'shipping') {
            return false
          }
        }
        if (directionsItemCode == 'R100630C' && InstructionsType == 'shipping') {
          return true
        }
      }
      // 12mmホースディスコン
      if (directionsItemCode == '1137817' && InstructionsType == 'shipping') {
        return true
      }
      // 12mmﾁｭｰﾌﾞ用装置ｺﾈｸﾀディスコン
      if (directionsItemCode == '1138250' && InstructionsType == 'shipping') {
        return true
      }
      // マスク、回路の場合、指示チェックボックスは非活性(回収指示のみ)
      if(InstructionsType == "collection"){
        //処方変更以外の場合 回収指示非活性
        if(this.data.kind!=cpapKindMap.applicationChange){
          return true
        }
        let target = this.cpapAccessories.find(val => val.itemCode == directionsItemCode)
        if(target){
          switch(target.type){
            case "cpap":
            case "moist":
            case "module":
              return false
            case "mask":
            case "circuit":
            case "flame":
            case "headgear":
            case "maskCushion":
            case "maskHeadgear":
              return true
          }
        }
      }else{
        return false
      }
    },
    serialExchangeCheck: function() {
      let serialExchange = this.singleChangedCheck('hardwareArea','serial');
      let machineExchange = this.singleChangedCheck('hardwareArea','reportFormatType');
      let moistSerialExchange = this.singleChangedCheck('moistArea','moistSerial');
      let moduleSerialExchange = this.singleChangedCheck('moduleArea','moduleSerial');
      let moistMachineExchange;
      for (let content of this.data.prescriptionItems.filter(val=>{ return val.category===1})) {
        moistMachineExchange = this.singleChangedCheck('moistArea',content.displayName);
        if (moistMachineExchange == true) {
          break;
        }
      }
      let moduleMachineExchange;
      for (let content of this.data.prescriptionItems.filter(val=>{ return val.category===2})) {
        moduleMachineExchange = this.singleChangedCheck('moduleArea',content.displayName);
        if (moduleMachineExchange == true) {
          break;
        }
      }
      let oldMoist = this.data.oldEstimateDetailCode.find(val => val.itemCode == this.data.moistItemCode)
      if (oldMoist) {
        if (oldMoist.itemCode != this.data.moistItemCode) {
          moistMachineExchange = true;
        }
      }
      let oldModule = this.data.oldEstimateDetailCode.find(val => val.itemCode == this.data.moduleItemCode)
      if (oldModule) {
        if (oldModule.itemCode != this.data.moduleItemCode) {
          moduleMachineExchange = true;
        }
      }
      if (!machineExchange && serialExchange) {
        this.serialExchangeFlag = true;
      }
      if (!moistMachineExchange && moistSerialExchange) {
        this.serialExchangeFlag = true;
      }
      if (!moduleMachineExchange && moduleSerialExchange) {
        this.serialExchangeFlag = true;
      }
    },
    resumeExchangeCheck: function(directionsItemCode) {
      // 転院からの再開の場合
      if(this.isResume){
        // 転院前使用品目にないものはfalse
        let beforeItemCheck = this.data.beforeItems.find(val => val.itemCode == directionsItemCode)
        if(!beforeItemCheck){
          return false
        }
        let target = this.cpapAccessories.find(val => val.itemCode == directionsItemCode)
        if(target){
          // 転院前とシリアルが違う場合はfalse
          switch(target.type){
            case "cpap":
              if(this.data.transferSerial){
                if(this.data.transferSerial != this.data.serial) return false
              }
              break;
            case "moist":
              if(this.data.transferMoistSerial){
                if(this.data.transferMoistSerial != this.data.moistSerial) return false
              }
              break;
            case "module":
              if(this.data.transferModuleSerial){
                if(this.data.transferModuleSerial != this.data.moduleSerial) return false
              }
              break;
            case "mask":
            case "flame":
            case "headgear":
            case "maskCushion":
            case "maskHeadgear":
            case "circuit":
              return false
          }
        }
        return true
      }
      return false;
    },
    isPrevPrescriptionChanged: function(directionsItemCode) {
      // 前回の処方から機種が変更されているか
      let oldItemCode       = this.data.comparisonDatas.find(val => val.itemName == "model")
      let oldMoistItemCode  = this.data.comparisonDatas.find(val => val.itemName == "moistItemCode")
      let oldModuleItemCode = this.data.comparisonDatas.find(val => val.itemName == "moduleItemCode")

      let target;
      let accessory = this.cpapAccessories.find(val => val.itemCode == directionsItemCode)
      if(accessory){
        switch(accessory.type){
          case "cpap":
            if(oldItemCode && oldItemCode.value == directionsItemCode){
              if(this.data.changedItems && this.data.changedItems.length>0){
                target = this.data.changedItems.find(val => val.areaName == "hardwareArea")
                // 変更項目の有無を返却
                return target && target.isChange
              }
            }
            break;
          case "moist":
            if(oldMoistItemCode && oldMoistItemCode.value == directionsItemCode){
              if(this.data.changedItems && this.data.changedItems.length>0){
                target = this.data.changedItems.find(val => val.areaName == "moistArea")
                // 変更項目の有無を返却
                return target && target.isChange
              }
            }
            break;
          case "module":
            if(oldModuleItemCode && oldModuleItemCode.value == directionsItemCode){
              if(this.data.changedItems && this.data.changedItems.length>0){
                target = this.data.changedItems.find(val => val.areaName == "moduleArea")
                // 変更項目の有無を返却
                return target && target.isChange
              }
            }
            break;
        }
      }
      return true
    },
    isSerialChanged: function(directionsItemCode, directionsSerial) {
      // 前処方のシリアル
      let oldSerial = this.data.comparisonDatas.find(val => val.itemName == "serial")
      let oldMoistSerial = this.data.comparisonDatas.find(val => val.itemName == "moistSerial")
      let oldModuleSerial = this.data.comparisonDatas.find(val => val.itemName == "moduleSerial")

      let accessory = this.cpapAccessories.find(val => val.itemCode == directionsItemCode)
      if(accessory){
        switch(accessory.type){
          case "cpap":
            if(oldSerial && oldSerial.value != "" && oldSerial.value == directionsSerial){
              return false
            }
          case "moist":
            if(oldMoistSerial && oldMoistSerial.value != "" && oldMoistSerial.value == directionsSerial){
              return false
            }
          case "module":
            if(oldModuleSerial && oldModuleSerial.value != "" && oldModuleSerial.value == directionsSerial){
              return false
            }
        }
      }
      return true
    },
    getCpapChoicesList: async function() {
      this.departmentMaster = this.getCpapChoiceList(cpapChoicesType.departmentCode,false);
      this.orderProcessType = this.getCpapChoiceList(cpapChoicesType.orderProcessType,false);
      this.customerCategory = this.getCpapChoiceList(cpapChoicesType.customerCategory,false);
      this.billedCurrentMonth = this.getCpapChoiceList(cpapChoicesType.billedCurrentMonth,false);
      this.cancelCodeMaster = this.getCpapChoiceList(cpapChoicesType.cancellReason,false);
    },
    prescriptionItemsCheck: function(reportFormatType, mode, prescriptionItems) {
      switch (reportFormatType) {
        case 1: // ドリームステーションAuto
          // Flex設定、Flexタイプの相関チェック
          // Flex設定
          var flex = prescriptionItems.find(val => val.displayOrder == 9)
          // Flexタイプ
          var flexType
          if (mode == 1) { // Auto CPAPモード
            flexType = prescriptionItems.find(val => val.displayOrder == 8)
          } else if (mode == 4) { // CPAPモード
            flexType = prescriptionItems.find(val => val.displayOrder == 7)
          }
          // Flexタイプ:0、Flex設定:空の場合、Flex設定は非活性
          if (flexType.value == "0" && flex.value == "") {
            flex.disabled = true
          }

          // 加湿モード、回路温度設定の相関チェック
          // 加温加湿器
          var moist = this.data.prescriptionItems.find(val => val.displayOrder == 24)
          // 加湿モード
          var moistMode = this.data.prescriptionItems.find(val => val.displayOrder == 26)
          // 回路温度設定
          var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 28)
          // 加温加湿器:1、加湿モード:0または1、回路温度設定:空の場合、回路温度設定は非活性
          if (moist.value == "1" && (moistMode.value == "0" || moistMode.value=="1") && circuit.value == "") {
            circuit.disabled = true
          }
          // QA474_処方値関連残
          // フレックス設定からOFFを除去
          if (this.circulation || flex.value !== "0") {
            flex.displayValue = flex.displayValue.filter(v => v.key !== "0")
          }
          var language = prescriptionItems.find(val => val.displayOrder == 23)
          // 言語設定の選択肢から「その他」の選択肢を除去
          if (this.circulation || language.value !== "5") {
            language.displayValue = language.displayValue.filter(v => v.key !== "5")
          }
          break;

        case 2: // ドリームステーションPro
          // Flex設定,Flexタイプの相関チェック
          // Flex設定
          var flex = prescriptionItems.find(val => val.displayOrder == 5)
          // Flexタイプ
          var flexType = prescriptionItems.find(val => val.displayOrder == 4)
          // Flexタイプ:0、Flex設定:空の場合、Flex設定は非活性
          if (flexType.value == "0" && flex.value == "") {
            flex.disabled = true
          }

          // 加湿モード、回路温度設定の相関チェック
          // 加温加湿器
          var moist = this.data.prescriptionItems.find(val => val.displayOrder == 20)
          // 加湿モード
          var moistMode = this.data.prescriptionItems.find(val => val.displayOrder == 22)
          // 回路温度設定
          var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 24)
          // 加温加湿器:1、加湿モード:0または1、回路温度設定:空の場合、回路温度設定は非活性
          if (moist.value == "1" && (moistMode.value == "0" || moistMode.value=="1") && circuit.value == "") {
            circuit.disabled = true
          }
          break;

        case 3:
          // ドリームステーションGo
          // Flex設定,Flexタイプの相関チェック
          // Flex設定
          var flex = prescriptionItems.find(val => val.displayOrder == 9)
          // Flexタイプ
          var flexType
          if (mode == 1) { // Auto CPAPモード
            flexType = prescriptionItems.find(val => val.displayOrder == 8)
          } else if (mode == 4) { // CPAPモード
            flexType = prescriptionItems.find(val => val.displayOrder == 7)
          }
          // Flexタイプ:0、Flex設定:空の場合、Flex設定は非活性
          if (flexType.value == "0" && flex.value == "") {
            flex.disabled = true
          }
          // QA474_処方値関連残
          // フレックス設定からOFFを除去
          if (this.circulation || flex.value !== "0") {
            flex.displayValue = flex.displayValue.filter(v => v.key !== "0")
          }
          var language = prescriptionItems.find(val => val.displayOrder == 19)
          // 言語設定の選択肢から「その他」の選択肢を除去
          if (this.circulation || language.value !== "5") {
            language.displayValue = language.displayValue.filter(v => v.key !== "5")
          }
          break;

        case 4:
          // ドリームステーションBiPAP Auto
          // Flex設定,Flexタイプの相関チェック
          // Flex設定
          var flex = prescriptionItems.find(val => val.displayOrder == 13)
          // Flex設定ロック
          var flexLock = prescriptionItems.find(val => val.displayOrder == 14)
          // ライズタイム
          var riseTime = prescriptionItems.find(val => val.displayOrder == 15)
          // Flexタイプ
          var flexType
          if (mode == 1) { // Auto Bi-Levelモード
            // QA474_処方値関連残
            // Bipap（Auto Bi-Levelモード）IPAP＝EPAPのときPS最大圧、PS最小圧は0－0で非活性とする。
            var ipap = prescriptionItems.find(val => val.displayOrder == 5)
            var epap = prescriptionItems.find(val => val.displayOrder == 6)
            var pressureMax = prescriptionItems.find(val => val.displayOrder == 7)
            var pressureMin = prescriptionItems.find(val => val.displayOrder == 8)
            if ((Number(ipap.value) == Number(epap.value)) && (Number(pressureMax.value) == 0) && (Number(pressureMin.value) == 0)) {
              pressureMax.disabled = true
              pressureMin.disabled = true
            }
            flexType = prescriptionItems.find(val => val.displayOrder == 12)
            // QA474_処方値関連残
            // Bipap（Auto Bi-Levelモード）Flexタイプの選択肢はBi-Flex、0（オフ）のみとする。
            if (this.circulation || flexType.value !== "2") {
              flexType.displayValue = flexType.displayValue.filter(v => v.key !== "2")
              var flexType8 = prescriptionItems.find(val => val.displayOrder == 11)
              flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
            }
            // QA474_処方値関連残
            // Bipap（Auto Bi-Levelモード）Flexタイプがオフの場合、Flex設定ロックは非活性とする。
            if (flexType.value == "0" && !flexLock.value) {
              flexLock.disabled = true
            }
            flexLock.displayValue = [{"key":"","value":""},{"key":"0","value":"OFF"},{"key":"1","value":"ON"}]
            // QA474_処方値関連残
            // Bipap（Auto Bi-Levelモード）Flexタイプがオフのときはライズタイムの選択肢を「1～3」とする
            // if (this.circulation || (flexType.value == "0" && riseTime.value !== "0")) {
            //   riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
            //   if (riseTime.value == "0") {
            //     riseTime.value = ""
            //   }
            // }
            // QA474 仕様変更 20260410
            riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
          } else if (mode == 4) { // CPAPモード
            flexType = prescriptionItems.find(val => val.displayOrder == 10)
            var flexType1 = prescriptionItems.find(val => val.displayOrder == 12)
            flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
            var flexType8 = prescriptionItems.find(val => val.displayOrder == 11)
            flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
          } else if (mode == 8) { // Bi-Levelモード
            flexType = prescriptionItems.find(val => val.displayOrder == 11)
            // QA474_処方値関連残
            // Bipap（Bi-Levelモード）Flexタイプの選択肢はBi-Flex、0（オフ）のみとする。
            if (this.circulation || (flexType.value !== "2" && flexType.value !== "3")) {
              flexType.displayValue = flexType.displayValue.filter(v => v.key !== "2" && v.key !== "3")
            }
            if (this.circulation || flexType.value !== "2") {
              var flexType1 = prescriptionItems.find(val => val.displayOrder == 12)
              flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
            }
            // QA474_処方値関連残
            // Bipap（Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
            if (flexType.value == "0" && !flexLock.value) {
              flexLock.disabled = true
            }
            flexLock.displayValue = [{"key":"","value":""},{"key":"0","value":"OFF"},{"key":"1","value":"ON"}]
            // QA474_処方値関連残
            // Bipap（Bi-Levelモード）Flexタイプがオフのときはライズタイムの選択肢を「1～3」とする
            // if (this.circulation || (flexType.value == "0" && riseTime.value !== "0")) {
            //   riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
            //   if (riseTime.value == "0") {
            //     riseTime.value = ""
            //   }
            // }
            riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
          }
          // Flexタイプ:0、Flex設定:空の場合、Flex設定は非活性
          if (flexType.value == "0" && flex.value == "") {
            flex.disabled = true
          }

          // ライズタイム,Flexタイプの相関チェック
          // ライズタイム
          var riseTime = prescriptionItems.find(val => val.displayOrder == 15)
          // Auto Bi-Levelモード
          // Flexタイプ:Bi-Flex（1）またはC-Flex（2）、ライズタイム:空の場合、ライズタイムは非活性
          // Bi-Levelモード
          // Flexタイプ:Bi-Flex（1）またはC-Flex（2）またはC-Flex+（3）、ライズタイム:空の場合、ライズタイムは非活性
          if ((flexType.value == "1"  || flexType.value == "2" || flexType.value == "3") && riseTime.value == "") {
            riseTime.disabled = true
          }

          // ライズタイムロック,Flexタイプの相関チェック
          // ライズタイムロック
          var riseTimeLock = prescriptionItems.find(val => val.displayOrder == 16)
          // Auto Bi-Levelモード
          // Flexタイプ:Bi-Flex（1）またはC-Flex（2）、ライズタイムロック:空の場合、ライズタイムロックは非活性
          // Bi-Levelモード
          // Flexタイプ:Bi-Flex（1）またはC-Flex（2）またはC-Flex+（3）、ライズタイムロック:空の場合、ライズタイムロックは非活性
          if ((flexType.value == "1"  || flexType.value == "2" || flexType.value == "3") && riseTimeLock.value == "") {
            riseTimeLock.disabled = true
          }

          // 加湿モード、回路温度設定の相関チェック
          // 加温加湿器
          var moist = this.data.prescriptionItems.find(val => val.displayOrder == 30)
          // 加湿モード
          var moistMode = this.data.prescriptionItems.find(val => val.displayOrder == 32)
          // 回路温度設定
          var circuit = this.data.prescriptionItems.find(val => val.displayOrder == 34)
          // 加温加湿器:1、加湿モード:0または1、回路温度設定:空の場合、回路温度設定は非活性
          if (moist.value == "1" && (moistMode.value == "0" || moistMode.value=="1") && circuit.value == "") {
            circuit.disabled = true
          }
          // QA474_処方値関連残
          // フレックス設定からOFFを除去
          if (this.circulation || flex.value !== "0") {
            flex.displayValue = flex.displayValue.filter(v => v.key !== "0")
          }
          var language = prescriptionItems.find(val => val.displayOrder == 29)
          // 言語設定の選択肢から「その他」の選択肢を除去
          if (this.circulation || language.value !== "5") {
            language.displayValue = language.displayValue.filter(v => v.key !== "5")
          }
          break;

        case 5:
          // エスボックス バイスタルク
          // CC+、CC+機能有効時間　全治療時間、CC+機能有効時間　ランプのみの相関チェック
          // "CC+"
          var cc = this.data.prescriptionItems.find(val => val.displayOrder == 6)
          // "CC+機能有効時間　全治療時間"
          var ccAll = this.data.prescriptionItems.find(val => val.displayOrder == 7)
          // "CC+機能有効時間　ランプのみ"
          var ccLamp = this.data.prescriptionItems.find(val => val.displayOrder == 8)
          // CC+：OFF（0）、CC+機能有効時間　全治療時間：空白
          // CC+機能有効時間　全治療時間を非活性とする
          if (cc.value == "0" && ccAll.value == "") {
            ccAll.disabled = true
          }
          // CC+：OFF（0）、CC+機能有効時間　ランプのみ：空白
          // CC+機能有効時間　ランプのみを非活性とする
          if (cc.value == "0" && ccLamp.value == "") {
            ccLamp.disabled = true
          }
          // CC+：ON（1）、CC+機能有効時間　全治療時間：空白、CC+機能有効時間ランプのみ：値あり
          // CC+機能有効時間　全治療時間を非活性とする
          if (cc.value == "1" && ccAll.value == "" && ccLamp.value != "") {
            ccAll.disabled = true
          }
          // CC+：ON（1）、CC+機能有効時間　全治療時間：値あり、CC+機能有効時間ランプのみ：空白
          // CC+機能有効時間　ランプのみを非活性とする
          if (cc.value == "1" && ccAll.value != "" && ccLamp.value == "") {
            ccLamp.disabled = true
          }

          // ランプ機能、ランプタイム、ランプ時間【分】の相関チェック
          // "ランプ機能"
          var lamp = this.data.prescriptionItems.find(val => val.displayOrder == 9)
          // "ランプタイム"
          var lampTime = this.data.prescriptionItems.find(val => val.displayOrder == 10)
          // "ランプ時間【分】"
          var lampTimeMinutes = this.data.prescriptionItems.find(val => val.displayOrder == 11)
          // ランプ機能：０（オフ）、ランプタイム：空
          // ランプタイムを非活性とする
          if (lamp.value == "0" && lampTime.value == "") {
            lampTime.disabled = true
          }
          // ランプ機能：0（OFF）、ランプ時間【分】：空
          // ランプ時間【分】を非活性とする
          if (lamp.value == "0" && lampTimeMinutes.value == "") {
            lampTimeMinutes.disabled = true
          }
          // ランプ機能：ON（1）、ランプタイム：I.RAMP（1）、ランプ時間【分】：空
          // ランプ時間【分】を非活性とする
          if (lamp.value == "1" && lampTime.value == "1" && lampTimeMinutes.value == "") {
            lampTimeMinutes.disabled = true
          }
          // ランプ機能、、ランプ開始圧【hPa(cmH2O)】の相関チェック
          // ランプ機能：0（OFF）、ランプ開始圧【hPa(cmH2O)】：空
          // ランプ開始圧【hPa(cmH2O)】を非活性とする
          // "ランプ開始圧【hPa(cmH2O)】"
          var lampStart = this.data.prescriptionItems.find(val => val.displayOrder == 12)
          if (lamp.value == "0" && lampStart.value == "") {
            lampStart.disabled = true
          }
          break;
        case 6:
          // プリズマ ライン (prisma25S)
          break;
      }
    },
    changeDelivaryTarget: function(delivaryTarget) {
      // 支店回覧では申込み時の納品先情報を保持する
      if (this.circulation && this.initialDeliveryTarget == delivaryTarget && this.initialDeliveryOther && this.data.deliveryOther) {
        this.data.deliveryPostcode = this.initialDeliveryPostcode
        this.data.deliveryAddress = this.initialDeliveryAddress
        this.data.deliveryHouseNumber = this.initialDeliveryHouseNumber
        this.data.deliveryBuilding = this.initialDeliveryBuilding
        this.data.deliveryDestination = this.initialDeliveryDestination
        this.data.deliveryPhoneNumber = this.initialDeliveryPhoneNumber
      } else {
        if (delivaryTarget == 'home') {
          this.data.deliveryPostcode = this.data.patient.zip
          this.data.deliveryAddress = this.data.patient.address
          this.data.deliveryHouseNumber = this.data.patient.address1
          this.data.deliveryBuilding = this.data.patient.address2
          this.data.deliveryDestination = this.data.patient.patientFamilyName + " " + this.data.patient.patientFirstName
          if (this.data.patient.mobilePhone) {
            this.data.deliveryPhoneNumber = this.data.patient.mobilePhone
          } else {
            this.data.deliveryPhoneNumber = this.data.patient.phoneNumber
          }
        } else {
          this.data.deliveryPostcode = this.data.zip
          this.data.deliveryAddress = this.data.address
          this.data.deliveryHouseNumber = this.data.address1
          this.data.deliveryBuilding = this.data.address2
          this.data.deliveryDestination = this.data.receiverName
          this.data.deliveryPhoneNumber = this.data.phoneNumber
        }
      }
      this.isChangeDelivaryTarget = true;
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    },
    onPaste() {
      this.isChangeDelivaryTarget = false;
    },
    /**
     * QA521 持出オーダー、直送オーダーに連携する個数について、品目マスタの個数を連携する
     */
    deleteEstimateDetailCode() {
      this.data.estimateDetailCode = this.data.estimateDetailCode.filter(detail =>
        this.cpapAccessories.some(accessory =>accessory.itemCode === detail.itemCode)
      );
    }
  },
  data() {
    var modelList = this.getCpapMaster();
    var cpapCodeMaster = this.getCpapCodeMaster();
    var cpapAccessories = this.getCpapAccessoryList();
    var cpapSetItems = this.getCpapSetItemList();
    var moduleList = ""
    var branchOfficeMaster= this.getSalesOfficeMaster();
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var officeCode = userInfo.salesOfficeCode
    var initEstimateDetailCode = this.data.estimateDetailCode
    var formatType = ""
    // 処方再開(転院)判定
    var isResume = false;
    if(this.resume){
      isResume = this.resume;
      initEstimateDetailCode = this.data.beforeItems
    }
    //　コメント判定
    var isComment = true;
    if(!this.comment){
      isComment = this.comment;
    }
    if(this.data){
      var model = modelList.find(item => item.itemCode == this.data.model)
      if(model){
        formatType = model.reportFormatType
      }
      // QA324 ディスコン対応
      var setItem = cpapSetItems.find(val => val.cpapItemCode == this.data.model)
      if (this.data.kind != cpapKindMap.applicationTempRemoval || this.changeValue) {
        // 中止前にディスコン品目を処方していた場合、再開支店回覧ではディスコン品目を選択不可とする
        if (this.data.cancelResume) {
          modelList = modelList.filter(val=>{ return val.reportFormatType === 1 || val.reportFormatType === 3 || val.reportFormatType === 4 || val.reportFormatType === formatType})
        } else {
          modelList = modelList.filter(val=>{ return val.reportFormatType === 1 || val.reportFormatType === 3 || val.reportFormatType === 4 || val.reportFormatType === formatType || val.reportFormatType === this.data.changeBeforeReportFormatType})
        }
        // QA164 Go以外のときのみmoduleListを設定する
        if(setItem && setItem.module && this.data.reportFormatType != 3){
          if (this.data.moduleItemCode === "R100630C") {
            moduleList = setItem.module
          } else {
            moduleList = setItem.module.filter(val=>{ return val.itemCode === "R100631C"})
          }
        }
      } else {
        // QA389 仮持出新規はディスコン品も使用可能とする
        if(setItem && setItem.module && this.data.reportFormatType != 3){
            moduleList = setItem.module
        }
      }
      // DS Auto、DS Pro、DS BiPAPの場合
      if (this.data.reportFormatType == 1 || this.data.reportFormatType == 2 || this.data.reportFormatType == 4) {
        // モデム機種をデフォルトで4Gとする
        if (!this.data.moduleItemCode && this.data.useModule) {
          this.data.moduleItemCode = "R100631C"
        }
      }
      // QA164 Go,sbox,prisma使用の場合モデムの品目コード、シリアルをクリアする
      const validReportFormatType = [3, 5, 6]; // Go,sbox,prisma
      if (validReportFormatType.includes(this.data.reportFormatType)) {
        this.data.moduleItemCode = "";
        this.data.moduleSerial = "";
      }

      // DS Auto、DS Go、DS BiPAPの場合
      if (this.data.reportFormatType == 1 || this.data.reportFormatType == 3 || this.data.reportFormatType == 4) {
        // 呼吸回路タイプ12mmを選択不可とする
        var kokty = this.data.prescriptionItems.find(val => val.itemName === "KOKTY")
        if (kokty.value !== "12") {
          kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
          if (this.data.reportFormatType == 3 && !kokty.value) {
            kokty.value = "15"
          }
        } else {
          kokty.displayValue = kokty.displayValue.filter(v => v.key !== "")
        }
        // 患者情報管理 「アンコールエニウェア」と空白を選択不可とする
        var kjk = this.data.prescriptionItems.find(val => val.displayName === "患者情報管理")
        if (kjk.value !== "2") {
          kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
          if (this.data.reportFormatType == 3 && !kjk.value) {
            kjk.value = "1"
          }
        } else {
          kjk.displayValue = kjk.displayValue.filter(v => v.key !== "")
        }
        const order = ["1", "0", "2"]
        kjk.displayValue.sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key))
        // 登録方法 「登録しない」と空白を選択不可とする
        var trh = this.data.prescriptionItems.find(val => val.displayName === "登録方法")
        if (trh.value !== "0") {
          trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
        } else {
          trh.displayValue = trh.displayValue.filter(v => v.key !== "")
        }
      }
    }
    if(!this.data.shippingDate){
      this.data.shippingDate = this.yyyy_hyp_MM_hyp_dd(new Date())
    }
    // QA316 納品先情報は引き継がない
    if (this.changeValue && this.data.delivaryTarget== 'home') {
      this.data.deliveryPostcode = this.data.patient.zip
      this.data.deliveryAddress = this.data.patient.address
      this.data.deliveryHouseNumber = this.data.patient.address1
      this.data.deliveryBuilding = this.data.patient.address2
      this.data.deliveryDestination = this.data.patient.patientFamilyName + " " + this.data.patient.patientFirstName
      if (this.data.patient.mobilePhone) {
        this.data.deliveryPhoneNumber = this.data.patient.mobilePhone
      } else {
        this.data.deliveryPhoneNumber = this.data.patient.phoneNumber
      }
      this.data.deliveryOther = false
    } else if (this.changeValue && this.data.delivaryTarget== 'hospital') {
      this.data.deliveryPostcode = this.data.zip
      this.data.deliveryAddress = this.data.address
      this.data.deliveryHouseNumber = this.data.address1
      this.data.deliveryBuilding = this.data.address2
      this.data.deliveryDestination = this.data.receiverName
      this.data.deliveryPhoneNumber = this.data.phoneNumber
      this.data.deliveryOther = false
    }
    // 支店回覧では申込み時の納品先情報を保持する
    if (this.circulation && this.data.deliveryOther) {
      this.initialDeliveryPostcode = this.data.deliveryPostcode
      this.initialDeliveryAddress = this.data.deliveryAddress
      this.initialDeliveryHouseNumber = this.data.deliveryHouseNumber
      this.initialDeliveryBuilding = this.data.deliveryBuilding
      this.initialDeliveryDestination = this.data.deliveryDestination
      this.initialDeliveryPhoneNumber = this.data.deliveryPhoneNumber
      this.initialDeliveryOther = this.data.deliveryOther
      this.initialDeliveryTarget = this.data.delivaryTarget
    }
    const isEscrow = this.$route.params["isEscrow"] ? this.$route.params["isEscrow"]:this.data.depositUseFlag;
    const medicalInstitutionCode = userInfo.medicalInstitutionCode;
    let escrowStockList = [];
    let stockItemNameList = [];
    let stockItemCodeList = [];
    let stockItemSeialList = [];
    if(isEscrow){
      // 預託の場合、初期値設定
      if(!(this.data.depositCancelReasonCode && this.data.depositCancelReasonCode.length > 0)) this.data.depositCancelReasonCode = "JX"// その他
      if(!(this.data.depositBillingCurrentMonth && this.data.depositBillingCurrentMonth.length > 0)) this.data.depositBillingCurrentMonth = "002"// レンタル請求なし
    }
    // QA457_処方変更で返却情報欄を引き継がない
    // 保存済であればスキップ
    if (!this.data.savedFlag) {
      this.data.collectionDestination = ""
      this.data.billingCurrentMonth = ""
      this.data.cancelReasonCode = ""
      this.data.cancelReasonText = ""
    }

    // QA438_「指示書申請中」と「指示書支店回覧中」に患者の基本情報が編集できてしまう
    let patientDataDisabled = false
    // 支店回覧画面の場合
    if (this.circulation) {
      // 通常・預託新規、仮持出新規の場合
      if (this.data.kind == cpapKindMap.application || this.data.kind == cpapKindMap.applicationTempRemoval) {
        //患者コードマスタDL後は編集不可
        if (this.data.patientCodeStatus != cpapPatientRegisterStatus.unrequested) {
          patientDataDisabled = true
        }
      // 転院再開、中止再開の場合
      } else if (this.data.kind == cpapKindMap.applicationResume) {
        if (this.data.patientCodeStatus != cpapPatientRegisterStatus.updateWait) {
          patientDataDisabled = true
        }
      }
    }

    // QA474_処方値関連残
    let bipapvaliFlag = true
    if (!this.data.existingFlag) {
      this.prescriptionItemsCheck(this.data.reportFormatType, this.data.mode, this.data.prescriptionItems)
      if (!this.circulation) {
        if (this.data.reportFormatType == 4) {
          // DS BiPAP AutoにおいてminEPAPとmaxIPAPの差分とPSの設定範囲の関係性が考慮できていない
          var mode = this.data.prescriptionItems.find(val => val.displayOrder == 1)
          var epapMin = this.data.prescriptionItems.find(val => val.displayOrder == 6)
          var ipapMax = this.data.prescriptionItems.find(val => val.displayOrder == 5)
          var psMax = this.data.prescriptionItems.find(val => val.displayOrder == 7)
          if (mode.value == 1) { // Auto Bi-Levelモード
            if (Number(ipapMax.value) - Number(epapMin.value) < Number(psMax.value)) {
              // "IPAP最大圧【hPa(cmH2O)"-"EPAP最小圧【hPa(cmH2O)】" >= "PS最大圧【hPa(cmH2O)】" で無い時
              bipapvaliFlag = false
            }
          }
        }
      }
    }
    return {
      modelList,
      quotationModalActive: false,
      bulkQuotationModalActive: false,
      itemQuotationModalActive: false,
      patientModalActive: false,
      cpapPatientRegisterStatus:cpapPatientRegisterStatus,
      cpapShippingMethodList:cpapShippingMethodList,
      cpapSenderMaster:cpapSenderMaster,
      cpapCodeMaster,
      departmentMaster:[],
      orderProcessType:[],
      rentalType:[],
      customerCategory:[],
      strategicMeasures:[],
      reserve:[],
      deliveryTimeZone:[],
      searchTargetPostCode:"",
      searchTargetAddress:null,
      maskSelectModalActive:false,
      formatType,
      cpapKindMap:cpapKindMap,
      cpapRequestStatus:cpapRequestStatus,
      cpapAccessories,
      cpapSetItems,
      isChangeValue:this.changeValue,
      cpapStockModalActive:false,
      cpapDirectShippingList:cpapDirectShippingList,
      cpapLeaseUpList:cpapLeaseUpList,
      isTemp:this.temp,
      tempDeviceSelectModalActive:false,
      escrowDeviceSelectModalActive:false, // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
      targetType:"",
      searchModel:"",
      searchItemCode:"",
      searchSerial:"",
      branchOfficeMaster,
      officeCode,
      depositoryCodeMaster:[],
      billedCurrentMonth:[],
      cancelCodeMaster:[],
      webHtApiErr:false,
      directionsItemList:[],
      cpapOrderSelectModalActive:false,
      renderKey:true,
      isResume,
      moduleList,
      searchDepositUseOrderId:"",
      searchOrderItemCode:"",
      searchOrderSerialNumber:"",
      // changeBeforeUseMoist:true,
      // beforeMoistDate:""
      changeBeforeUseModule:true,
      beforeModuleDate:"",
      quotationItemCode:"",
      quotationItemName:"",
      modelChangeFlg:false,
      invalidPatientPostcode: false,
      invalidPatientMobilePhone: false,
      invalidPatientPhoneNumber: false,
      invalidPostcode: false,
      invalidPhoneNumber: false,
      isComment,
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      saveOldEstimateDetailCode:this.data.oldEstimateDetailCode ? this.data.oldEstimateDetailCode : [], // 旧見積情報（oldEstimateDetailCode）を保存
      saveEstimateDetail:[],// 指示書未選択の情報を格納
      isComment,
      isEscrow,
      medicalInstitutionCode,
      escrowStockList,
      stockItemNameList,
      stockItemCodeList,
      stockItemSeialList,
      prescriptionHardwareList,
      kinds:"",
      serialExchangeFlag:false,
      onlyCollectionFlag:false,
      tempDeviceSelectFlag: false,
      existingFlag:this.data.existingFlag,
      isCirculation:this.circulation,
      ApplicationPrescriptionItems:[],
      ApplicationReportFormatType:"",
      initEstimateDetailCode:initEstimateDetailCode,
      patientDataDisabled,
      wkPrevReportFormatType:"",
      bipapvaliFlag,
      digitErrorZipMessage,
      digitErrorPostcode:false,
      digitErrorDeliveryPostcode:false,
      isInitial:true,
      isChangeDelivaryTarget:false,
    };
  },
  components: {
    quotationSelectModal:QuotationSelectModal,
    quotationBulkSelectModal:QuotationBulkSelectModal,
    cpapOrderSelectModal:CpapOrderSelectModal,
    patientSelectModal:PatientSelectModal,
    cpapMaskSelectModal:CpapMaskSelectModal,
    cpapStockModal:CpapStockModal,
    instrumentSelectModal:InstrumentSelectModal,
    EscrowInstrumentSelectModal, // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
  },
  filters: {
    codeToValueFilter: function(val, list){
      var target = list.find(item => item.code == val)
      if(target){
        return target.name
      }
      return ""
    }
  },
  mounted: async function() {
    // CPAP選択肢リスト取得
    await this.getCpapChoicesList();
   // 支店回覧時のみ実施
    if(this.isCirculation) {
      await this.getDepositoryCodeMaster()
      if(this.webHtApiErr) return
    }

    // QA337_支店回覧で得意先区分をデフォルトで在宅にする
    // 転院元の得意先区分は引き継がない
    if (!this.data.customerClass || this.resume) {
      const targetClass = this.customerCategory.find(val => val.label == "在宅")
      this.data.customerClass = targetClass.value;
    }
    // QA335_ドリームステーションのランプ設定の誤りを修正
    // 初期表示にてランプスタート圧を活性化
    var lampStart = this.data.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】")
    if (lampStart) {
      lampStart.disabled = false
    };

    // モデム同時交換チェック
    this.moduleSimultaneousExchange()

    this.getDirectionsItemList()

    this.setDirectionsItemList()

    // QA521 持出オーダー、直送オーダーに連携する個数について、品目マスタの個数を連携する
    // マスタ情報と不整合の見積情報を削除
    this.deleteEstimateDetailCode()

    // 預託処方変更の場合、預託機使用フラグオン
    if (this.isEscrow) {
      this.data.depositUseFlag = true;
    };


    // QA308 支店回覧で相関チェックを行う
    // QA474 処方値関連残　dataメソッドへ移動
    // if (!this.data.existingFlag) {
    //   this.prescriptionItemsCheck(this.data.reportFormatType, this.data.mode, this.data.prescriptionItems)
    // }

    // シリアル交換を判断　預託処方変更2023.12.11
    this.serialExchangeCheck();

    this.invalidPatientPostcode = isNaN(Number(this.data.patient.zip));
    this.invalidPatientMobilePhone = isNaN(Number(this.data.patient.mobilePhone));
    this.invalidPatientPhoneNumber = isNaN(Number(this.data.patient.phoneNumber));
    this.invalidPostcode = isNaN(Number(this.data.zip));
    this.invalidPhoneNumber = isNaN(Number(this.data.phoneNumber));
    this.ApplicationPrescriptionItems = this.data.prescriptionItems;
    this.ApplicationReportFormatType = this.data.reportFormatType;
  },
  created: function() {
    this.$validator.extend("validationCheck", {
      getMessage: field => `${field}の入力内容に誤りがあります。`, // QA427_エラーメッセージに項目名を追加
      validate: (value, indexArray) => {
        var ret = false;
        var value = indexArray[0];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";

        if (value.indexOf("'") != -1) {
          // シングルコーテーションはサーバ側でSQLエラーとなる為、ここではじく
          return false;
        }

        for (var i = 1; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // QA403_小数点以下が入力されていると赤文字のエラーとなってしまう
        // 「0.5」刻みのルールを持つ場合、「.0」を許容
        if (validationRule.indexOf(".[05]") != -1) {
          value = value.replace(/\.0$/, "");
        }
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      }
    });
  },
  watch: {
    "data.patient.zip" (newValue) {
      this.invalidPatientPostcode = isNaN(Number(newValue));
      if (!this.data.deliveryOther && this.data.delivaryTarget == 'home') {
        this.data.deliveryPostcode = newValue
      }
      // QA476 郵便番号自動検索処理
      if (!this.invalidPatientPostcode && newValue.length === 7) {
        this.patientAddressSearch(newValue);
      }
    },
    "data.patient.address" (newValue) {
      if (!this.data.deliveryOther && this.data.delivaryTarget == 'home') {
        this.data.deliveryAddress = newValue
      }
    },
    "data.patient.address1" (newValue) {
      if (!this.data.deliveryOther && this.data.delivaryTarget == 'home') {
        this.data.deliveryHouseNumber = newValue
      }
    },
    "data.patient.address2" (newValue) {
      if (!this.data.deliveryOther && this.data.delivaryTarget == 'home') {
        this.data.deliveryBuilding = newValue
      }
    },
    "data.patient.patientFamilyName" (newValue) {
      if (!this.data.deliveryOther && this.data.delivaryTarget == 'home') {
        this.data.deliveryDestination = newValue + " " + this.data.patient.patientFirstName
      }
    },
    "data.patient.patientFirstName" (newValue) {
      if (!this.data.deliveryOther && this.data.delivaryTarget == 'home') {
        this.data.deliveryDestination = this.data.patient.patientFamilyName + " " + newValue
      }
    },
    "data.patient.mobilePhone" (newValue) {
      this.invalidPatientMobilePhone = isNaN(Number(newValue));
      if (!this.data.deliveryOther && this.data.delivaryTarget == 'home' && newValue) {
        this.data.deliveryPhoneNumber = newValue
      } else if (!this.data.deliveryOther && this.data.delivaryTarget == 'home' && !newValue) {
        this.data.deliveryPhoneNumber = this.data.patient.phoneNumber
      }
    },
    "data.patient.phoneNumber" (newValue) {
      this.invalidPatientPhoneNumber = isNaN(Number(newValue));
      if (!this.data.deliveryOther && this.data.delivaryTarget == 'home' && !this.data.patient.mobilePhone) {
        this.data.deliveryPhoneNumber = newValue
      }
    },
    "data.deliveryPostcode" (newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      // 納品先が変更されたタイミングは郵便番号検索しない
      if (this.isChangeDelivaryTarget) {
        this.isChangeDelivaryTarget = false;
        return
      }
      if (!this.invalidPostcode && newValue.length === 7) {
        this.addressSearch(newValue);
      }
    },
    "data.deliveryPhoneNumber" (newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
  },
};
</script>
<style lang="scss" scoped>
#item-contens table tr{
  height: 35px;
}
#item-contens table select{
  height: 30px;
}
#prescriptionTable th{
  width:280px;
}
#editMark{
  width:50px;
  vertical-align: middle;
}
.clearBtn {
  margin-left: 5px;
  height: 27px !important;
  width: 27px !important;
}
.change::after {
  position: static;
}
.emphasis {
  background-color: aquamarine;
}
.notice {
  font-size:18px;
  text-align:left;
  color: rgb(62, 125, 197);
  font-weight: bold;
  margin: 10px 50px 20px 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/CpapRequestDetailEdit.vue